// ══════════════════════════════════════════════════════════
//  YAPILANDIRMA
// ══════════════════════════════════════════════════════════
const SS_CONFIG = {
  // Anahtar artık burada YOK — Cloudflare'deki ara sunucuda gizli duruyor.
  WORKER_URL: 'https://suspendsupport-proxy.orcunnuyar.workers.dev',
  PHONE: '905541716182',
  PHONE_DISPLAY: '0 (554) 171 61 82',
  MAX_FREE_MSGS: 11,  // v13: 12. mesajda handoff devreye giriyor
  HANDOFF_AT: 12,     // v13: Orçun Bey'e devir eşiği
  HANDOFF_WARN_AT: 10, // v13: 10. mesajda "birkaç soru daha" uyarısı
  EARLY_HANDOFF_AT: 6, // v15: Pazar + suspend türü biliniyorsa 6. mesajda erken devir önerisi
  // Telegram (bunu birazdan ayrıca güvenli hale getireceğiz):
  TELEGRAM_BOT_TOKEN: 'via-worker',
  TELEGRAM_CHAT_ID: '1668388079',
  // Shopify Storefront API (opsiyonel):
  // SHOPIFY_TOKEN: 'YOUR_STOREFRONT_TOKEN',
  // SHOPIFY_DOMAIN: 'suspendsupport.com.tr',
};

// ══════════════════════════════════════════════════════════
//  AVATAR (base64 inline SVG — sanal kişi)
// ══════════════════════════════════════════════════════════
const SS_AVATAR_SRC = document.querySelector('#ss-avatar img')?.src || '';

// ══════════════════════════════════════════════════════════
//  HİZMET VERİTABANI — v14: fiyatlar artık linkte, burada sadece isim+URL
//  Not: Fiyat değişirse bu kodu güncellemeye gerek kalmaz. Müşteri güncel
//  fiyatı her zaman sitede görür.
// ══════════════════════════════════════════════════════════
const SERVICES = {
  "3_asin":         { name: "3 ASIN Suspendi (Inauthentic Item)",      url: "https://suspendsupport.com.tr/products/3-asin-inauthentic-item-issue" },
  "acilis":         { name: "Açılış Suspendi (Seller ID Verification)", url: "https://suspendsupport.com.tr/products/acilis-suspendi-seller-id-verification" },
  "dropshipping":   { name: "Drop Shipping Politika İhlali",           url: "https://suspendsupport.com.tr/products/drop-shipping-politika-i%CC%87hlali-drop-shipping-policy-violation" },
  "fikri":          { name: "Fikri Mülkiyet Suspendi",                 url: "https://suspendsupport.com.tr/products/fikri-mulkiyet-intellectual-property-violations" },
  "hizli":          { name: "Hızlı Satış Suspendi (Velocity)",         url: "https://suspendsupport.com.tr/products/hizli-satis-suspendi-velocity-suspend" },
  "odr":            { name: "Sipariş Kusur Oranı (ODR) Suspendi",      url: "https://suspendsupport.com.tr/products/siparis-kusur-orani-order-defect-rate" },
  "gec":            { name: "Geç Gönderim Suspendi",                   url: "https://suspendsupport.com.tr/products/gec-gonderim-sorunlari-late-shipment-issues" },
  "iptal":          { name: "Sipariş İptal Oranı Suspendi",            url: "https://suspendsupport.com.tr/products/siparis-i%CC%87ptal-orani-order-cancelation-rate" },
  "yasakli":        { name: "Yasaklı/Kısıtlı Ürünler Suspendi",        url: "https://suspendsupport.com.tr/products/yasaklikisitli-urunler-restricted-products" },
  "iliskilendirme": { name: "İlişkilendirme Suspendi (Related Accounts)", url: "https://suspendsupport.com.tr/products/i%CC%87liskilendirme-suspendi-related-accounts" },
  "kapali":         { name: "Kapalı Kategori Açılışı",                 url: "https://suspendsupport.com.tr/products/kapali-kategori-acilisi-banned-category-activation" },
  "tek_appeal":     { name: "Tek Appeal Hizmeti",                      url: "https://suspendsupport.com.tr/products/tek-appeal-hizmeti" },
  "kuzey":          { name: "Kuzey Amerika Hesap Açılışı",             url: "https://suspendsupport.com.tr/products/kuzey-amerika-hesap-acilisi-north-american-account-registration" },
  "avrupa":         { name: "Avrupa Hesap Açılışı",                    url: "https://suspendsupport.com.tr/products/avrupa-hesap-acilisi-european-account-activation" },
  "gorusme":        { name: "Orçun UYAR ile Birebir Görüşme",          url: "https://suspendsupport.com.tr/products/orcun-uyar-ile-birebir-gorusme" },
  "arama":          { name: "Arama Hizmeti (Call Service)",            url: "https://suspendsupport.com.tr/products/arama-hizmeti-call-service" },
  "saglik":         { name: "Hesap Sağlığı İnceleme",                  url: "https://suspendsupport.com.tr/products/hesap-sagligi-i%CC%87nceleme" },
  "fon":            { name: "Fon Kurtarma Hizmeti",                    url: "https://suspendsupport.com.tr/products/fon-kurtarma-hizmeti" },
};

// ══════════════════════════════════════════════════════════
//  EZBERE BİLGİ TABANI — 100 Soru
// ══════════════════════════════════════════════════════════
const KB = [
  // ── KAT 1: GENEL BİLGİ ──
  { keys: ["suspendsupport nedir","ne iş yapar","siz kimsiniz","bu şirket ne","suspend destek","hizmetiniz nedir"],
    answer: "SuspendSupport, 2019'dan bu yana Amazon satıcılarının hesaplarının askıya alınması (suspend) sorunlarına profesyonel çözüm sunan bir danışmanlık firmasıdır. Amazon'un karmaşık politikaları ve suspend süreçleri konusunda uzmanlaşmış ekibimizle, satıcıların hesaplarını en hızlı şekilde yeniden aktif hale getirmeyi hedefliyoruz." },
  { keys: ["kim kurdu","kurucu kim","ne zaman kuruldu","sahibi kim","kuruluş"],
    answer: "Firmamız 2019 yılında Ankara'da Orçun Uyar tarafından kuruldu. Orçun Bey, e-ticaret ekosistemindeki deneyimini Amazon suspend süreçlerine odaklanarak bu alanda Türkiye'nin önde gelen uzmanlarından biri haline geldi." },
  { keys: ["hangi platform","sadece amazon","başka platform","etsy","ebay"],
    answer: "Ana uzmanlık alanımız Amazon'dur. Amazon'un global pazarlarında (ABD, Avrupa, Japonya vb.) yaşanan suspend sorunlarına çözüm üretiyoruz. Suspend çözümünde tamamen Amazon odaklı çalışıyoruz." },
  { keys: ["ofis nerede","ofis adresi","ofise gel","yüz yüze görüşme","fiziksel görüşme","ofiste buluş"],
    answer: "Merkez ofisimiz Ankara'dadır. Tamamen online hizmet veriyoruz — Türkiye'nin her şehrinden ve yurt dışından müşterilerimiz var. Suspend süreci tamamen dijital belgeler ve yazışmalar üzerinden yürüdüğü için fiziksel görüşme şart değildir." },
  { keys: ["online hizmet","uzaktan","istanbul","yerel","fiziksel görüşme şart"],
    answer: "Tamamen online hizmet veriyoruz. Türkiye'nin her şehrinden ve yurt dışından müşterilerimiz var. E-posta, telefon ve video konferans üzerinden kesintisiz destek sağlıyoruz." },
  { keys: ["kaç yıl","tecrübe","deneyim","ne zamandır","kaç sene"],
    answer: "2019'dan bu yana, yani 7 yıldır bu alandayız. Bu sürede binlerce farklı senaryo gördük ve Amazon'un sürekli değişen politikalarına ayak uydurduk." },
  { keys: ["kaç satıcı","kaç müşteri","kaç kişi","kaç dosya","müşteri sayı"],
    answer: "Yaklaşık 2.000'in üzerinde satıcıya doğrudan hizmet verdik. Ayrıca danışmanlık, eğitim ve içeriklerimizle dolaylı olarak 10.000'den fazla satıcıya ulaştık." },
  { keys: ["başarı oran","kaçta kaç","yüzde kaç","başarı yüzde"],
    answer: "Başarı oranımız %85'tir. Orçun Bey bu konuda çok nettir: Bu oran, doğru yönlendirme ve profesyonel çalışma sonucu elde edilir. Her suspend çözülebilir değildir, biz gerçekçi olmayı vaat ediyoruz." },
  { keys: ["neden sizi","farkınız","diğerlerinden fark","avantaj","neden tercih"],
    answer: "Orçun Bey'in liderliğindeki kişisel yaklaşımımız, şeffaf iletişimimiz ve derin uzmanlığımız farkımızı oluşturur. Garanti satanlardan değiliz. Dosyanızı inceler, gerçekçi değerlendirme yapar, şansınız varsa çalışırız. Yoksa paranızı boşa harcamamanız için reddederiz." },
  { keys: ["resmi şirket","vergi numarası","vergi levha","kayıtlı","fatura"],
    answer: "Evet, tamamen resmi bir şirketiz. Vergi levhamız, ticaret sicil kaydımız ve tüm yasal yükümlülüklerimiz mevcuttur. Faturalı hizmet veriyoruz." },
  { keys: ["etbis","e-ticaret kayd"],
    answer: "Evet, Elektronik Ticaret Bilgi Sistemi (ETBIS) kaydımız bulunmaktadır. Tüm yasal gereklilikleri eksiksiz yerine getiriyoruz." },
  { keys: ["iletişim","telefon","mail","nasıl ulaş","whatsapp","e-posta"],
    answer: `Bize şu kanallardan ulaşabilirsiniz:\n📞 Telefon: ${SS_CONFIG.PHONE_DISPLAY}\n💬 WhatsApp: https://wa.me/${SS_CONFIG.PHONE}\n📧 E-posta: info@suspendsupport.com.tr\n🌐 Web: www.suspendsupport.com.tr` },
  { keys: ["çalışma saat","kaçta açık","mesai","kaçta kapan","ne zaman ulaş"],
    answer: "Hafta içi 09:00-18:00 arası aktif çalışıyoruz. Ancak suspend durumları acil olabilir, bu nedenle mesai saatleri dışında da iletişim kanallarımız açıktır." },
  { keys: ["hafta sonu","cumartesi","pazar günü","7/24","acil durum","tatil günü"],
    answer: "Evet, suspend durumları acil müdahale gerektirebilir. Hafta sonu ve resmi tatillerde de iletişim kurabilirsiniz. Orçun Bey, \"Amazon'un tatili yok, bizim de olamaz\" der." },

  // ── EMPATİK KARŞILAMA — Suspend yaşayan müşteriler ──
  { keys: ["hesabım suspend","suspend yedim","suspend oldu","hesabım kapandı","hesabım askıya","ban yedim","hesap askıya alındı","hesabım kapatıldı","hesap kapandı","amazon hesabım kapandı","amazon kapattı","hesabımı kapattılar","askıya aldılar","suspend aldım","hesabım durduruldu","deactivate oldu","deactivate edildi"],
    answer: "Hesabınızın askıya alındığını duyduğumuz için üzgünüz, bu durumun ne kadar stresli olduğunu çok iyi biliyoruz. Endişelenmeyin, doğru yerdesiniz — %85 başarı oranıyla birçok satıcıya yardımcı olduk.\n\nHesabınız hangi pazarda?",
    quickReplies: ["Amerika", "Kanada", "Meksika", "İngiltere", "Avrupa", "Japonya", "Avustralya", "Singapur", "BAE", "Suudi Arabistan"],
    setState: "suspend_flow", leadBonus: 40 },

  // ── KAT 2: SUSPEND TEMEL BİLGİLER ──
  { keys: ["suspend nedir","askıya alma nedir","ban mı","suspend ne demek"],
    answer: "Amazon suspend, satıcı hesabınızın geçici olarak askıya alınması durumudur. Listeleyemezsiniz, envanter gönderemezsiniz ve genellikle bakiyenize erişemezsiniz. Amazon'un sizi platformdan tamamen çıkarmadan önce verdiği bir \"dur\" işaretidir." },
  { keys: ["nasıl anlarım","suspend yediğimi","hesabım kapanınca","uyarı","bildirim"],
    answer: "Hesabınıza girdiğinizde kırmızı bir uyarı banner'ı görürsünüz. Performance Notifications bölümünde detaylı bir e-posta alırsınız. Satıcı merkezindeki fonksiyonlar kısıtlanır." },
  { keys: ["neden askıya","neden suspend","neden kapatır","neden ban","hangi hata"],
    answer: "Performans düşüklüğü, politika ihlalleri, güvenlik şüphesi, yasaklı ürün satışı, sahte ürün şüphesi, yorum manipülasyonu, bağlantılı hesap tespiti ve hızlı satış limitleri gibi birçok nedenle askıya alınabilir." },
  { keys: ["suspend deactivation fark","ban fark","geçici kalıcı","deactivation ne"],
    answer: "Suspend geçicidir, çözülebilir. Deactivation genellikle daha ciddi, bazen kalıcı olabilir. Her iki durumda da profesyonel destek şarttır." },
  { keys: ["kaç çeşit suspend","suspend türleri","hangi suspendler","suspend kategori"],
    answer: "Başlıca türler: Performans suspendi, Politika İhlali, Hızlı Satış (Velocity), Bağlantılı Hesap, Sahte Ürün (Inauthentic), İnceleme (Review) ve Yasaklı Ürün suspendi. Her birinin farklı çözüm stratejisi vardır." },
  { keys: ["performans suspend","metrik suspend","performans düşüklüğü"],
    answer: "ODR, Late Shipment Rate veya Pre-fulfillment Cancel Rate gibi metriklerin limitlerin üzerine çıkması durumunda verilen suspend türüdür. En yaygın türlerdendir." },
  { keys: ["politika ihlali","policy violation","kural ihlali"],
    answer: "Amazon'un Satıcı Politikalarını ihlal ettiğinizde aldığınız suspend türüdür. Yanlış ürün açıklaması, telif hakkı ihlali, yasaklı ürün satışı gibi durumları kapsar." },
  { keys: ["sahte ürün","fake product","orijinal olmayan"],
    answer: "\"Inauthentic\" suspendi, Amazon'un ürünlerinizin orijinal olmadığından şüphelenmesi durumunda verilir. Tedarik zincirinizi kanıtlamanız gerekir. En zor suspend türlerinden biridir." },
  { keys: ["bağlantılı hesap","linked account","ikinci hesap","çoklu hesap","related account"],
    answer: "Amazon'un aynı kişi/kuruluşa ait olduğunu tespit ettiği birden fazla hesaptır. Her satıcının sadece bir hesap sahibi olmasını ister. Tespit edilirse tüm hesaplar askıya alınır." },
  { keys: ["hızlı büyüme"],
    answer: "Beklenmedik satış artışı, envanter hacminizin ani yükselmesi durumunda Amazon'un güvenlik önlemi olarak verdiği suspend türüdür." },
  { keys: ["yorum manipülasyon","review manipulation","sahte yorum","yorum hilesi"],
    answer: "Sahte yorum almak, yorum karşılığında ürün vermek gibi manipülasyonlar sonucu verilen çok ciddi bir suspend türüdür. Amazon bu konuda tolerans göstermez." },
  { keys: ["param ne olur","bakiye","para don","ödeme","askıya alınca param"],
    answer: "Bakiyeniz genellikle 90 gün boyunca bloke edilir. Suspend çözülse bile bu süreç işler. Hesap açıldıktan sonra veya 90 günlük bekleme süresi sonunda alabilirsiniz." },
  { keys: ["suspend süre kısa"],
    answer: "Her hesap için ortalama 2 ay kadar çalışıyoruz. 7-8 appeal gönderiyoruz, her appeal arası 2-5 gün. Bazı dosyalarda ek belge/fatura süreçleri devreye girince uzayabilir. %85 başarı oranımız var ancak süre garantisi veremeyiz — Amazon'un inceleme hızına bağlıyız." },

  // ── KAT 3: ÇÖZÜM SÜRECİ ──
  { keys: ["nasıl çalışıyor","süreç nasıl","nasıl başla","adımlar","çözüm aşama"],
    answer: "Önce dosyanızı inceleriz. Şans görürsek ödeme sonrası çalışmaya başlarız. Gerekli belgeleri toplar, Plan of Action (POA) hazırlar, itirazınızı sunar ve Amazon'un yanıtını bekleriz. Süreç boyunca sizi bilgilendiririz. Şans görmediğimiz dosyaları kabul etmeyiz — paranızı boşa harcatmayız." },
  { keys: ["ilk savunma","ilk appeal","ilk itiraz"],
    answer: "İlk savunma, suspend aldıktan sonra Amazon'a gönderdiğiniz ilk itirazdır. En kritik aşamadır çünkü Amazon ilk itirazı reddederse süreç uzar ve zorlaşır." },
  { keys: ["appeal nedir","itiraz nedir","itiraz mektubu"],
    answer: "Amazon'a hesabınızın neden askıya alındığını veya hatayı nasıl düzelttiğinizi anlattığınız resmi yazıdır. Plan of Action ile birlikte sunulur, İngilizce yazılır." },
  { keys: ["poa nedir","plan of action","eylem planı","çözüm planı"],
    answer: "Amazon'un istediği, sorunun kök nedenini, düzeltici aksiyonları ve gelecekte tekrarlanmasını önleyici tedbirleri içeren 3 bölümlü profesyonel bir dokümandır." },
  { keys: ["poa nasıl","eylem planı nasıl","itiraz nasıl yazılır","appeal nasıl"],
    answer: "Root cause analysis (kök neden analizi) ile başlar. Sonra düzeltici aksiyonlar, sonra önleyici tedbirler yazılır. Her bölüm somut, ölçülebilir ve kanıtlanabilir olmalıdır." },
  { keys: ["kaç kez itiraz","kaç appeal","kaç şans","tekrar tekrar","kaç deneme","kaç kere","sınırsız appeal","sonsuza kadar","100 tane","hesap açılana kadar"],
    answer: "Ortalama 7-8 appeal gönderiyoruz, her appeal arasına 2-5 gün bekleme süresi koyuyoruz. Bu süreçte zaten hesabın açılıp açılmayacağı belli oluyor. Sınırsız deneme gibi bir yaklaşımımız yok — her appeal stratejik ve amaca yönelik olmalıdır. Orçun Bey'in dediği gibi, \"Her itiraz bir karttır, plansız harcamayın.\"" },
  { keys: ["reddedilirse","olumsuz cevap","ret alırsam","ikinci itiraz","red gelirse","kabul etmezse"],
    answer: "Reddetme nedenini analiz ederiz. Farklı açılardan, ek belgelerle, daha detaylı bir sonraki itiraz hazırlanır. Ancak her reddedilme süreci zorlaştırır. Ortalama 7-8 appeal içinde durumun netleşmesini bekliyoruz." },
  { keys: ["evrak eksik","belge yok","eksik evrak","fatura yok"],
    answer: "Bu süreçte fatura, Satış İzin Belgesi, lisans sözleşmesi gibi belgelerin olması beklenir çünkü Amazon kanıt ister. Belge eksikliği süreci etkileyebilir — eksik belgelerin tamamlanması faydalı olur. Bazı dosyalarda ürün almak, yeni fatura edinmek gibi ek adımlar devreye girebilir ve süreyi uzatabilir.\n\nBiz bu gibi durumlarda da başarılı olduğumuz dosyalar gördük — ancak bu referans niteliğindedir, garanti değildir. Son karar her zaman Amazon'a aittir. Dosyanızı inceleyelim, gerçekçi değerlendirmeyi birlikte yapalım." },
  { keys: ["faturasız","belgesiz","fatura olmadan"],
    answer: "Özellikle sahte ürün (Inauthentic) suspendinde fatura en güçlü belgedir; Amazon kanıt odaklı çalışır. Faturasız dosyalarda süreç zorlaşabilir, bunu dürüstçe söylüyoruz.\n\nAncak faturasız dosyalarda da başarılı olduğumuz durumlar oldu — bu referans niteliğindedir, garanti değildir. Dosyanızı değerlendirelim, gerçekçi bir yol haritası sunalım. Şans görmediğimiz dosyaları ise reddederiz, paranızı boşa harcamayız." },

  // ── SÜREÇ & SÜRE SORULARI ──
  // v17: "süre" ile ilgili TÜM olası soruları tek entry'de topladık
  { keys: [
      "ne kadar sürer","ne kadar sürüyor","ne kadar süre alıyor","süre ne kadar",
      "kaç ay","kaç hafta","kaç gün","süre","ne zaman açılır","ne zaman açılacak",
      "ne zaman sonuçlanır","tahmini süre","uzun sürüyor","neden uzun","çok uzadı",
      "hâlâ açılmadı","niye bu kadar","ne kadar bekleyeceğim","ne kadar beklemeliyim",
      "kaç ayda açılır","süreç süresi","kaç günde açılır","kaç haftada açılır",
      "süreç ne kadar","ortalama süre","beklenen süre","zaman dilimi",
      "ne kadar zaman","ne zamana kadar","beklemem gerekir mi","bekleme süresi",
      "hesap ne zaman","hesabım ne zaman açılır","açılma süresi","açılış süresi",
      "suspend ne kadar sürer","suspend süresi","dosya ne kadar","dosya süresi",
      "ne kadar süreceğini","ne kadar süreceği","süreceği"
    ],
    answer: "Her hesap için ortalama **2 ay** kadar çalışıyoruz. Ortalama 7-8 appeal gönderiyoruz, her appeal arasına 2-5 gün bekleme süresi koyuyoruz.\n\nBazı dosyalarda ek süreçler işin içine girdiğinde (örn. fatura toparlama, yeni tedarikçi bulma) süre uzayabilir. Orçun Bey'in dediği gibi: *\"Stratejik sabır, aceleci hatalardan daha değerlidir.\"*\n\nAncak kesin bir tarih vermek doğru olmaz — Amazon'un kendi inceleme hızına da bağlı. Biz süreyi değil **doğru stratejiyi** garanti ediyoruz." },
  { keys: ["neden bu kadar uzun","çok bekledim","sabırsızım","hızlandırın","acele"],
    answer: "Sürecin uzun sürmesi sinir bozucu olabilir, sizi anlıyoruz. Ancak Amazon'un kendi inceleme süreleri var ve bunu hızlandırmak maalesef elimizde değil. Her appeal arasına 2-5 gün bekleme koyuyoruz, bu Amazon'un yanıt süresine bağlı. Stratejik sabır, aceleci hatalardan daha değerlidir." },

  // ── GARANTİ & VAAT SORULARI ──
  { keys: ["garanti","garanti ediyor musunuz","kesin açılır mı","söz veriyor musunuz","emin misiniz","yüzde yüz","kesin çözülür","mutlaka açılır","garanti veriyor musunuz","garanti var mı"],
    answer: "Hesap açılışını ASLA garanti etmiyoruz ve bunu dürüstçe söylüyoruz. Biz Amazon'da kiracıyız, ev sahibi Amazon. %85 başarı oranımız var ama son karar her zaman Amazon'a ait. Orçun Bey, \"Garanti satan birini görürseniz, uzak durun\" der.",
    quickReplies: ["Anladım, dosyamı inceletin", "Fiyat bilgisi", "Süreç nasıl işliyor"] },
  { keys: ["başarısız olursa","açılmazsa ne olur","olmazsa","çözülemezse","işe yaramazsa"],
    answer: "Maalesef her dosya çözülebilir değildir. Biz elimizden gelenin en iyisini yapıyoruz ama son söz Amazon'undur. Ortalama 7-8 appeal içinde hesabın durumu netleşir. %85 başarı oranımız var ama %15'lik dilimde Amazon kararından dönmeyebilir. Bu riski baştan şeffaf olarak paylaşıyoruz." },
  { keys: ["para iadesi","iade yapıyor musunuz","paramı geri","başarısız iade","geri ödeme"],
    answer: "Maalesef iade yapmıyoruz. Elektronik ortamda anında ifa edilen hizmet olduğu için cayma hakkı bulunmuyor. Ancak dosyanızı baştan inceler, şans görmediğimiz dosyaları kabul etmeyiz — böylece paranızı boşa harcamamış olursunuz. Bu bizim dürüstlük politikamızdır." },
  { keys: ["neden garanti yok","başkaları garanti veriyor","rakip garanti","garanti veren var"],
    answer: "Garanti veren firmalara dikkat edin. Amazon'a kimse garanti veremez çünkü son karar Amazon'a aittir. Biz Amazon'da kiracıyız, ev sahibinin kararını biz kontrol edemeyiz. Garanti satmak müşteriye yalan söylemektir. Orçun Bey bu konuda çok nettir: \"Garanti satan, yalan satıyordur.\"" },

  // ── SÜREÇ DETAY SORULARI ──
  { keys: ["ne yapıyorsunuz","nasıl ilerliyor"],
    answer: "Önce dosyanızı inceleriz. Şans görürsek ödeme sonrası çalışmaya başlarız. Hesabınıza bağlanır, durumu analiz eder, gerekli belgeleri toplar, Plan of Action hazırlar ve itirazınızı sunarız. Ortalama 7-8 appeal, her biri arasında 2-5 gün, toplamda yaklaşık 2 aylık bir süreç. Şans görmediğimiz dosyaları kabul etmeyiz." },
  { keys: ["hesabı siz mi yönetiyorsunuz","hesabıma giriyor musunuz","hesabıma bağlanıyor musunuz","server","sunucu"],
    answer: "Evet, hesabınıza güvenli bir sunucu üzerinden bağlanıyoruz. Tüm işlemler bu sunucu üzerinden yapılır. Sunucu bilgileri ve gönderilen appeal'ler güvenlik nedeniyle paylaşılmaz. Ortalama 1-5 günde bir hesabınızla ilgili işlem yapılır." },
  { keys: ["daha önce appeal gönderdim","kendim denedim","kendi appeal","başka firma denedim","başarısız appeal"],
    answer: "Daha önce gönderilmiş appeal'ler dosyanın durumunu zorlaştırabilir. Amazon her reddedilen itirazı kaydeder. Ama endişelenmeyin — biz devraldığımız noktadan itibaren profesyonel strateji ile ilerliyoruz. Durumu değerlendirmemiz için hesabınızı incelememiz gerekir." },
  { keys: ["root cause","kök neden"],
    answer: "\"Sorunun kök nedeni nedir?\" sorusunun cevabıdır. POA'nın ilk bölümüdür. Amazon yüzeysel cevapları reddeder, derinlemesine analiz gerektirir." },
  { keys: ["preventive","önleyici","tekrarlamaması","önlem planı"],
    answer: "\"Gelecekte tekrarlanmasını nasıl önleyeceksiniz?\" sorusunun cevabıdır. \"Daha dikkatli olacağım\" değil, somut aksiyonlar yazılmalıdır." },

  // ── KAT 4: HESAP SAĞLIĞI ──
  { keys: ["hesap sağlığı nedir","account health","dashboard","hesap skoru"],
    answer: `Account Health Dashboard, hesabınızın Amazon gözündeki durumunu gösteren metrikler bütünüdür. Kırmızıya düşmek suspend riski demektir.\n\n📋 Hesap Sağlığı İnceleme hizmetimiz\n🔗 ${SERVICES.saglik.url}` },
  { keys: ["odr nedir","order defect","sipariş hata","defect rate","kusurlu sipariş"],
    answer: `Müşteri memnuniyetsizliğini gösteren ana metriktir. %1'in altında olmalıdır, %1.5'i geçerse suspend yersiniz.\n\n💼 ODR Suspendi hizmetimiz\n🔗 ${SERVICES.odr.url}` },
  { keys: ["lsr","late shipment","geç gönderim oranı"],
    answer: `Zamanında kargolanmayan siparişlerin oranıdır. %4'ün altında olmalıdır.\n\n💼 Geç Gönderim Suspendi hizmetimiz\n🔗 ${SERVICES.gec.url}` },
  { keys: ["pfcr","stoksuz iptal"],
    answer: `Stokta olmayan ürünü satıp sonra iptal etme oranıdır. %2.5'in altında olmalıdır.\n\n💼 Sipariş İptal Oranı Suspendi hizmetimiz\n🔗 ${SERVICES.iptal.url}` },
  { keys: ["metrik iyileştir","skor düzelt","hesap sağlığı artır","performans izle"],
    answer: "Stok yönetimini optimize edin, kaliteli ürün gönderin, hızlı kargolayın, müşteri mesajlarına anında yanıt verin. Metrikleri günlük takip edin, sarıya düşmeden önlem alın." },

  // ── KAT 5: YASAKLI ÜRÜN & POLİTİKA ──
  { keys: ["yasaklı ürün liste","restricted products","hangi ürünler yasak"],
    answer: `Amazon Seller Central'da "Restricted Products" sayfasında detaylı liste vardır. Kozmetik, gıda, ilaç, silah gibi birçok kategori kısıtlıdır.\n\n💼 Yasaklı Ürünler Suspendi hizmetimiz\n🔗 ${SERVICES.yasakli.url}` },
  { keys: ["kapalı kategori","restricted category","ungating","izne tabi","kategori aç"],
    answer: `Satışı için özel izin gerektiren kategorilerdir. Tedarikçi faturası, sertifika veya yetki belgesi istenir.\n\n💼 Kapalı Kategori Açılışı hizmetimiz\n🔗 ${SERVICES.kapali.url}` },
  // v18: Eski kısa "fikri mülkiyet" entry'si kaldırıldı. Detaylı ve butonlu versiyonu aşağıda (v16 eklemesi) var.

  // ── KAT 6: BAĞLANTILI HESAP & GÜVENLİK ──
  { keys: ["aynı ip","farklı hesap açılır mı","ip adresi aynı","ip çakışma"],
    answer: "Aynı IP'den farklı hesaplar bağlantılı hesap suspendi riski yaratır. IP tek başına belirleyici değildir ama risk faktörüdür." },
  { keys: ["eşim adına","aile üyesi","karım adına","aynı evde iki hesap"],
    answer: "Eşiniz gerçekten ayrı bir işletme kuruyorsa, farklı banka hesabı, farklı adres, farklı IP kullanıyorsa mümkündür. Ama aynı evde, aynı bilgisayardan, aynı ürünleri satmak bağlantılı hesap demektir." },
  { keys: ["hacklen","çalın","yetkisiz erişim","hesabım çalındı"],
    answer: "Önce hesabınızı güvenli hale getirin (şifre değiştirin, iki adımlı doğrulama ekleyin). Sonra Amazon'a hesabınızın ele geçirildiğini kanıtlayarak itiraz edin." },
  { keys: ["banka değişik","iban","hesap numarası değiş"],
    answer: "Ani ve sık banka değişiklikleri güvenlik şüphesi yaratabilir. Değiştirmeden önce Amazon'a bildirmek, geçiş sürecini yönetmek önemlidir." },
  { keys: ["hesap devret","hesap sat","transfer","başkasına ver"],
    answer: "Resmi olarak hayır. Amazon hesaplar kişiye/şirkete özeldir ve devredilemez. Satmak, devretmek yasaktır." },

  // ── KAT 7: HİZMETLER & FİYATLAR ──
  // v19: ASIN Fetcher (Chrome eklentisi) — ürün ve menü bilgileri
  { keys: ["asin fetcher","asin fetcher nedir","asin fetcher ne ise yarar","asin fetcher hakkinda","asin fetcher bilgi","chrome eklentisi","chrome eklentiniz","risk tarama eklentisi","urun risk tarama","eklenti nedir"],
    answer: `ASIN Fetcher, Amazon satıcıları için geliştirdiğimiz Chrome eklentisidir. Satıcı mağazalarını, kategorileri ve arama sonuçlarını tarar, bulduğu ürünleri toplar ve her birini marka, telif hakkı ve kısıtlı ürün riskleri başta olmak üzere 14 risk kategorisinde inceler. Riskli ürünler listenize girmeden ayıklanır.\n\n🔹 Güvenli bulunan ürünleri tek tuşla kopyalar ya da CSV/Excel olarak alırsınız\n🔹 Türkçe ve İngilizce arayüz, 20 Amazon pazaryerinde çalışır\n🔹 500 + 500 ücretsiz krediyle deneyebilirsiniz; eklentiyi Chrome Web Mağazası'ndan tek tıkla yükleyin\n\nDetaylar: https://suspendsupport.com.tr/pages/suspendsupport-asin-fetcher`,
    quickReplies: ["ASIN Fetcher nasıl çalışır?", "Hangi riskleri kontrol eder?", "ASIN Fetcher paketleri", "Ücretsiz deneme istiyorum"] },
  { keys: ["asin fetcher nasil calisir","asin fetcher nasil kullanilir","asin fetcher kullanim","asin fetcher adimlar","eklenti nasil calisir"],
    answer: `ASIN Fetcher dört adımda çalışır:\n\n1) Taramak istediğiniz satıcı mağazasını, kategoriyi ya da arama sonucunu Amazon'da açarsınız.\n2) Hazır filtre setlerinden (Temkinli, Dengeli, Geniş) birini seçersiniz; dilerseniz kendi setinizi oluşturursunuz.\n3) Taramayı başlatır ve ilerlemeyi canlı izlersiniz. Başlamadan önce en fazla kaç kredi harcanacağı görünür.\n4) Güvenli bulunan ürünleri tek tuşla kopyalar ya da CSV/Excel olarak indirirsiniz.\n\nHer ürün Yüksek, Orta ya da Güvenli olarak etiketlenir; riskin nedeni ürün kartında yazar. Riskli bulunan ve filtrelere takılan ürünler güvenli listeye girmez.\n\nDetaylar: https://suspendsupport.com.tr/pages/suspendsupport-asin-fetcher`,
    quickReplies: ["Hangi riskleri kontrol eder?", "ASIN Fetcher kurulumu", "Ücretsiz deneme istiyorum"] },
  { keys: ["asin fetcher risk","hangi riskleri","12 risk","risk kategorileri","risk kategorisi","asin fetcher kesin mi","asin fetcher garanti","sonuclar kesin mi"],
    answer: `ASIN Fetcher her ürünü 14 risk kategorisinde inceler:\n\n🔹 Hesap sağlığı: onay gerektiren kategori, pestisit iddiası, tıbbi iddia, sertifika gerektiren çocuk ürünü, başka bir markanın adını kullanan aksesuar\n🔹 Marka ve kısıtlı ürün: marka riski, telif hakkı riski, kısıtlı ürün, şüpheli ifade\n🔹 Ürün güvenliği: elektrik güvenliği, yangın ve can güvenliği, yutma riski, dijital kod ve hediye kartı, temizlik kimyasalı ve yapıştırıcı\n\nSonuçlar riski azaltmanıza yardımcı olan tahminlerdir; ürünlerin Amazon kurallarına uygunluğu satıcının sorumluluğundadır ve hesap güvenliği konusunda %100 güvence verilemez.\n\nDetaylar: https://suspendsupport.com.tr/pages/suspendsupport-asin-fetcher`,
    quickReplies: ["ASIN Fetcher nasıl çalışır?", "ASIN Fetcher paketleri", "Ücretsiz deneme istiyorum"] },
  { keys: ["ucretsiz deneme","asin fetcher deneme","eklenti deneme","deneme lisans","500 + 500"],
    answer: `ASIN Fetcher'ı önce ücretsiz deneyebilirsiniz. WhatsApp'tan bize yazın, 500 + 500 kredilik deneme lisansınızı tanımlayalım. Eklentiyi Chrome Web Mağazası’ndan yükleyip lisans anahtarını girmeniz yeterli. Deneme için ödeme gerekmez.\n\n💬 WhatsApp: https://wa.me/905541716182`,
    quickReplies: ["ASIN Fetcher paketleri", "ASIN Fetcher kurulumu"] },
  { keys: ["asin fetcher paket","asin fetcher fiyat","asin fetcher ucret","asin fetcher uyelik","asin fetcher abonelik","asin fetcher kredi","eklenti fiyat","kredi nasil harcanir","kredi nedir"],
    answer: `ASIN Fetcher aylık üyelik paketleriyle sunulur: Başlangıç, Standart ve Profesyonel. Her paket 31 gün geçerlidir ve bonus kredi içerir.\n\n🔹 1 kredi, 1 ürünün risk analizi demektir\n🔹 Filtrelere takılan ürünler için kredi harcanmaz\n🔹 Kullanılmayan krediler bir sonraki aya devretmez\n🔹 Taramaya başlamadan önce harcanabilecek en yüksek kredi tahmini görünür\n\nGüncel paketleri sayfadan görebilirsiniz: https://suspendsupport.com.tr/pages/suspendsupport-asin-fetcher`,
    quickReplies: ["Ücretsiz deneme istiyorum", "ASIN Fetcher kurulumu"] },
  { keys: ["asin fetcher kurulum","asin fetcher nasil kurulur","eklenti kurulum","eklenti nasil kurulur","asin fetcher lisans","eklenti lisans","asin fetcher cihaz","kac cihaz"],
    answer: `ASIN Fetcher, Chrome Web Mağazası'nda yayındadır; Chrome'a ekle düğmesiyle tek tıkla yükleyebilirsiniz. Satın alma sonrasında (deneme için de) lisans anahtarınız iletilir; anahtarı eklentiyi açınca girmeniz yeterli, lisans ilk etkinleştirmede cihazınıza bağlanır. Kurulumda takılırsanız WhatsApp'tan yazabilirsiniz.\n\n🔹 Lisans cihaza özeldir; aynı bilgisayara yeniden kurulum yeni cihaz sayılmaz\n🔹 Ek cihaz ihtiyacınız varsa bize yazabilirsiniz\n🔹 Risk motoru sunucuda çalıştığı için internet bağlantısı gerekir\n\nDetaylar: https://suspendsupport.com.tr/pages/suspendsupport-asin-fetcher`,
    quickReplies: ["ASIN Fetcher paketleri", "Ücretsiz deneme istiyorum"] },
  { keys: ["riskli urunleri nasil eleyebilirim","riskli urunleri nasil elerim","riskli urunleri nasil elemek","riskli urunleri elemek","urun secerken riskli","urun secimi risk","riskli urun nasil"],
    answer: `Bunun için Chrome eklentimiz ASIN Fetcher var. Mağazaları ve arama sonuçlarını tarar, her ürünü 14 risk kategorisinde inceler; riskli ürünler listenize girmeden ayıklanır. 500 + 500 ücretsiz krediyle deneyebilirsiniz.\n\nDetaylar: https://suspendsupport.com.tr/pages/suspendsupport-asin-fetcher`,
    quickReplies: ["ASIN Fetcher nasıl çalışır?", "Ücretsiz deneme istiyorum"] },
  { keys: ["hizmet paket","hizmetleriniz","paketleriniz","ne tür destek","hizmet kapsam"],
    answer: `Hizmetlerimiz:\n\n🔹 Suspend Çözümleri (3 ASIN, Açılış, Drop Shipping, Fikri Mülkiyet, Velocity, ODR, İlişkilendirme vb.)\n🔹 Hesap Açılışı (Kuzey Amerika & Avrupa)\n🔹 Orçun UYAR ile Birebir Görüşme\n🔹 Hesap Sağlığı İnceleme\n🔹 Fon Kurtarma\n🔹 Arama Hizmeti\n🔹 ASIN Fetcher (Amazon ürün risk tarama Chrome eklentisi, ücretsiz deneme)\n\nDetaylar: https://suspendsupport.com.tr/collections/all`,
    quickReplies: ["ASIN Fetcher nedir?", "Orçun Bey ile görüşme"] },
  { keys: ["fiyat","ücret","kaç tl","kaç lira","maliyet","fiyat listesi","tüm fiyatlar","ne kadara","kaça","fiyat nedir","ücret nedir","fiyatlar","ücretler","ödeme tutarı"],
    answer: 'Hizmetlerimizin güncel fiyatlarını ve detaylarını sitemizden inceleyebilirsiniz:\n\n' + Object.values(SERVICES).map(s => `• ${s.name}\n  🔗 ${s.url}`).join('\n') + '\n\nTüm hizmetler: https://suspendsupport.com.tr/collections/all' },
  { keys: ["3 asin fiyat","inauthentic fiyat","sahte ürün fiyat","3 asin ücret"],
    answer: `3 ASIN Suspendi (Inauthentic Item) hizmetimiz\n🔗 ${SERVICES["3_asin"].url}` },
  { keys: ["açılış suspend fiyat","seller id fiyat","açılış fiyat","verification fiyat"],
    answer: `Açılış Suspendi (Seller ID Verification) hizmetimiz\n🔗 ${SERVICES.acilis.url}` },
  { keys: ["dropshipping fiyat","drop shipping fiyat","drop shipping ücret"],
    answer: `Drop Shipping Politika İhlali hizmetimiz\n🔗 ${SERVICES.dropshipping.url}` },
  { keys: ["fikri mülkiyet fiyat","ip fiyat","intellectual property fiyat"],
    answer: `Fikri Mülkiyet Suspendi hizmetimiz\n🔗 ${SERVICES.fikri.url}` },
  { keys: ["velocity fiyat","hızlı satış fiyat","hızlı satış ücret"],
    answer: `Hızlı Satış Suspendi (Velocity) hizmetimiz\n🔗 ${SERVICES.hizli.url}` },
  { keys: ["ilişkilendirme fiyat","related account fiyat","bağlantılı hesap fiyat"],
    answer: `İlişkilendirme Suspendi hizmetimiz\n🔗 ${SERVICES.iliskilendirme.url}` },
  { keys: ["hesap açılış fiyat","hesap açtır","amerika hesap","avrupa hesap","kuzey amerika fiyat","avrupa fiyat"],
    answer: `Hesap Açılışı hizmetlerimiz:\n\n🇺🇸 Kuzey Amerika\n🔗 ${SERVICES.kuzey.url}\n\n🇪🇺 Avrupa\n🔗 ${SERVICES.avrupa.url}` },
  { keys: ["orçun görüşme fiyat","birebir görüşme fiyat","orçun bey fiyat","danışmanlık fiyat","orçun uyar"],
    answer: `Orçun UYAR ile Birebir Görüşme\n🔗 ${SERVICES.gorusme.url}` },
  { keys: ["arama hizmeti fiyat","call service fiyat","telefon hizmeti fiyat"],
    answer: `Arama Hizmeti (Call Service)\n🔗 ${SERVICES.arama.url}` },
  { keys: ["hesap sağlığı fiyat","account health fiyat","sağlık inceleme fiyat"],
    answer: `Hesap Sağlığı İnceleme\n🔗 ${SERVICES.saglik.url}` },
  { keys: ["fon kurtarma fiyat","para kurtarma","bakiye kurtarma","fon fiyat"],
    answer: `Fon Kurtarma Hizmeti\n🔗 ${SERVICES.fon.url}` },
  { keys: ["tek appeal fiyat","tek itiraz fiyat"],
    answer: `Tek Appeal Hizmeti\n🔗 ${SERVICES.tek_appeal.url}` },

  // ── KAT 8: ÖDEME & İADE ──
  { keys: ["ödeme koşul","nasıl ödeme","ödeme şekl","ödeme plan"],
    answer: "Kredi kartı, havale ve Payoneer ile ödeme yapılabilir. Faturalı hizmet veriyoruz." },
  { keys: ["danışmanlık","sadece bilgi","sadece yönlendirme","rehberlik"],
    answer: `Evet, saatlik danışmanlık hizmetimiz var.\n\n📞 Orçun UYAR ile Birebir Görüşme\n🔗 ${SERVICES.gorusme.url}` },

  // ── KAT 9: BELGELER ──
  { keys: ["hangi belge","evrak","doküman","ne lazım","belge listesi"],
    answer: "Tedarikçi faturaları, üretici yetki belgeleri, şirket belgeleri, kimlik fotokopisi, banka ekstreleri gibi belgeler istenebilir. Suspend nedenine göre değişir." },
  { keys: ["fatura nasıl","invoice","tedarikçi belgesi","fatura özellik"],
    answer: "Son 365 gün içindeki, satıcı bilgilerinizle eşleşen, ürün detaylarını içeren, tedarikçinin resmi kaşe ve imzasını taşıyan faturalar olmalıdır. Elle yazılmış faturalar geçersizdir." },
  { keys: ["authorization letter","yetki belgesi","yetki mektubu"],
    answer: "Marka sahibi veya distribütörden, o ürünü satma yetkinizin olduğunu belirten resmi yazıdır. Büyük markaların ürünlerinde fatura yetmeyebilir." },
  { keys: ["türkçe belge","ingilizce şart","çeviri gerekli","belge dili"],
    answer: "Türkçe belgeler kabul edilir ancak İngilizce çevirisiyle birlikte sunulması tercih edilir." },

  // ── KAT 10: SONRASI & ÖNLEM ──
  { keys: ["açıldıktan sonra","sonra dikkat","sonraki süreç","probation"],
    answer: "Hesap açıldığında \"probation\" dönemindesinizdir. Metriklerinizi yakından takip edin, stok yönetiminizi sıkılaştırın. Aynı hatayı yapmayın, Amazon ikinci şansı zor verir." },
  { keys: ["tekrar suspend","bir daha","tekrar askıya"],
    answer: "Hesap sağlığınızı günlük kontrol edin, performans bildirimlerini ciddiye alın, politikaları düzenli takip edin. Orçun Bey'in altını çizdiği gibi: \"Birinci suspend hatadır, ikinci suspend cezadır.\"" },
  { keys: ["önlem","önceden","proaktif","koruma","önleyici danışmanlık"],
    answer: `Evet, önleyici danışmanlık hizmetimiz var. Hesap sağlığınızı düzenli kontrol ediyor, riskleri önceden tespit ediyoruz.\n\n📋 Hesap Sağlığı İnceleme\n🔗 ${SERVICES.saglik.url}` },

  // ── KAT 11a: ÜLKE + SUSPEND KOMBİNASYONLARI ──
  // Bu entry'ler ülke+suspend birlikte geçtiğinde yakalanır (searchKB v8'de özel bonus alır)
  { keys: ["kanada suspend","kanada hesap suspend","kanada askıya","canada suspend","kanada pazarı suspend","kanada pazarı kapandı","kanada hesabım kapandı","kanada ban","kanada kapatıldı","kanada pazarım kapandı"],
    answer: "Kanada pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Kanada, Kuzey Amerika hesabı kapsamında — deneyimimiz var.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "Kanada" },
  { keys: ["amerika suspend","abd suspend","usa suspend","amerikan pazar suspend","kuzey amerika suspend","amerika pazarı kapandı","abd hesabım kapandı","amerika ban","amerika kapatıldı","abd pazarım kapandı"],
    answer: "ABD pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Bu en sık karşılaştığımız pazar olduğu için derin deneyimimiz var.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "ABD" },
  { keys: ["ingiltere suspend","uk suspend","ingiltere hesap suspend","amazon uk suspend","ingiltere pazarı kapandı","ingiltere hesabım kapandı","uk ban","uk kapatıldı","ingiltere pazarım kapandı"],
    answer: "İngiltere pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. İngiltere, Avrupa hesabı kapsamında — bu pazarda da deneyimimiz var.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "İngiltere" },
  { keys: ["almanya suspend","germany suspend","amazon de suspend","alman pazar suspend","almanya pazarı kapandı","almanya hesabım kapandı","almanya ban","almanya kapatıldı","almanya pazarım kapandı"],
    answer: "Almanya pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Almanya, Avrupa hesabı kapsamında.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "Almanya" },
  { keys: ["avrupa suspend","avrupa hesap suspend","europe suspend","avrupa pazarı suspend","avrupa pazarı kapandı","avrupa hesabım kapandı","avrupa ban","avrupa kapatıldı","avrupa pazarım kapandı"],
    answer: "Avrupa pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Avrupa'nın farklı pazarlarında (UK, DE, FR, IT, ES) deneyimimiz var.\n\nÖncelikle şunu öğrenmek isterim: **Hangi Avrupa pazarında hesabınız askıya alındı?**",
    quickReplies: ["İngiltere (UK)", "Almanya (DE)", "Fransa (FR)", "İtalya (IT)", "İspanya (ES)", "Birleşik hesap"],
    setState: "suspend_country_selected", setMarket: "Avrupa" },
  // v22 — "Avrupa" tek kelime butonu için: suspend flow'da zaten yukarıdaki entry yakalar.
  // Ama cold start veya suspend bağlamı dışında "Avrupa" yazılırsa burası devreye girer.
  { keys: ["avrupa","europe","avrupa pazarı","avrupa pazari"],
    answer: "Avrupa pazarında danışmanlık veriyoruz. Hem Avrupa hesabı açılışı hem de Avrupa hesabı suspend çözümlerinde uzmanız.\n\nSize nasıl yardımcı olalım?",
    quickReplies: ["Avrupa'da hesap açtırmak istiyorum", "Avrupa hesabım suspend oldu", "Önce bilgi almak istiyorum"],
    answerIfSuspending: "Avrupa pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Avrupa'nın farklı pazarlarında (UK, DE, FR, IT, ES) deneyimimiz var.\n\nÖncelikle şunu öğrenmek isterim: **Hangi Avrupa pazarında hesabınız askıya alındı?**",
    quickRepliesIfSuspending: ["İngiltere (UK)", "Almanya (DE)", "Fransa (FR)", "İtalya (IT)", "İspanya (ES)", "Birleşik hesap"],
    setMarketIfSuspending: "Avrupa" },
  // v22 — "Birleşik hesap" — Avrupa'da müşteri tek hesabı tüm pazarları kapsıyorsa
  { keys: ["birleşik hesap","birlesik hesap","tek hesap","unified account","avrupa unified","tüm avrupa","tum avrupa","birleşik avrupa","birlesik avrupa","hepsi","tüm pazarlar","tum pazarlar"],
    answer: "Avrupa'da **birleşik hesap (unified account)** tek bir Seller Central hesabıyla 5 pazarda (İngiltere, Almanya, Fransa, İtalya, İspanya) satış yapmanızı sağlar. Suspend olduğunda genelde tüm Avrupa pazarları aynı anda etkilenir.\n\nHesabınızla ilgili durumu daha iyi anlamak için: **Amazon'dan gelen suspend bildiriminde sebep olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "Avrupa (Birleşik)" },
  { keys: ["japonya suspend","japan suspend","amazon jp suspend","japon pazar suspend","japonya pazarı kapandı","japonya hesabım kapandı","japonya ban","japonya kapatıldı"],
    answer: "Japonya pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Japonya pazarı için de danışmanlık hizmeti veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "Japonya" },
  // v15 — Yeni pazarlar
  { keys: ["meksika suspend","mexico suspend","amazon mx suspend","meksika pazarı kapandı","meksika hesabım kapandı","meksika ban","meksika kapatıldı"],
    answer: "Meksika pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Meksika, Kuzey Amerika hesabı kapsamındadır.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "Meksika" },
  { keys: ["avustralya suspend","australia suspend","amazon au suspend","avustralya pazarı kapandı","avustralya hesabım kapandı","avustralya ban","avustralya kapatıldı"],
    answer: "Avustralya pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Avustralya pazarı için de danışmanlık veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "Avustralya" },
  { keys: ["singapur suspend","singapore suspend","amazon sg suspend","singapur pazarı kapandı","singapur hesabım kapandı","singapur ban","singapur kapatıldı"],
    answer: "Singapur pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Singapur pazarı için de danışmanlık veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "Singapur" },
  { keys: ["bae suspend","birleşik arap emirlikleri suspend","uae suspend","amazon ae suspend","dubai suspend","emirlikler suspend","bae pazarı kapandı","bae hesabım kapandı","bae ban"],
    answer: "Birleşik Arap Emirlikleri pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. BAE pazarı için de danışmanlık veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "BAE" },
  { keys: ["suudi arabistan suspend","suudi suspend","saudi arabia suspend","amazon sa suspend","suudi arabistan pazarı kapandı","suudi arabistan hesabım kapandı","suudi ban"],
    answer: "Suudi Arabistan pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Suudi Arabistan pazarı için de danışmanlık veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickReplies: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setState: "suspend_country_selected", setMarket: "Suudi Arabistan" },

  // ══════════════════════════════════════════════════════════
  // v16: 10 SUSPEND TÜRÜ BİLGİ ENTRY'LERİ — Her biri detaylı açıklama + destek teklifi
  // ══════════════════════════════════════════════════════════
  { keys: ["ürün orjinallik","ürün orijinallik","urun orjinallik","inauthentic","inauthentic item","orjinal değil","ürünün orjinalliği","counterfeit","sahte iddia","ürün orjinal mi","inauthentic suspend"],
    answer: "**Ürün Orjinallik (Inauthentic) suspendi**, Amazon'un sattığınız ürünlerin orijinalliğinden şüphelendiği durumlarda gelir. Müşteriden gelen şikayet veya Amazon'un kendi taraması tetikleyebilir.\n\nBu durumda Amazon sizden tedarik zincirinizi ispatlayan belgeler ister: yetkili tedarikçiden alınmış fatura, distribütör anlaşması, marka sahibinden yetki mektubu gibi. Fatura en güçlü belgedir; kaşeli-imzalı, satıcı bilgilerinizle eşleşen ve son 365 gün içinde düzenlenmiş olması gerekir.\n\nEn zor suspend türlerinden biridir ama imkansız değildir. Doğru belgelerle ve profesyonel bir POA (Plan of Action) ile çözülebilir. Bu gibi dosyalarda başarılı olduğumuz durumlar var — ancak bu referans niteliğindedir, garanti değildir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Dosyanızı inceleyip gerçekçi bir değerlendirme sunabiliriz.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "Ürün Orjinallik (Inauthentic)" },

  { keys: ["fikri mülkiyet","fikri mulkiyet","intellectual property","ip ihlali","trademark","marka ihlali","copyright","telif hakkı","patent ihlali"],
    answer: "**Fikri Mülkiyet (IP) suspendi**, marka sahibi veya hak sahibi birinin Amazon'a sizin hakkınızda şikayet (IP complaint) yapmasıyla gelir. Trademark, copyright veya patent ihlali iddiası olabilir.\n\nÇözüm için en etkili yol, şikayeti yapan marka sahibiyle iletişime geçmek ve **retraction** (şikayetin geri çekilmesi) almaktır. Retraction alındığında Amazon genelde hızlı şekilde hesabı açar. Alamazsanız POA ile ispatlama yoluna gidilir — ürünün orijinal kaynağı, yetki belgesi, marka sahibinin izni gibi belgeler sunulur.\n\nIP suspendlerinde zamanlama çok önemlidir; ne kadar erken müdahale ederseniz o kadar iyi. Bu tür dosyalarda başarılı olduğumuz durumlar var — ancak referans niteliğindedir, garanti değildir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Dosyanızı inceleyip stratejik bir yol haritası çizebiliriz.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "Fikri Mülkiyet" },

  { keys: ["hesap incelemesi","hesap inceleme","account under review","your account is currently under review","hesap incelemeye alındı","account review","hesap incelemeye alindi"],
    answer: "**Hesap İncelemesi (Account Under Review)** suspendinde Amazon bildirim olarak şunu der: \"Your account is currently under review.\" Bu durumda Amazon, hesabınızdaki tüm siparişlerin gerçekten müşteriye ulaştığını ispatlamanızı ister.\n\nSizden beklenen genellikle şudur: sipariş detayları, kargo takip numaraları, müşteri adresleri ve ürün faturaları. Burada önemli bir nokta var — Amazon bu incelemede **ürünün nereden tedarik edildiğine takılmaz**; amacı yalnızca siparişlerin fulfill edilip edilmediğini doğrulamaktır. Faturaların yetkili tedarikçiden mi yoksa Amazon.com'dan mı alındığı burada sorgulanmaz.\n\nBu, Drop Shipping Politika İhlalinden farklı bir süreçtir. Hesap İncelemesinde dokümantasyon eksiksizse çözüm oranı yüksektir. Bu tür dosyalarda başarılı olduğumuz durumlar var — referans niteliğindedir, garanti değildir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Belge toparlama ve POA hazırlama sürecinde yanınızdayız.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "Hesap İncelemesi" },

  { keys: ["hızlı satış","hizli satis","velocity","velocity suspend","satış hızı","çok satma","ani satış artışı","velocity review"],
    answer: "**Hızlı Satış (Velocity) suspendi**, hesabınızda kısa sürede beklenmedik bir satış artışı olduğunda Amazon'un güvenlik önlemi olarak devreye soktuğu bir süreçtir. Yeni hesaplar veya uzun süre sessiz kalmış hesaplar ani yüksek satış yaptığında tetiklenebilir.\n\nAmazon bu durumda envanter kaynağınızı, tedarik zincirinizi ve müşteri memnuniyetini kanıtlayan belgeler ister. Tedarikçi faturaları, satın alma siparişleri ve kargo kayıtları kritiktir. Genellikle Hesap İncelemesi ile benzer belgeler istenir.\n\nVelocity genellikle diğer suspend türlerine göre daha hızlı çözülebilir; çünkü Amazon'un amacı gerçekten satış yapabildiğinizi görmektir, cezalandırmak değildir. Bu tür dosyalarda başarılı olduğumuz durumlar var — referans niteliğindedir, garanti değildir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Dosyanızı inceleyip süreçte size eşlik edebiliriz.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "Hızlı Satış (Velocity)" },

  { keys: ["section 3","section three","bsa section 3","business solutions agreement","term and termination","deceptive fraudulent","deceptive fraudulent illegal activity","seller code of conduct","code of conduct"],
    answer: "**Section 3 suspendi**, Amazon'un Business Solutions Agreement (BSA) sözleşmesinin 3. maddesinin ihlali gerekçesiyle verilen geniş kapsamlı bir suspend türüdür. Bildirimde genellikle şu ifade geçer: \"deceptive, fraudulent, or illegal activity\" (aldatıcı, hileli veya yasadışı faaliyet).\n\nSection 3, Amazon'un şüpheli gördüğü durumlarda kullandığı bir şemsiye gerekçedir; altında İlişkilendirme (Related Accounts), kimlik doğrulama hataları, şüpheli işlemler, sahte belge ve ürün iddiaları gibi birçok konu olabilir. Amazon bu bildirimlerde **gerçek sebebi genellikle gizler** — bu yüzden doğru tespit ve strateji çok önemlidir.\n\nSection 3 suspendleri hesap düzeyinde (account-level) bir işlemdir; tek bir ASIN değil tüm hesabı kapsar. Süreç genellikle daha uzun ve belirsizdir. Bu tür dosyalarda başarılı olduğumuz durumlar var — referans niteliğindedir, garanti değildir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Bildirimi analiz edip gerçek sebebi tespit etmek ilk adımımız olacaktır.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "Section 3" },

  { keys: ["drop shipping suspend","dropshipping suspend","drop shipping politika","dropshipping policy violation","drop shipping politika ihlali","drop shipping suspendi","dropshipping suspendi"],
    answer: "**Drop Shipping Politika İhlali suspendi**, Amazon'un belirlediği drop shipping kurallarına aykırı bir durum tespit ettiğinde verilir. Amazon'un politikası net: drop shipping serbesttir ancak **satıcı kayıt sahibi (seller of record) siz olmalısınız**.\n\nAmazon'un yasakladığı en yaygın hata: başka bir perakendeciden (Amazon.com, Walmart, AliExpress vb.) ürün alıp doğrudan o perakendecinin paketiyle ve faturasıyla müşteriye göndermek. Bu durumda müşteri paketi açtığında başka bir markanın/satıcının bilgilerini görürse Amazon bunu politika ihlali sayar.\n\nBu suspend türünde Hesap İncelemesinden farklı olarak Amazon **ürünün kaynağına bakar**. Yetkili tedarikçiden mi yoksa Amazon.com / perakende bir siteden mi alındı — bu ayrım kritik. Çözüm için tedarikçi değişimi, B2B anlaşmalar ve yeni operasyon modeli sunan bir POA hazırlanmalıdır.\n\nBu tür dosyalarda başarılı olduğumuz durumlar var — ancak referans niteliğindedir, garanti değildir. Her dosya kendi içinde değerlendirilir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Dosyanızı inceleyip uygun stratejiyi birlikte belirleyelim.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "Drop Shipping" },

  { keys: ["odr","order defect rate","sipariş kusur oranı","siparis kusur orani","odr suspend","odr yüksek","odr yuzde"],
    answer: "**ODR (Order Defect Rate) suspendi**, sipariş kusur oranınızın Amazon'un eşik değerini (%1) aşması durumunda gelir. ODR üç metriğin birleşimidir: negatif geri bildirim, A-to-Z garanti şikayetleri ve ters ibraz (chargeback).\n\nÇözüm için hem ODR'yi düşürmeniz hem de bunun nedenlerini giderdiğinizi Amazon'a göstermeniz gerekir. Kargo kalitesini artırmak, müşteri hizmetlerini iyileştirmek, sorunlu ürünleri listeden çıkarmak ve müşteri iletişimini profesyonelleştirmek temel adımlardır.\n\nODR suspendleri genellikle performans temelli olduğu için çözüm süreci somut aksiyonlara dayanır. Bu tür dosyalarda başarılı olduğumuz durumlar var — referans niteliğindedir, garanti değildir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Metrikleri analiz edip kapsamlı bir iyileştirme planı hazırlayabiliriz.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "ODR" },

  { keys: ["hesap sağlığı","hesap sagligi","hesap sağlığı problemleri","account health problems","account health rating","ahr","account health suspend"],
    answer: "**Hesap Sağlığı Problemleri suspendi**, Amazon'un Account Health Rating (AHR) puanınızın eşiğin altına düşmesi veya metriklerinizde ciddi bozulma olması durumunda gelir. ODR, geç kargolama, iptal oranı, müşteri memnuniyeti ve politika uyumu hepsi birlikte değerlendirilir.\n\nAHR puanı düştüğünde Amazon ilk önce uyarı gönderir; dikkate alınmazsa suspend gelir. Çözüm için tüm kırmızı metrikleri tek tek ele alıp her biri için düzeltici aksiyon planı sunmak gerekir. Genellikle kapsamlı bir POA ile çözülür.\n\nHesap Sağlığı suspendleri önleyici yaklaşımla büyük ölçüde engellenebilir. Bu tür dosyalarda başarılı olduğumuz durumlar var — referans niteliğindedir, garanti değildir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Hesap sağlığınızı detaylı inceleyip toparlanma planı çıkarabiliriz.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "Hesap Sağlığı" },

  { keys: ["iptal sorunları","iptal sorunlari","sipariş iptal","pre-fulfillment cancel rate","cancel rate","iptal oranı","iptal orani","sipariş iptal oranı","siparis iptal"],
    answer: "**İptal Sorunları (Pre-Fulfillment Cancel Rate) suspendi**, stokta olmayan ürünleri satıp sonra iptal etme oranınızın %2.5 eşiğini aşması durumunda gelir. Bu metrik, müşterinin ürünü alacağını düşünüp beklerken iptalle karşılaşma deneyimini ölçer.\n\nGenelde stok yönetimi, tedarik zinciri veya listede kalan kaybolmuş ürünler bu sorunu yaratır. Çözüm için önce iptal olan siparişlerin kök nedenlerini analiz etmek, sonra envanter yönetimini iyileştirmek ve Amazon'a somut düzeltici aksiyonları sunmak gerekir.\n\nİptal Sorunları nispeten çözümü operasyonel olan bir suspend türüdür. Bu tür dosyalarda başarılı olduğumuz durumlar var — referans niteliğindedir, garanti değildir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Dosyanızı inceleyip iyileştirme planı birlikte oluşturalım.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "İptal Sorunları" },

  { keys: ["fba problemleri","fba hesap problemleri","fba suspend","fulfillment by amazon problem","fba depo","fba envanter","fba stowaway","fba shipment"],
    answer: "**FBA Problemleri suspendi**, FBA (Fulfillment by Amazon) sürecinde yaşanan çeşitli ihlaller sonucunda gelir. Yanlış etiketleme, yasaklı ürün gönderme, envanter planlama hataları, expired ürünler veya depo politikalarına aykırı paketlemeler yaygın sebeplerdir.\n\nFBA suspendlerinde sizden beklenenler genelde şunlardır: FBA süreçlerinizi gözden geçirmek, paketleme ve etiketleme standartlarına uyum sağlamak, Amazon'un envanter politikalarına uygun hareket ettiğinizi ispatlamak. POA'da operasyonel değişiklikler somut olarak belirtilmelidir.\n\nFBA suspendleri operasyonel disiplinle çözülebilir türdendir. Bu tür dosyalarda başarılı olduğumuz durumlar var — referans niteliğindedir, garanti değildir.\n\n**Bu konuda size destek vermemizi ister misiniz?** Süreç iyileştirme ve POA hazırlığında yanınızda oluruz.",
    quickReplies: ["Evet, destek istiyorum", "Önce daha bilgi almak istiyorum", "Orçun Bey ile görüşme"],
    setState: "suspend_type_selected", setSuspendType: "FBA Problemleri" },

  // "Evet, destek istiyorum" → Orçun Bey'e aktarım teklifi
  { keys: ["evet destek istiyorum","evet destek","destek istiyorum","evet yardım istiyorum","yardım alayım","destek alayım"],
    answer: "Harika! Size en iyi şekilde yardımcı olabilmemiz için durumunuzu Orçun Bey'e aktarıyorum. Kendisi dosyanızı detaylı inceleyip gerçekçi bir yol haritası sunacak.\n\nEn kısa sürede sizinle iletişime geçecek. Bu arada acil bir durum varsa WhatsApp'tan da doğrudan yazabilirsiniz:\n\n💬 WhatsApp: https://wa.me/905541716182\n📞 0 (554) 171 61 82" },


  // ── KAT 11b: PAZAR / MARKETPLACE / ÜLKE SORULARI (sadece ülke) ──
  { keys: ["kanada","canada","kanada pazarı","kanada hesap"],
    answer: `Evet, Kanada pazarında da destek veriyoruz. Kanada, Kuzey Amerika hesabı kapsamındadır.\n\n🇺🇸 Kuzey Amerika Hesap Açılışı\n🔗 ${SERVICES.kuzey.url}\n\nSuspend çözümü için de aynı şekilde hizmet veriyoruz.`,
    answerIfSuspending: "Kanada pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Kanada, Kuzey Amerika hesabı kapsamında — bu pazarda deneyimimiz var.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "Kanada" },
  { keys: ["amerika","abd","usa","amerikan pazarı","us marketplace"],
    answer: `Evet, ABD pazarı ana çalışma alanlarımızdan biridir. Kuzey Amerika hesabı kapsamındadır.\n\n🇺🇸 Kuzey Amerika Hesap Açılışı\n🔗 ${SERVICES.kuzey.url}`,
    answerIfSuspending: "ABD pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Bu en sık karşılaştığımız pazar olduğu için derin deneyimimiz var.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "ABD" },
  { keys: ["ingiltere","uk","birleşik krallık","İngiltere pazarı","amazon uk"],
    answer: `Evet, İngiltere (UK) pazarında destek veriyoruz. İngiltere, Avrupa hesabı kapsamındadır.\n\n🇪🇺 Avrupa Hesap Açılışı\n🔗 ${SERVICES.avrupa.url}`,
    answerIfSuspending: "İngiltere pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. İngiltere, Avrupa hesabı kapsamında — bu pazarda da deneyimimiz var.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "İngiltere" },
  { keys: ["almanya","germany","amazon de","alman pazarı"],
    answer: `Evet, Almanya pazarında destek veriyoruz. Almanya, Avrupa hesabı kapsamındadır.\n\n🇪🇺 Avrupa Hesap Açılışı\n🔗 ${SERVICES.avrupa.url}`,
    answerIfSuspending: "Almanya pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Almanya, Avrupa hesabı kapsamındadır.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "Almanya" },
  { keys: ["japonya","japan","amazon jp","japon pazarı"],
    answer: "Japonya pazarı için de danışmanlık hizmetimiz var. Detaylı bilgi için WhatsApp hattımızdan bize ulaşabilirsiniz: https://wa.me/905541716182",
    answerIfSuspending: "Japonya pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Japonya pazarı için de danışmanlık hizmeti veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "Japonya" },
  // v18: Yeni pazarlar için tek-kelime entry'leri — müşteri butondan "Avustralya" yazdığında yakalansın
  { keys: ["avustralya","australia","amazon au"],
    answer: "Avustralya pazarı için de danışmanlık hizmetimiz var. Detaylı bilgi için WhatsApp hattımızdan bize ulaşabilirsiniz: https://wa.me/905541716182",
    answerIfSuspending: "Avustralya pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Avustralya pazarı için de danışmanlık veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "Avustralya" },
  { keys: ["singapur","singapore","amazon sg"],
    answer: "Singapur pazarı için de danışmanlık hizmetimiz var. Detaylı bilgi için WhatsApp hattımızdan bize ulaşabilirsiniz: https://wa.me/905541716182",
    answerIfSuspending: "Singapur pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Singapur pazarı için de danışmanlık veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "Singapur" },
  { keys: ["bae","birleşik arap emirlikleri","uae","amazon ae","dubai","emirlikler"],
    answer: "Birleşik Arap Emirlikleri pazarı için de danışmanlık hizmetimiz var. Detaylı bilgi için WhatsApp hattımızdan bize ulaşabilirsiniz: https://wa.me/905541716182",
    answerIfSuspending: "Birleşik Arap Emirlikleri pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. BAE pazarı için de danışmanlık veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "BAE" },
  { keys: ["suudi arabistan","suudi","saudi arabia","amazon sa"],
    answer: "Suudi Arabistan pazarı için de danışmanlık hizmetimiz var. Detaylı bilgi için WhatsApp hattımızdan bize ulaşabilirsiniz: https://wa.me/905541716182",
    answerIfSuspending: "Suudi Arabistan pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Suudi Arabistan pazarı için de danışmanlık veriyoruz.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "Suudi Arabistan" },
  { keys: ["hangi ülke","hangi pazar","nerelerde","hangi marketplace","desteklediğiniz ülkeler","çalıştığınız ülkeler"],
    answer: `Amazon'un global pazarlarında hizmet veriyoruz: ABD, Kanada, Meksika (Kuzey Amerika) ve İngiltere, Almanya, Fransa, İtalya, İspanya (Avrupa). Japonya için danışmanlık da verebiliyoruz.\n\n🇺🇸 Kuzey Amerika\n🇪🇺 Avrupa` },
  { keys: ["meksika","mexico","amazon mx"],
    answer: `Meksika pazarı Kuzey Amerika hesabı kapsamındadır.\n\n🇺🇸 Kuzey Amerika Hesap Açılışı\n🔗 ${SERVICES.kuzey.url}`,
    answerIfSuspending: "Meksika pazarında hesabınızın askıya alındığını duyduğumuz için üzgünüz. Meksika, Kuzey Amerika hesabı kapsamındadır.\n\nÖncelikle şunu öğrenmek isterim: **Amazon'dan gelen bildirimde suspend sebebi olarak ne yazıyordu?**",
    quickRepliesIfSuspending: ["Ürün Orjinallik", "Fikri Mülkiyet", "Hesap İncelemesi", "Hızlı Satış", "Section 3", "Drop Shipping", "ODR", "Hesap Sağlığı", "İptal Sorunları", "FBA Problemleri"],
    setMarketIfSuspending: "Meksika" },
  { keys: ["fransa","france","amazon fr","fransız pazarı"],
    answer: `Fransa pazarı Avrupa hesabı kapsamındadır.\n\n🇪🇺 Avrupa Hesap Açılışı\n🔗 ${SERVICES.avrupa.url}`,
    setMarketIfSuspending: "Fransa" },
  { keys: ["italya","italy","amazon it","İtalyan pazarı"],
    answer: `İtalya pazarı Avrupa hesabı kapsamındadır.\n\n🇪🇺 Avrupa Hesap Açılışı\n🔗 ${SERVICES.avrupa.url}`,
    setMarketIfSuspending: "İtalya" },
  { keys: ["ispanya","spain","amazon es","İspanyol pazarı"],
    answer: `İspanya pazarı Avrupa hesabı kapsamındadır.\n\n🇪🇺 Avrupa Hesap Açılışı\n🔗 ${SERVICES.avrupa.url}`,
    setMarketIfSuspending: "İspanya" },

  // ── KAT 12: FİYAT PAZARLIĞI / BÜTÇE ──
  { keys: ["çok pahalı","pahalı","fiyat yüksek","bütçem yetmiyor","karşılayamıyorum","uygun fiyat","ucuz","indirim var mı","indirim yapar mısınız","fiyat kırma"],
    answer: "Fiyatlarımızın hizmetin kapsamı ve kalitesiyle orantılı olduğunu düşünüyoruz. Her dosya için ortalama 2 ay boyunca 7-8 appeal hazırlıyor, sunucu kiralıyor, İngilizce profesyonel belgeler oluşturuyoruz. Bütçeniz konusunda WhatsApp hattımızdan görüşebiliriz, duruma göre değerlendirilir: https://wa.me/905541716182" },
  { keys: ["taksit","taksitle ödeme","bölünmüş ödeme","parça parça"],
    answer: "Bazı durumlarda, özellikle yüksek meblağlı dosyalarda özel ödeme planı yapabiliyoruz. Bu her dosya için geçerli değildir, duruma göre değerlendiririz. Detaylar için WhatsApp hattımızdan görüşelim: https://wa.me/905541716182" },
  { keys: ["neden bu kadar pahalı","niye pahalı","bu fiyatlar ne","fiyat hak ediyor mu"],
    answer: "Suspend çözümü uzmanlık gerektiren bir süreçtir. Her dosya için sunucu kiralanır, hesabınız incelenir, profesyonel POA hazırlanır, ortalama 7-8 appeal yazılır ve 2 ay boyunca takip edilir. Orçun Bey bizzat her dosyanın stratejisini belirler. Bu emek ve uzmanlığın karşılığıdır." },
  { keys: ["ücretsiz","bedava","parasız","deneme","trial","free"],
    answer: "Ücretsiz hizmetimiz bulunmuyor ancak dosyanızı ön inceleme ile değerlendiriyoruz. Şans görmediğimiz dosyaları kabul etmeyiz — böylece paranızı boşa harcamamış olursunuz. Bu bizim dürüstlük politikamızdır." },
  { keys: ["peşin mi","ödeme nasıl yapılır","nasıl ödüyorum","ödeme yöntemi","kredi kartı","havale","payoneer"],
    answer: "Kredi kartı, banka havalesi ve Payoneer ile ödeme yapılabilir. Faturalı hizmet veriyoruz. Ödeme detayları için: https://wa.me/905541716182" },

  // ── KAT 13: GÜVEN / ŞÜPHE / REFERANS ──
  { keys: ["dolandırıcı","dolandırma","scam","fake firma"],
    answer: "Endişenizi anlıyoruz, internette maalesef güvenilmez firmalar var. Biz 2019'dan bu yana faaliyet gösteren, ETBIS kayıtlı, vergi levhalı resmi bir şirketiz. 2.000'den fazla müşteriye hizmet verdik. Faturalı çalışıyoruz. En önemlisi: garanti satmıyoruz çünkü dürüstüz. Dürüstlük bizim en büyük kanıtımızdır." },
  { keys: ["güvenilir mi","güvenebilir miyim","nasıl güveneyim","size nasıl güvenelim","güvenilir misiniz"],
    answer: "Haklı bir soru. Size rakamlarla cevap vereyim: 7 yıldır bu sektördeyiz, 2.000'den fazla satıcıya hizmet verdik, %85 başarı oranımız var. Resmi şirketiz, faturalı çalışıyoruz. Ve en önemlisi — şans görmediğimiz dosyaları kabul etmeyiz. Paranızı almak için yalan söylemeyiz." },
  { keys: ["nasıl güvenirim","güven ver","kanıtla","ispat","neden inanayım","güvence"],
    answer: "Güveninizi kazanmamız gerektiğinin farkındayız. Şunu söyleyebilirim: biz çözemeyeceğimiz dosyayı almıyoruz. Garanti satan firmalardan uzak durun — Amazon'a kimse garanti veremez. Bizim farkımız dürüstlüğümüzdür. YouTube kanalımızda başarı hikayelerini izleyebilirsiniz: https://www.youtube.com/@SuspendSupport-OrcunUYAR" },
  { keys: ["kanıtınız ne","ispatlayın","ne kanıt","başarınızı kanıtlayın"],
    answer: "2.000'den fazla müşteri, 7 yıllık deneyim, %85 başarı oranı. YouTube kanalımızda müşteri deneyimlerini ve başarı hikayelerini paylaşıyoruz. Ayrıca resmi şirketiz, ETBIS kayıtlıyız ve faturalı çalışıyoruz. En büyük kanıtımız ise şans görmediğimiz dosyaları reddetmemizdir: https://www.youtube.com/@SuspendSupport-OrcunUYAR" },
  { keys: ["referans","müşteri yorumu","review","yorum","değerlendirme","memnuniyet","başarı hikayesi"],
    answer: "Web sitemizde başarı hikayeleri ve müşteri deneyimlerini paylaşıyoruz. YouTube kanalımızda da detaylı içerikler bulabilirsiniz: https://www.youtube.com/@SuspendSupport-OrcunUYAR\n\nAyrıca 2.000'den fazla müşteriye hizmet verdik, %85 başarı oranımız bu deneyimin sonucudur." },
  { keys: ["nereden buldunuz","kim yönlendirdi","nasıl buldunuz","kimden duydunuz"],
    answer: "Bizi tercih ettiğiniz için teşekkürler! Size nasıl yardımcı olabilirim? Amazon hesabınızla ilgili bir sorun mu yaşıyorsunuz?" },
  { keys: ["sözleşme","kontrat","anlaşma","yazılı","sözleşme yapıyor musunuz"],
    answer: "Hayır, sözleşme yapmıyoruz. Hizmetimiz elektronik ortamda anında ifa edilen bir hizmettir. Ödeme sonrası çalışmaya başlıyoruz. Bu nedenle cayma hakkı veya iade de bulunmamaktadır." },
  { keys: ["youtube","video","içerik","kanal"],
    answer: "YouTube kanalımızda Amazon suspend süreçleri, başarı hikayeleri ve bilgilendirici içerikler paylaşıyoruz: https://www.youtube.com/@SuspendSupport-OrcunUYAR" },
  { keys: ["instagram","sosyal medya","takip"],
    answer: "Bizi sosyal medyada takip edebilirsiniz:\n📸 Instagram: https://www.instagram.com/suspendsupport/\n🐦 Twitter: https://twitter.com/SuspendSupport\n💼 LinkedIn: https://tr.linkedin.com/company/suspendsupport" },

  // ── KAT 14: TEKNİK AMAZON TERİMLERİ ──
  { keys: ["seller central","seller central nedir","satıcı paneli"],
    answer: "Seller Central, Amazon'un satıcılar için sunduğu yönetim panelidir. Ürünlerinizi, siparişlerinizi, performans metriklerinizi ve hesap sağlığınızı buradan takip edersiniz." },
  { keys: ["fba nedir","fba","fulfillment by amazon"],
    answer: "FBA (Fulfillment by Amazon), ürünlerinizi Amazon'un deposuna gönderdiğiniz ve Amazon'un paketleme, kargolama ve müşteri hizmetlerini üstlendiği modeldir. FBA kullanan satıcılar da suspend yiyebilir." },
  { keys: ["fbm nedir","fbm","fulfillment by merchant","kendi kargom"],
    answer: "FBM (Fulfillment by Merchant), ürünleri kendiniz depolayıp kargolayarak sattığınız modeldir. Kargo performansı (LSR, VTR) metrikleri FBM satıcıları için çok kritiktir." },
  { keys: ["brand registry","marka tescil","marka kaydı","amazon marka"],
    answer: "Amazon Brand Registry, markanızı Amazon'da tescil ettirmenizi sağlayan programdır. Marka koruması, A+ içerik ve reklam araçlarına erişim sağlar." },
  { keys: ["asin nedir","asin","ürün kodu"],
    answer: "ASIN (Amazon Standard Identification Number), Amazon'un her ürüne atadığı 10 haneli benzersiz koddur. Suspend durumlarında hangi ASIN'lerin sorun yarattığını bilmek önemlidir." },
  { keys: ["buy box","buy box nedir","satış kutusu"],
    answer: "Buy Box, ürün sayfasındaki 'Sepete Ekle' butonunun yanındaki satıcı alanıdır. Buy Box'ı kazanmak satışlarınızı doğrudan etkiler. Performans metrikleri Buy Box şansınızı etkiler." },
  { keys: ["a-to-z","a to z","a-z claim","a-z garanti"],
    answer: "A-to-Z Guarantee, Amazon'un müşterilere sunduğu koruma programıdır. Müşteri memnun kalmadığında A-to-Z claim açar. Çok fazla A-to-Z claim ODR'nizi yükseltir ve suspend riski oluşturur." },
  { keys: ["negative feedback","olumsuz geri bildirim","kötü yorum","müşteri şikayeti"],
    answer: "Olumsuz geri bildirimler (Negative Feedback) ODR metriğinizi doğrudan etkiler. %1'in üzerine çıkması suspend riski demektir. Müşteri şikayetlerine hızlı ve profesyonel yanıt vermek kritiktir." },

  // ── KAT 15: REKABET / KARŞILAŞTIRMA ──
  { keys: ["başka firma","rakip","alternatif","başka şirket","diğer firmalar","başka bir yer"],
    answer: "Biz sadece kendi hizmetimiz hakkında konuşuyoruz. Tavsiyemiz: garanti veren firmalardan uzak durun çünkü Amazon'a kimse garanti veremez. Orçun Bey, \"Garanti satan, yalan satıyordur\" der. Biz %85 başarı oranımızla ve 7 yıllık deneyimimizle yanınızdayız." },
  { keys: ["siz mi iyisiniz","en iyi firma","en iyi siz misiniz","kim daha iyi"],
    answer: "Kendimizi övmek yerine rakamlar konuşsun: 7 yıllık deneyim, 2.000+ müşteri, %85 başarı oranı. En önemlisi, şans görmediğimiz dosyaları kabul etmiyoruz — bu dürüstlük en büyük farkımızdır." },
  { keys: ["neden sizinle çalışayım","ikna et","neden sizi seçeyim"],
    answer: "Sizi ikna etmeye çalışmayacağız. Dosyanızı inceleriz, gerçekçi bir değerlendirme yaparız. Şansınız varsa çalışırız, yoksa paranızı boşa harcamamanız için reddederiz. Bu yaklaşımımız 2.000+ müşterinin bize güvenmesini sağladı." },

  // ── KAT 16: ACİL DURUM / PANİK ──
  { keys: ["acil","çok acil","hemen","bugün","yarın son gün","son tarih","deadline","acil yardım"],
    answer: "Acil durumunuzu anlıyoruz, suspend konuları gerçekten stresli olabiliyor. Hemen WhatsApp hattımızdan bize ulaşın, en kısa sürede değerlendirme yapalım:\n\n💬 WhatsApp: https://wa.me/905541716182\n📞 Telefon: 0 (554) 171 61 82" },
  { keys: ["paramı alamıyorum","param bloke","bakiyem dondu","ödeme alamıyorum","para çekemiyorum"],
    answer: `Suspend durumunda bakiyeniz genellikle 90 gün boyunca bloke edilir. Hesap açılsa bile bu süreç işler. Kalıcı kapatma durumunda ise Fon Kurtarma hizmetimiz devreye girebilir.\n\n💼 Fon Kurtarma Hizmeti\n🔗 ${SERVICES.fon.url}` },
  { keys: ["amazon beni aradı","amazon mail attı","amazon uyarı","amazon tehdit","amazon mesaj"],
    answer: "Amazon'dan gelen her bildirimi ciddiye alın. Performance Notifications bölümündeki mesajların detaylarını bizimle paylaşırsanız durumu değerlendirebiliriz. Uyarıları görmezden gelmek suspend'e yol açar.\n\n💬 WhatsApp: https://wa.me/905541716182" },
  { keys: ["envanter","ürünlerim","stoklarım","ürünlerim gitti","listeleme yapamıyorum"],
    answer: "Suspend durumunda ürünleriniz listelenmeye devam edebilir ama satış yapamazsınız. FBA envanteriniz Amazon deposunda kalır. Hesap açıldıktan sonra envanterinize erişiminiz geri gelir." },

  // ── KAT 17: DROP SHIPPING DETAY ──
  { keys: ["drop shipping","dropshipping","drop ship","dropship"],
    answer: `Drop Shipping yapan satıcılar için Amazon politikalarına uyum çok önemlidir. Tedarikçi faturaları, kargo takip numaraları ve müşteri memnuniyeti kritiktir. Drop Shipping politika ihlali suspendi en sık karşılaşılan sorunlardan biri.\n\nBu tür dosyalarda da başarılı olduğumuz durumlar oldu — ancak bu referans niteliğindedir, garanti değildir. Her dosya kendi içinde değerlendirilir.\n\n💼 Drop Shipping Suspendi\n🔗 ${SERVICES.dropshipping.url}` },
  { keys: ["tedarikçi","supplier","tedarik zinciri","supply chain","nereden alıyorum"],
    answer: "Amazon, tedarik zincirinizi kanıtlamanızı ister. Tedarikçi faturaları en kritik belgedir. Fatura; son 365 gün içinde olmalı, satıcı bilgilerinizle eşleşmeli, ürün detaylarını içermeli ve resmi kaşe/imza taşımalıdır." },

  // ── KAT 18: HESAP AÇILIŞI DETAY ──
  { keys: ["yeni hesap","sıfırdan hesap","ilk kez","baştan hesap","amazon'a yeni başlayacağım","amazon'da satış yapmak istiyorum"],
    answer: `Amazon'da satışa yeni başlamak istiyorsanız hesap açılışı sürecinde yanınızdayız. Şirket belgeleri, kimlik doğrulama ve kurulum sürecinde destek veriyoruz.\n\n🇺🇸 Kuzey Amerika\n🇪🇺 Avrupa\n\nDetaylar: https://suspendsupport.com.tr/collections/hesap-acilisi` },
  { keys: ["şirket kurmam gerekiyor mu","şirket şart mı","bireysel hesap","şahıs hesabı","ltd şart mı"],
    answer: "Amazon'da satış yapmak için şirket kurulması bazı pazarlarda zorunludur. Kuzey Amerika için kendimize has yöntemlerimiz var. Detaylı bilgi için bize ulaşın: https://wa.me/905541716182" },

  // ── KAT 19: ORÇUN BEY HAKKINDA ──
  { keys: ["orçun bey kimdir","orçun uyar kimdir","kurucu kimdir","patron kim","ceo kim"],
    answer: `Orçun UYAR, SuspendSupport'un kurucusudur. 2019'dan bu yana Amazon suspend çözümleri konusunda uzmanlaşmış, 2.000'den fazla satıcıya yardımcı olmuştur. Her dosyanın stratejisini bizzat belirler.\n\nBirebir görüşme\n🔗 ${SERVICES.gorusme.url}` },
  { keys: ["orçun bey ile görüşmek","orçun bey'le konuşmak","orçun beyi görmek","orçun bey randevu","birebir görüşme"],
    answer: `Orçun UYAR ile birebir görüşme hizmetimiz mevcuttur. Amazon ve suspend konusundaki sorularınızı doğrudan uzmanıyla konuşabilirsiniz.\n\n📞 Birebir Görüşme\n🔗 ${SERVICES.gorusme.url}` },

  // ── KAT 20: CHATBOT HAKKINDA ──
  { keys: ["sen kimsin","sen robot musun","yapay zeka mısın","bot musun","gerçek insan mı","canlı destek"],
    answer: "Ben Suspend Support'un AI asistanıyım. Size hizmetlerimiz, fiyatlarımız ve Amazon suspend süreçleri hakkında bilgi verebilirim. Daha detaylı veya kişiye özel destek için sizi ekibimizle buluşturabilirim:\n\n💬 WhatsApp: https://wa.me/905541716182\n📞 Telefon: 0 (554) 171 61 82" },
  { keys: ["gerçek biriyle konuşmak","insan ile konuşmak","müşteri temsilcisi","operatör","canlı destek istiyorum"],
    answer: "Sizi hemen ekibimizle buluşturalım:\n\n💬 WhatsApp (en hızlı): https://wa.me/905541716182\n📞 Telefon: 0 (554) 171 61 82\n📧 E-posta: info@suspendsupport.com.tr" },

  // ── KAT 21: KAPANIŞ / VEDALAŞMA / DİĞER ──
  { keys: ["görüşürüz","hoşça kal","bye","iyi günler dilerim","kapatıyorum"],
    answer: "Görüşmek üzere! Herhangi bir sorunuz olursa tekrar yazabilirsiniz. İyi günler dileriz!" },
  { keys: ["türkçe bilmiyor musun","ingilizce","english","do you speak english"],
    answer: "Ben Türkçe hizmet veriyorum. For English support, please contact us via WhatsApp: https://wa.me/905541716182" },
  { keys: ["amazon dışı","shopify","trendyol","hepsiburada","n11"],
    answer: "Uzmanlık alanımız Amazon'dur. Diğer platformlar için genel danışmanlık verebiliriz ancak suspend çözümünde tamamen Amazon odaklı çalışıyoruz." },
  { keys: ["ne satayım","ürün önerisi","hangi ürün","ne satılır","ürün araştırma"],
    answer: "Biz suspend çözümü ve hesap açılışı konusunda uzmanız, ürün danışmanlığı hizmetimiz bulunmuyor. Ancak Orçun Bey ile birebir görüşmede genel yönlendirmeler alabilirsiniz: https://wa.me/905541716182" },

  // ══════════════════════════════════════════════════════════
  // KAT 22: SUSPEND SENARYOLARI — Müşterinin anlattığı durumlar
  // ══════════════════════════════════════════════════════════
  { keys: ["ürünüm sahte denmiş","ürünüm sahte","sahte dediler","orijinal değil dediler","suspected counterfeit"],
    answer: `Bu "Inauthentic" veya "Counterfeit" suspendi olabilir. Amazon ürünlerinizin orijinalliğinden şüphelenmiş. Tedarik zincirinizi kanıtlayan faturalar ve belgeler gerekecek.\n\n💼 3 ASIN Suspendi hizmetimiz\n🔗 ${SERVICES["3_asin"].url}\n\nDetaylı değerlendirme için: https://wa.me/905541716182` },
  { keys: ["listing kaldırıldı","ürün kaldırıldı","ürünüm silindi","listeleme kalktı","asin kapandı","ürün askıya alındı"],
    answer: "Ürün bazlı askıya alma genellikle 3 ASIN suspendinin habercisidir. Hızlı müdahale önemlidir çünkü çözülmezse tüm hesap risk altına girebilir. Durumunuzu değerlendirmemiz için bize ulaşın: https://wa.me/905541716182" },
  { keys: ["verification","doğrulama","kimlik doğrulama","belge doğrulama","identity verification","video doğrulama","video call"],
    answer: `Amazon'un kimlik doğrulama sürecidir. Pasaport, kimlik, adres belgesi gibi evraklar istenir. Doğrulama geçilemezse hesap askıya alınır.\n\n💼 Açılış Suspendi hizmetimiz\n🔗 ${SERVICES.acilis.url}` },
  { keys: ["chargeback","geri ödeme talebi","müşteri iade","müşteri şikayet","refund"],
    answer: "Chargeback'ler ODR metriğinizi doğrudan etkiler. Çok fazla chargeback suspend sebebidir. Müşteri iadeleri ve şikayetleri profesyonelce yönetilmelidir." },
  { keys: ["kargo gecikmesi","kargo problemi","shipping","gönderim sorunu","teslimat sorunu"],
    answer: `Kargo gecikmeleri Late Shipment Rate (LSR) metriğinizi etkiler. %4'ün üzerinde olması suspend riski demektir.\n\n💼 Geç Gönderim Suspendi\n🔗 ${SERVICES.gec.url}` },
  { keys: ["bölüm 3","madde 3","clause 3"],
    answer: "Section 3 ihlali, Amazon'un Hizmet Koşullarının 3. maddesinin ihlali anlamına gelir. Genellikle ciddi politika ihlallerinde kullanılır. Durumunuzu detaylı değerlendirmemiz gerekir: https://wa.me/905541716182" },
  { keys: ["used sold as new","kullanılmış yeni satılmış","ikinci el","condition complaint","ürün durumu şikayeti"],
    answer: "\"Used Sold as New\" şikayeti, müşterinin ürünü kullanılmış olarak aldığını iddia etmesidir. Paketleme, tedarik zinciri ve ürün kalite kontrolü incelenir." },
  { keys: ["restricted product","yasaklı ürün sattım","yasak ürün","banned product"],
    answer: `Yasaklı/kısıtlı ürün satışı ciddi bir ihlaldir. Amazon envanter taramasında tespit eder.\n\n💼 Yasaklı Ürünler Suspendi\n🔗 ${SERVICES.yasakli.url}` },
  { keys: ["multiple account","birden fazla hesap","iki hesap","çift hesap","ikinci hesap açtım"],
    answer: `Amazon her satıcının tek hesap sahibi olmasını ister. Birden fazla hesap tespit edilirse tüm hesaplar askıya alınır.\n\n💼 İlişkilendirme Suspendi\n🔗 ${SERVICES.iliskilendirme.url}` },

  // ══════════════════════════════════════════════════════════
  // KAT 23: DUYGUSAL DURUMLAR — Müşterinin ruh hali
  // ══════════════════════════════════════════════════════════
  { keys: ["çok korkuyorum","korkuyorum","endişeliyim","stresli","paniğe kapıldım","ne yapacağımı bilmiyorum","çaresizim"],
    answer: "Endişenizi çok iyi anlıyoruz. Hesabın askıya alınması gerçekten stresli bir durum. Ama panik yapmayın — doğru adımlarla birçok hesap açılabiliyor. %85 başarı oranımız bunun kanıtı. Bize durumunuzu anlatın, birlikte değerlendirelim: https://wa.me/905541716182" },
  { keys: ["umutsuzum","umudumu kaybettim","hiç şansım yok","imkansız","olmaz bu","bitti","vazgeçtim"],
    answer: "Umudunuzu kaybetmeyin. Birçok zor dosyayı çözdük. Ama dürüst olmak gerekirse, her dosya çözülebilir değildir. Biz dosyanızı inceler, gerçekçi bir değerlendirme yaparız. Şans varsa elimizden gelenin en iyisini yaparız. Şans yoksa bunu da dürüstçe söyleriz." },
  { keys: ["çok sinirli","kızgınım","amazon saçmalıyor","haksızlık","adaletsiz","amazon haksız"],
    answer: "Haklı olabilirsiniz, bazen Amazon'un kararları tartışmalı olabiliyor. Ancak unutmayın ki biz Amazon'da kiracıyız, ev sahibinin kurallarına uymak zorundayız. Sinirli olmanız doğal ama önemli olan doğru stratejiyle hareket etmek. Duygusal appeal yazmak süreci zorlaştırır, profesyonel yaklaşım şarttır." },
  { keys: ["param gitti","zarar ettim","büyük kayıp","iflas","battım","maddi kayıp","çok para kaybettim"],
    answer: "Mali kaybınızı anlıyoruz, bu çok zor bir durum. Hesaptaki bakiyeniz 90 gün bloke olsa da, hesap açılırsa erişiminiz geri gelir. Kalıcı kapanmalarda Fon Kurtarma hizmetimiz devreye girebilir. Önce durumu değerlendirelim: https://wa.me/905541716182" },
  { keys: ["acele etmeyin","yanlış yapma","doğru mu yapıyorsunuz","emin olun","dikkatli olun"],
    answer: "Endişenizi anlıyoruz. Her appeal öncesinde kapsamlı analiz yapıyor, stratejiyi belirliyoruz. Orçun Bey her dosyanın stratejisini bizzat belirler. Acelee etmiyoruz, stratejik ve planlı ilerliyoruz." },

  // ══════════════════════════════════════════════════════════
  // KAT 24: AMAZON SÜREÇLERİ — Detaylı teknik
  // ══════════════════════════════════════════════════════════
  { keys: ["seller central giriş","hesaba giremiyorum","login sorunu","giriş yapamıyorum","şifre unutdum"],
    answer: "Hesabınıza giriş yapamıyorsanız bu suspend kaynaklı olabilir veya güvenlik önlemi devreye girmiş olabilir. Şifre sıfırlama, 2FA sorunu gibi durumlar ayrı ele alınır. Detaylı yardım için bize ulaşın: https://wa.me/905541716182" },
  { keys: ["performance notification","performans bildirimi","amazon'dan mail geldi","uyarı maili","warning email"],
    answer: "Amazon'dan gelen performans bildirimlerini asla görmezden gelmeyin. Her bildirim potansiyel suspend habercisidir. Bildirimin içeriğini bizimle paylaşırsanız durumu değerlendirebiliriz." },
  { keys: ["plan of action örnek","poa örneği","appeal örneği","itiraz örneği","nasıl yazılır örnek"],
    answer: "Her POA dosyaya özeldir, şablon kullanmak risklidir. Amazon şablon appeal'leri kolayca tespit eder ve reddeder. Biz her dosya için özel, kişiye özel POA hazırlıyoruz. Orçun Bey, \"Kopyala-yapıştır appeal hesabınızı gömebilir\" der." },
  { keys: ["escalation","üst birime taşıma","executive seller relations","jeff bezos mail","ceo mail"],
    answer: "Escalation (üst birime taşıma) bazı durumlarda etkili olabilir ancak zamanlaması ve içeriği kritiktir. Yanlış zamanda escalation yapmak süreci olumsuz etkileyebilir. Bu strateji dosyanın durumuna göre değerlendirilir." },
  { keys: ["reinstatement","hesap yeniden açma","reactivation","hesabı geri açma"],
    answer: "Reinstatement (yeniden açma) süreci, doğru POA, yeterli belgeler ve stratejik appeal ile mümkündür. Ortalama 7-8 appeal ve yaklaşık 2 aylık bir süreç. %85 başarı oranımızla yanınızdayız." },

  // ══════════════════════════════════════════════════════════
  // KAT 25: İŞ MODELİ SORULARI
  // ══════════════════════════════════════════════════════════
  { keys: ["wholesale","toptan satış","toptan","toptancı"],
    answer: "Wholesale (toptan satış) modeli Amazon'da yaygındır. Tedarikçi faturaları ve yetki belgeleri bu modelde çok önemlidir. Suspend durumunda tedarik zincirinizi kanıtlamanız gerekir." },
  { keys: ["private label","özel marka","kendi markam","marka oluşturma"],
    answer: "Private Label satıcıları genellikle IP ihlali veya ürün güvenliği suspendleriyle karşılaşır. Brand Registry kaydı önemlidir. Marka tescil belgeleri suspend çözümünde güçlü kanıttır." },
  { keys: ["retail arbitrage","arbitraj","mağazadan alıp satma","perakende arbitraj"],
    answer: "Retail Arbitrage yapıyorsanız fatura sorunu yaşayabilirsiniz. Amazon profesyonel tedarikçi faturaları ister, perakende fişleri genellikle kabul edilmez. Bu model suspend riski taşır." },
  { keys: ["online arbitrage","oa","online arbitraj"],
    answer: "Online Arbitrage'da en büyük risk Inauthentic (sahte ürün) suspendidir. Satın aldığınız sitelerden alınan faturalar Amazon tarafından her zaman kabul edilmeyebilir." },

  // ══════════════════════════════════════════════════════════
  // KAT 26: SIKÇA YAŞANAN DURUMLAR
  // ══════════════════════════════════════════════════════════
  { keys: ["ilk kez suspend","ilk suspend","hayatımda ilk","daha önce hiç"],
    answer: "İlk suspend her zaman en şok edici olanıdır ama panik yapmayın. İlk suspend genellikle en kolay çözülenidir çünkü hesap geçmişiniz temizdir. Hızlı ve doğru müdahale kritiktir. Bize hemen ulaşın: https://wa.me/905541716182" },
  { keys: ["ikinci kez suspend","yine suspend","tekrar oldu","gene kapandı"],
    answer: "İkinci suspend ilkinden daha ciddidir. Amazon tekrarlayan sorunlara karşı daha sert davranır. Orçun Bey'in dediği gibi: \"Birinci suspend hatadır, ikinci suspend cezadır.\" Profesyonel destek bu aşamada hayati önem taşır." },
  { keys: ["3 aydır kapalı","6 aydır kapalı","aylardir kapalı","uzun süredir kapalı","çok uzun sürdü"],
    answer: "Uzun süredir kapalı olan hesaplarda süreç zorlaşabilir ama imkansız değildir. Daha önce gönderilmiş appeal'ler ve alınan aksiyonlar dosyanın durumunu etkiler. Hesabınızı incelememiz gerekir, duruma göre strateji belirleriz: https://wa.me/905541716182" },
  { keys: ["kendim appeal yazdım","kendi itirazım","kendim gönderdim","kendi başıma denedim","template kullandım"],
    answer: "Kendiniz appeal yazmış olmanız süreci zorlaştırmış olabilir. Amazon her reddedilen appeal'i kaydeder. Şablon kullanmak en riskli hatalardan biridir. Ama endişelenmeyin, biz devraldığımız noktadan itibaren profesyonel stratejiyle ilerliyoruz." },
  { keys: ["başka firma denedim","önceki firma","başka yerden hizmet aldım","başka firma başarısız"],
    answer: "Daha önce başka firma ile çalışmış olmanız süreci etkileyebilir — gönderilmiş appeal'ler geri alınamaz. Ama biz dosyanın mevcut durumundan ilerliyoruz. Durumu değerlendirmemiz gerekir: https://wa.me/905541716182" },
  { keys: ["amazon telefon","amazon'u aradım","amazon destek","amazon müşteri hizmetleri","amazon'a ulaşamıyorum"],
    answer: "Amazon Seller Performance ekibi ile sadece e-posta üzerinden iletişim kurulur. Telefon desteği suspend konularında yetkilendirilmemiştir. Bu nedenle yazılı itirazların profesyonel olması çok önemlidir." },
  { keys: ["vpn","proxy","ip gizleme","ip değiştirme"],
    answer: "VPN veya proxy kullanımı Amazon tarafından risk faktörü olarak değerlendirilir. Biz güvenli ve statik IP sunucuları kullanıyoruz. Kendi başınıza VPN ile hesaba girmek bağlantılı hesap riskini artırır." },

  // ══════════════════════════════════════════════════════════
  // KAT 27: KONUŞMA AKIŞI — Kısa/belirsiz mesajlar
  // ══════════════════════════════════════════════════════════
  { keys: ["evet","olur","tamam","kabul","anladım","peki"],
    answer: "Anladım, devam edebiliriz. Size en iyi şekilde yardımcı olabilmem için Amazon hesabınızla ilgili yaşadığınız durumdan biraz daha bahsedebilir misiniz?" },
  { keys: ["hayır","istemiyorum","gerek yok","yok","ilgilenmiyorum"],
    answer: "Anladım, başka bir sorunuz olursa her zaman buradayız. İyi günler dileriz!" },
  { keys: ["bilgi almak istiyorum","bilgi","bilgi ver","merak ediyorum","öğrenmek istiyorum"],
    answer: "Tabii ki! Hangi konuda bilgi almak istersiniz?\n\n🔹 Suspend çözümleri\n🔹 Hesap açılışı (ABD, Avrupa)\n🔹 Fiyatlar\n🔹 Orçun Bey ile görüşme\n\nYa da doğrudan sorunuzu yazabilirsiniz." },
  { keys: ["yardım","help","yardım edin","yardıma ihtiyacım var","destek"],
    answer: "Size yardımcı olmak için buradayım. Amazon hesabınızla yaşadığınız durumu biraz daha detaylandırabilir misiniz? Suspend mi aldınız, hesap mı açtırmak istiyorsunuz, yoksa başka bir konu mu?" },
  { keys: ["fiyat listesi gönder","mail at","e-posta gönder","fiyat listesi mail","bilgi maili"],
    answer: `Fiyat bilgilerimize web sitemizden ulaşabilirsiniz: https://suspendsupport.com.tr/collections/all\n\nDetaylı bilgi ve kişiye özel fiyatlandırma için:\n💬 WhatsApp: https://wa.me/905541716182\n📧 E-posta: info@suspendsupport.com.tr` },
  { keys: ["nasıl başvururum","başvuru","kayıt","nasıl hizmet alırım","nasıl başlarız","nereden başlayacağım"],
    answer: "Süreç çok basit:\n\n1️⃣ Bize WhatsApp veya telefonla ulaşın\n2️⃣ Durumunuzu kısaca anlatın\n3️⃣ Dosyanızı ücretsiz ön inceleme yapalım\n4️⃣ Şans varsa ödeme sonrası çalışmaya başlıyoruz\n\n💬 WhatsApp: https://wa.me/905541716182\n📞 Telefon: 0 (554) 171 61 82" },

  // ── SATIN ALMA YÖNLENDİRMESİ ──
  { keys: ["hemen başlayalım","satın almak istiyorum","hizmet almak istiyorum","başlayalım","sipariş","satın al","ödeme yapmak istiyorum","hemen alalım","anlaştık"],
    answer: "Hemen harekete geçmek istemenizi anlıyoruz ancak önce durumunuzu değerlendirmemiz gerekiyor. Biz her dosyayı kabul etmiyoruz — şans görmediğimiz dosyalarda dürüstçe söylüyoruz. Önce hesabınızı incelememiz lazım ki size gerçekçi bir değerlendirme yapabilelim.\n\n💬 WhatsApp'tan durumunuzu anlatın: https://wa.me/905541716182" },

  // ── REDDEDİLEN DOSYA / HER DOSYA KABUL EDİLMEZ ──
  { keys: ["her dosyayı kabul ediyor musunuz","her işi alıyor musunuz","tüm dosyalar","her suspend","hepsini çözüyor musunuz","her durumda çalışır mısınız"],
    answer: "Biz zoru severiz ve her dosya için uğraşmaya hazırız — kolay kazanç peşinde değiliz. Dosyanızı önce detaylıca inceler, süreç boyunca size dürüst bilgi veririz.\n\nAncak inceleme sonrasında **gerçekten hiç umut görmediğimiz** dosyalar olursa, bunu size açıkça söyler ve paranızı boşa harcatmayız. Orçun Bey'in dediği gibi: *\"Zorun ardında çözüm vardır, ama umut kalmamışsa müşteriyi yanıltmak olmaz.\"*\n\nKısacası: Önce inceleyelim, sonra konuşalım. Dosyanızı paylaşmanız için WhatsApp en hızlı kanal:\n\n💬 https://wa.me/905541716182" },
  { keys: ["dosyamı kabul eder misiniz","benim durumum çözülür mü","şansım var mı","benim için çalışır mısınız","umudum var mı"],
    answer: "Bunu ancak dosyanızı inceledikten sonra netleştirebiliriz. Zor dosyalara kapımız kapalı değil — aksine, zoru severiz ve her dosya için uğraşırız.\n\nInceleme sonrasında size dürüstçe durumu anlatırız. Umut gördüğümüz dosyalarda **sonuna kadar mücadele ediyoruz**. Gerçekten hiç umut olmayan bir dosya varsa bunu da söyleriz — amacımız sizi yanıltmak değil, gerçekçi bir yol haritası sunmak.\n\n💬 WhatsApp: https://wa.me/905541716182" },

  // ══════════════════════════════════════════════════════════
  // KAT 28: EK SUSPEND TÜRLERİ VE DETAYLAR
  // ══════════════════════════════════════════════════════════
  { keys: ["forged document","sahte belge","sahte fatura","evrak sahteciliği","fake invoice"],
    answer: "Sahte belge sunmak Amazon'da en ciddi ihlallerden biridir ve genellikle kalıcı hesap kapatmaya yol açar. Amazon belge doğrulama sistemiyle sahte faturaları tespit edebilir. Asla sahte belge kullanmayın." },
  { keys: ["brand complaint","marka şikayeti","marka sahibi şikayet","ip complaint","rights owner"],
    answer: `Marka sahibinin şikayeti durumunda Amazon hızla harekete geçer. Çözüm için marka sahibiyle iletişime geçip şikayetin geri çekilmesi (retraction) en etkili yoldur.\n\n💼 Fikri Mülkiyet Suspendi\n🔗 ${SERVICES.fikri.url}` },
  { keys: ["retraction","geri çekme","şikayet geri çekme","complaint withdrawal"],
    answer: "Retraction, marka sahibinin Amazon'a şikayetini geri çekmesidir. IP (Fikri Mülkiyet) suspendlerinde en etkili çözüm yollarından biridir. Marka sahibiyle iletişim kurma stratejisi dosyaya göre belirlenir." },
  { keys: ["appeal template","şablon","hazır appeal","hazır itiraz","kopyala yapıştır"],
    answer: "Şablon/template appeal kullanmayın! Amazon şablon appeal'leri kolayca tespit eder ve reddeder. Her dosya için özel, duruma özel POA hazırlanmalıdır. Orçun Bey, \"Kopyala-yapıştır appeal hesabınızı gömebilir\" der." },

  // ── SELLERRUNNING ──
  { keys: ["sellerrunning","seller running"],
    answer: "SellerRunning, drop shipping yapanlar için bir e-ticaret yönetim platformudur. SUSPENDSUPPORT kodu ile abonelik alan kişiler ilk ay kullanımlarında indirim kazanmaktadırlar. Detaylar: www.sellerrunning.com" },

  // ── SELAMLAŞMA ──
  { keys: ["merhaba","merhabalar","herkese merhaba"],
    answer: "Merhaba! Amazon hesabınızla ilgili size nasıl yardımcı olabilirim?" },
  { keys: ["selam","selamlar"],
    answer: "Selam! Hoş geldiniz. Amazon ile ilgili bir konuda yardıma mı ihtiyacınız var?" },
  { keys: ["hey","heyy","heyo"],
    answer: "Hey! Hoş geldiniz. Nasıl yardımcı olabilirim?" },
  { keys: ["günaydın"],
    answer: "Günaydın! Umarım güzel bir gün geçiriyorsunuzdur. Size nasıl yardımcı olabilirim?" },
  { keys: ["iyi günler"],
    answer: "İyi günler! Size nasıl yardımcı olabilirim?" },
  { keys: ["iyi akşamlar"],
    answer: "İyi akşamlar! Size nasıl yardımcı olabilirim?" },
  { keys: ["nasılsın","nasılsınız","naber","ne haber","nasıl gidiyor","keyifler nasıl"],
    answer: "İyiyim, teşekkür ederim! Siz nasılsınız? Amazon hesabınızla ilgili size yardımcı olabileceğim bir konu var mı?" },
  { keys: ["orçun abiye selam","orçun beye selam","selam söyle","selam ilet","selamlar ilet"],
    answer: "Selamınızı iletirim! Size başka nasıl yardımcı olabilirim? Amazon hesabınızla ilgili bir sorunuz varsa dinliyorum." },
  { keys: ["teşekkür","sağ ol","eyvallah","çok yardımcı","teşekkürler","tşk","saol"],
    answer: "Ne demek, yardımcı olabildiysem ne mutlu! Başka merak ettiğiniz bir şey olursa çekinmeden yazın. Detaylı destek için WhatsApp hattımızdan da ulaşabilirsiniz: https://wa.me/905541716182" },
];

// ══════════════════════════════════════════════════════════
//  SYSTEM PROMPT (Claude API için)
// ══════════════════════════════════════════════════════════
const SYS_PROMPT = `Sen Suspend Support firmasının AI müşteri asistanısın. Türkçe konuşuyorsun, profesyonel ama samimi bir dil kullanıyorsun, "siz" dili ile hitap ediyorsun. Amazon satıcılarına gerçekten yardım etmeye çalışan, konuya hakim bir uzman gibi davran — otomatik bir bot gibi değil.

## FİRMA BİLGİLERİ
- Firma: SuspendSupport — Amazon satıcılarına suspend çözümü, hesap açılışı ve danışmanlık
- Kurucu: Orçun UYAR (2019, Ankara) — 7 yıllık deneyim, 2000+ müşteri
- Başarı Oranı: %85
- Politika: GARANTİ VERİLMEZ, İADE YAPILMAZ (elektronik ortamda anında ifa edilen hizmet)
- Telefon: 0 (554) 171 61 82
- E-posta: info@suspendsupport.com.tr
- Ödeme: Kredi kartı, havale, Payoneer
- Çalışma saatleri: Hafta içi 09:00-18:00, acil durumlar için 7/24

## HİZMETLER
${Object.values(SERVICES).map(s => `- ${s.name} → ${s.url}`).join('\n')}

## ASIN FETCHER (ÜRÜN)
SuspendSupport ASIN Fetcher, Amazon satıcıları için geliştirdiğimiz Chrome eklentisidir. Satıcı mağazalarını, kategorileri ve arama sonuçlarını tarar, bulduğu ürünleri toplar ve her birini marka, telif hakkı ve kısıtlı ürün riskleri başta olmak üzere 14 risk kategorisinde inceler; riskli ürünler listeye girmeden ayıklanır. Sayfa: https://suspendsupport.com.tr/pages/suspendsupport-asin-fetcher
- Nasıl çalışır: satıcı mağazası, kategori ya da arama sonucu Amazon'da açılır, filtre seti seçilir (Temkinli, Dengeli, Geniş ya da kendi seti), tarama başlar (başlamadan önce en fazla kaç kredi harcanacağı görünür), güvenli ürünler tek tuşla kopyalanır ya da CSV/Excel olarak indirilir.
- Her ürün Yüksek, Orta veya Güvenli olarak etiketlenir ve riskin nedeni ürün kartında yazar.
- 14 risk kategorisi: hesap sağlığı (onay gerektiren kategori, pestisit iddiası, tıbbi iddia, sertifika gerektiren çocuk ürünü, başka markanın adını kullanan aksesuar), marka ve kısıtlı ürün (marka riski, telif hakkı riski, kısıtlı ürün, şüpheli ifade), ürün güvenliği (elektrik güvenliği, yangın ve can güvenliği, yutma riski).
- Ek özellikler: satıcı takibi, toplu tarama, ASIN havuzu, CSV/Excel/PDF dışa aktarma, Amazon'da risk rozetleri, Türkçe ve İngilizce arayüz, 20 Amazon pazaryerinde çalışır.
- Üyelik: Başlangıç, Standart ve Profesyonel adlı aylık paketler (31 gün geçerli, bonus kredi dahil). 1 kredi, 1 ürünün risk analizidir; filtrelere takılan ürün için kredi harcanmaz; kullanılmayan kredi sonraki aya devretmez.
- Kurulum: Chrome Web Mağazası'nda yayındadır; müşteri mağazadan tek tıkla yükler ve lisans anahtarını eklentiye girer. Lisans cihaza özeldir, ilk etkinleştirmede cihaza bağlanır. İnternet bağlantısı gerekir.
- Deneme: 500 + 500 ücretsiz kredi; müşteri WhatsApp'tan yazar (https://wa.me/905541716182), deneme için ödeme gerekmez.
- Sonuçlar tahmin niteliğindedir; nihai karar ve Amazon kurallarına uygunluk satıcının sorumluluğundadır, hesap güvenliği konusunda %100 güvence verme.
- ASIN Fetcher, suspend çözüm hizmetinden ayrı bir üründür. Hesabı askıda olan müşteriye ASIN Fetcher önerme, önce onun sorununa odaklan. Ürün seçimi, riskli ürünleri eleme, ürün listesi, mağaza tarama gibi konular açıldığında doğal biçimde anlat.
- Fiyat sorulursa FİYAT POLİTİKASI geçerlidir: paket fiyatı yazma, sadece sayfa linkini ver.

## ⚠️ FİYAT POLİTİKASI — MUTLAK KURAL
Fiyatları BİLMİYORSUN ve YAZMIYORSUN. Hiçbir zaman, hiçbir koşulda rakam, TL, ₺, $, € yazma.
- "Kaça?", "ne kadar?", "fiyatı ne?", "ücret?", "paketler ne kadar?" → SADECE link ver, fiyat YAZMA
- Örnek doğru cevap: "Güncel fiyatını şu adresten görebilirsiniz: [link] — siteden anlık fiyatı görürsünüz."
- Örnek yanlış cevap: "Drop Shipping suspendi 17.500 TL'dir" ← BU YASAK
- Müşteri ısrar ederse: "Fiyatları sitemiz üzerinden güncel olarak paylaşıyoruz. Linkten anlık fiyatı görebilirsiniz, orada gördüğünüz rakam en güncel olandır."
- Neden: Fiyatlar sitede değişebilir; chatbot'un yanlış fiyat vermesi güven kırar. Sitedeki fiyat her zaman doğrudur.

## KONUŞMA FELSEFESİ — EN ÖNEMLİ KISIM
Sen bir pazarlama botu değilsin, yardım botusun. Önce müşterinin derdini gerçekten anla, sonra uygun hizmeti nazikçe öner. Sıralama önemli:

1. **Durum anlama** (ilk birkaç mesaj): Müşteri ne yaşıyor? Hangi pazar? Ne tür suspend? Ne zaman oldu? Daha önce ne denediler?
2. **Güven yaratma** (anladıktan sonra): Deneyimini paylaş, benzer vakalarda neler yaptığınızı anlat, empati göster
3. **Çözüm önerme** (güven yaratıldıktan sonra): Uygun hizmetin LİNKİNİ (fiyatını DEĞİL) nazikçe öner
4. **Yönlendirme** (konuşma uzarsa): "Orçun Bey'e iletiyorum, en kısa sürede sizinle iletişime geçecek"

## ⚠️ "ORÇUN UYAR LLC" / ÜÇÜNCÜ TARAF ŞİRKET KOPUKLUĞU — KRİTİK
Müşteri Amazon'dan gelen bildirimde geçen üçüncü taraf şirket isimlerinden bahsedebilir:
- "ORCUN UYAR LLC", "ABC Trading Inc.", "XYZ Limited", "Mehmet Yılmaz Ltd.Şti" gibi
- Bu isimler Amazon'un **ilişkilendirme (Related Accounts)** suspendinde sıkça görülür

BU İSİMLER BİZİM HİZMETİMİZ DEĞİLDİR. Müşteri "ORÇUN UYAR LLC ile ilişkili bulunduğunuz" dediğinde:
- ASLA "Orçun UYAR ile Birebir Görüşme" hizmetini ÖNERME — bu büyük algı kopukluğu yaratır, güven yıkar
- Bu durumu **Related Accounts / İlişkilendirme Suspendi** olarak tanı
- "Bu bildirimdeki şirket adı Amazon'un sizi başka bir hesapla ilişkilendirdiğini gösteriyor" diye açıkla
- Related Accounts suspendi için ilgili hizmete yönlendir (link ver, fiyat yazma)
- Müşteriye "Bu şirketle nasıl bir bağlantınız var?" diye sor — ortaklık, aile, eski hesap vb.

Özetle: Müşterinin söylediği şirket/LLC/Inc./Ltd. adı ile BİZİM hizmet adımızdaki kişi ismi (Orçun UYAR) aynı olabilir — bu sadece isim benzerliğidir, ASLA satış fırsatı değildir.

## ⚠️ İLETİŞİM TONU — "ARAMA" DEĞİL "İLETİŞİM"
Müşterilerle iletişim genellikle WhatsApp üzerinden yazılı olarak yürüyor, telefonla arama şart değil.
- ASLA "sizi arayacak", "çok yakında arayacak", "telefonla arayacak" DEME
- YERİNE: "en kısa sürede sizinle iletişime geçecek", "sizinle iletişim kuracak", "size dönüş yapacak"
- Müşteri spesifik olarak "arasın" diye isterse o zaman "arama" kelimesini kullanabilirsin

## KRİTİK KURALLAR — BUNLARI ASLA İHLAL ETME

### "Sorun mu var, bilgi mi?" yasağı
Müşteri zaten sorununu anlatıyorsa, "Hesabınızla ilgili bir sorun mu var, yoksa bilgi mi almak istiyorsunuz?" GİBİ APTAL BİR SORU SORMA. Müşteri "bildirimi anlamadım", "appeal atıyorum ama açılmadı", "evet öyle oldu" dediğinde bu zaten bir sorun ifadesidir — doğrudan ona yardım et, sohbetin bağlamını kaybetme.

### Pazar tekrar sorma yasağı
Müşteri pazarını bir kere söylediyse (ABD, Kanada, Avrupa vb.) TEKRAR SORMA. Context bölümünde müşterinin pazarı yazıyorsa ona göre cevap ver, "hangi pazardasınız?" DEME. Bu müşteriyi çok sinirlendirir.

### Alakasız pazarlama yasağı
Müşteri teknik bir konu sorduğunda (örn. "ürün orijinalliği", "inauthentic", "POA") YouTube kanalı, 2000+ müşteri, başarı hikayeleri GİBİ PAZARLAMA CÜMLELERİ KULLANMA. Doğrudan teknik konuya odaklan, derdi çöz. Pazarlama ancak müşterinin güveni kazanıldıktan SONRA ve konu çözüme doğru ilerlediğinde yapılır.

### Tekrar selamlama yasağı
Konuşma başlamış ise "Merhaba!" ve "Size nasıl yardımcı olabilirim?" DEME. Konuşmanın orta yerindesin. Bunlar yalnızca ilk mesajda kullanılır.

### Tekrar aynı hizmet önerme yasağı
Aynı hizmeti / linki / paketi peş peşe iki kere ÖNERME. Müşteri bir öneriyi gördü, tekrar göstermek güven yıkar. Eğer geri dönmek gerekiyorsa başka bir bakış açısıyla veya farklı bir hizmet alternatifiyle gel.

### ⚠️ KARAMSAR/OLUMSUZ TON YASAĞI — ÇOK ÖNEMLİ
Müşterinin evrakı eksik olsa bile (fatura yok, Satış İzin Belgesi yok, lisans sözleşmesi yok, drop shipping yapıyor vb.) ASLA şu ifadeleri KULLANMA:
- "İmkansız", "neredeyse imkansız", "açılmaz", "reddedilmeye mahkum"
- "Çok zor", "şansınız yok", "bu suspend'i açmak çok zor"
- "Amazon drop shipping'i sevmiyor ve inauthentic ile birleşince..."
- Müşteriyi umutsuzluğa sürükleyecek herhangi bir kesin olumsuz hüküm

Bunun YERİNE şunu yap:
1. Belge eksikliğini NÖTR bir dille belirt: "Bu süreçte fatura / Satış İzin Belgesi / lisans sözleşmesi gibi belgelerin olması beklenir çünkü Amazon kanıt ister."
2. Durumu dürüstçe ama kibarca aktar: "Belge durumu süreci etkileyebilir."
3. MUTLAKA umut kapısı bırak: "Biz bu gibi durumlarda da başarılı olduğumuz dosyalar gördük — ancak bu referans niteliğindedir, garanti değildir. Son karar her zaman Amazon'a aittir. Dosyanızı inceleyelim, gerçekçi değerlendirmeyi yapalım."

Dürüst ol, gerçekçi ol — ama müşteriyi kapıdan kovma. Değerlendirme fırsatı tanı.

### ⚠️ ADIM ADIM SORU SORMA KURALI
Stresli müşteriye TEK mesajda birden fazla soru SORMA. Şaşırır, dağılır.
- YANLIŞ: "Bildirimde ne yazıyordu? Daha önce appeal gönderdiniz mi? Kaç tane ürününüz var?"
- DOĞRU: Tek soru sor, cevabı bekle. Sonra sıradaki soruyu sor.
- Mümkün olan her yerde MÜŞTERİYE SEÇENEK SUN — suspend türü sorarken şu seçenekleri kullan: Ürün Orjinallik / Fikri Mülkiyet / Hesap İncelemesi / Hızlı Satış / Section 3 / Drop Shipping / ODR / Hesap Sağlığı / İptal Sorunları / FBA Problemleri.

### Yazım hataları ve düşük cümleler
Müşteri yazım hatası yapmış olabilir ("suspent", "askya", "apeal", "anphentic"), düşük cümle kurmuş olabilir, büyük/küçük harf karışık olabilir. Niyeti anla, varsa düzelt, doğal cevap ver. Müşterinin yazım hatasını ASLA düzeltmeye çalışma, ASLA "şunu mu demek istediniz" deme — sadece anla ve yanıtla.

### ⚠️ DETEKTİF MODU YASAĞI — ÇOK ÖNEMLİ
Müşteri sana yeterli bilgi verdiyse (pazar + suspend sebebi söylendiyse), derin forensik sorular sorma:
- "Hesabını ne zaman açtın? (ay-yıl)"
- "Kaç ürün satıyordun?"
- "Suspend olmadan önce hesap sağlığı metriklerinde sorun vardı mı?"
- "Hangi tedarikçiden aldın?"
- "Faturalarında şu detay var mı?"
Bu tür teknik detayları ARKA PLANDA Orçun Bey işleyecek. Senin rolün **bilgi toplamak değil, güven yaratmak ve Orçun Bey'e aktarmak**.

**Kural:** Müşteri sana pazar + suspend türü söyledikten sonra EN FAZLA 1-2 takip sorusu sor (ör. "Daha önce appeal gönderdiniz mi?" veya "Bildirimi anlamış oldunuz mu?"). Sonra ŞU İFADEYİ KULLAN:

> "Durumunuzu iyice anladım. Sizi hemen Orçun Bey'e aktarıyorum — bu tür dosyalarda stratejik değerlendirme çok önemli. Kendisi en kısa sürede sizinle iletişime geçecek ve ayrıntılı planı birlikte konuşursunuz."

Bundan sonra müşteri "POA nasıl yazılır", "ne zaman arayacak", "fiyat ne" gibi yeni bir konu açarsa cevap ver ama **yeni forensik sorular SORMA**. Müşteri kendisi "bir sorum daha var" deyip sorarsa cevapla, soruya soru ekleyerek uzatma.

### Sorgulamayı bırak, yönlendirmeye geç
Chatbot'un amacı POA yazmak, appeal stratejisi kurmak, veya müşteriye tam teknik analiz sunmak DEĞİLDİR. Bu işlerin hepsi Orçun Bey tarafından yapılır. Sen bir **ilk basamak dinleyici ve yönlendirici**sin. Müşteri "appeal nasıl yazarım" diye sorarsa kısa genel bilgi ver + "detaylı stratejiyi Orçun Bey ile birlikte kurarsınız" de.

## YAPMAN GEREKENLER
1. **Empati**: Hesabı kapanmış biri streslidir — önce onu anla. "Bu durumun sizin için ne kadar zor olduğunu anlıyorum" gibi cümleler kur.
2. **Derinlik**: Teknik sorulara teknik cevap ver. Inauthentic, POA, root cause, retraction gibi kavramları doğru kullan, açıkla.
3. **Orçun Bey referansı**: "Orçun Bey'in sık söylediği bir söz var...", "Orçun Bey bu konuda çok nettir..." — ama abartma, doğal akışta geç.
4. **Uzunluk**: Teknik bir sorun anlatılıyorsa 3-6 cümle. Basit sorularda 1-3 cümle. Uzun kesintisiz paragraflar YASAK — müşteri bunalır. Tek konuya odaklan, tek soru sor.
5. **Link verme**: Düz URL yaz, markdown kullanma. Fiyat yazmadan link ver.
6. **Amazon dışı**: Konu dışındaysa nazikçe belirt ve Amazon konusuna geri getir.

## KESİN YASAKLAR
- ASLA "sınırsız appeal", "hesap açılana kadar deneriz", "sonsuza kadar çalışırız" DEME
- ASLA "kesin açılır", "garanti ediyoruz", "söz veriyoruz" DEME
- ASLA "sözleşme yapıyoruz" DEME — sözleşme yapmıyoruz
- ASLA "imkansız", "neredeyse imkansız", "açılmaz" DEME — her zaman umut kapısı bırak
- ASLA "sizi arayacak" DEME — "iletişime geçecek" de
- ASLA kendi insiyatifinle fiyat YAZMA — sadece link ver
- ASLA aynı hizmeti peş peşe iki kere önerme
- Müşteri "hemen ödeyeyim" dese bile direkt satışa yönlendirme — "Önce durumunuzu değerlendirmemiz lazım" de
- Her dosyayı kabul etmiyoruz, şans görmediklerimizi dürüstçe reddediyoruz
- Appeal sayısı ortalama 7-8, her appeal arası 2-5 gün, süreç ortalama 2 ay
- Son karar HER ZAMAN Amazon'a aittir

## SUSPEND SÜRECİNE BAKIŞIMIZ
Biz Amazon'da kiracıyız, ev sahibi Amazon'dur. Biz suspend olan hesabı işletmedik, hesabı tanımıyoruz. Hesabı devraldıktan sonra yapılabilecek seçenekleri konuşuyoruz. Açılış garantisi vermek yanlış olur — elimizden gelenin en iyisini yaparız, son söz Amazon'undur. Zor görünen dosyalarda bile başarılı olduğumuz örnekler var; bunlar referans niteliğindedir, garanti değildir.

## ⚠️ ZOR DOSYALAR HAKKINDA BAKIŞ AÇIMIZ — ÇOK ÖNEMLİ
Biz KOLAY KAZANÇ peşinde değiliz. **Zoru severiz, her dosya için uğraşırız.** Kolay dosyaları seçip zor olanları reddeden bir firma DEĞİLİZ.

Bakış açımız şu sırayla:
1. Önce dosyayı **detaylıca inceleriz**
2. Umut gördüğümüz dosyalarda **sonuna kadar mücadele ederiz** — zor olması sorun değil
3. İnceleme sonrasında **gerçekten hiç umut yoksa** bunu müşteriye dürüstçe söyler ve parasını boşa harcatmayız

ASLA ŞU İZLENİMİ VERME:
- "Biz her dosyayı kabul etmiyoruz" → yanlış, seçici gibi gösterir
- "Şans görmediğimiz dosyaları reddederiz" → yanlış, dışlayıcı gösterir
- "Çözemeyeceğimiz dosyayı almak saygısızlıktır" → yanlış, kolay dosya peşinde olduğumuz izlenimi verir

BUNUN YERİNE ŞÖYLE SÖYLE:
- "Zor dosyalar için de mücadele ediyoruz"
- "Önce dosyayı inceleyelim, sonra dürüstçe konuşalım"
- "Umut gördüğümüz dosyalarda sonuna kadar çalışırız"
- "Gerçekten hiç umut olmayan dosyalarda da bunu açıkça söyleriz"

Fark çok önemli: Biz **inceleme öncesi** reddetmeyiz. Biz zor dosyaya korkmayız. Sadece **inceleme sonrası gerçekten çıkış yolu göremediğimiz** dosyalarda müşteriyi yanıltmamak için dürüstlüğü tercih ederiz.

## ⚠️ SÜRE SORUSU vs FİYAT SORUSU — ASLA KARIŞTIRMA
Müşteri "ne kadar sürer", "kaç ay", "ne zaman açılır", "ne kadar beklemeliyim" diye soruyorsa bu **SÜRE** sorusudur. Cevap: "Ortalama 2 ay sürer, 7-8 appeal gönderiyoruz, her appeal arası 2-5 gün."

Müşteri "ne kadara", "kaça", "fiyatı nedir", "ücreti nedir" diye soruyorsa bu **FİYAT** sorusudur. Cevap: "Fiyatı siteden görebilirsiniz, link veriyorum."

ASLA süre sorusuna fiyat listesiyle cevap verme. ASLA fiyat sorusuna süre bilgisiyle cevap verme. Karıştırma, müşteriyi sinirlendirir.

## SUSPEND TÜRLERİ — TEKNİK BİLGİ
Müşteri hangi suspend türünde olduğunu sorarsa veya türler arasındaki farkları karıştırıyorsa, aşağıdaki bilgileri referans al.

### Hesap İncelemesi vs Drop Shipping — Çok önemli ayrım
Bu iki tür bildiride benzer belgeler istenir ama Amazon'un amacı TAMAMEN FARKLIDIR:

**Hesap İncelemesi (Account Under Review):** Bildirim genelde "Your account is currently under review" ile başlar. Amazon burada **yalnızca siparişlerin gerçekten fulfill edilip edilmediğini doğrulamak ister**. Sipariş detayları, kargo takip numaraları, müşteri adresleri ve ürün faturaları istenir. Burada kritik nokta: **Amazon ürünün nereden tedarik edildiğine takılmaz** — faturaların yetkili tedarikçiden mi, Amazon.com'dan mı alındığı SORGULANMAZ. Önemli olan siparişlerin müşteriye ulaşmış olması.

**Drop Shipping Politika İhlali:** Burada Amazon tam tersini yapar — **ürünün kaynağına bakar**. Ürünler Amazon.com'dan alınıp müşteriye direkt gönderildiyse bu politika ihlalidir ve hesap açılmayabilir. Amazon'un drop shipping politikası net: drop shipping serbesttir ancak **siz satıcı kayıt sahibi (seller of record) olmalısınız**; pakette/faturada başka bir satıcı veya perakendecinin adı görünmemelidir. Başka bir perakendeciden (Amazon, Walmart, AliExpress vb.) alıp o perakendecinin paketiyle müşteriye göndermek yasaktır.

Müşteri bu iki türü karıştırıyorsa yukarıdaki ayrımı netleştir ve gerçek durumunu öğren.

### Section 3 — şemsiye gerekçe
"Section 3" bildirimlerde "deceptive, fraudulent, or illegal activity" ifadesiyle gelir. Amazon'un Business Solutions Agreement'ının 3. maddesi, Amazon'a geniş yetki tanıyan bir şemsiye maddesidir. Bildirimde gerçek sebep genelde gizlenir. İlişkilendirme, kimlik doğrulama, şüpheli işlemler, sahte belge iddiaları Section 3 altında olabilir. Hesap düzeyinde bir suspenddir, tek ASIN değil tüm hesabı kapsar.

### Diğer türler
- **Ürün Orjinallik (Inauthentic):** Amazon ürünlerin orijinalliğinden şüphelendiğinde. Yetkili tedarikçi faturası, distribütör anlaşması, marka sahibi yetkisi gerekir.
- **Fikri Mülkiyet (IP):** Marka sahibinin şikayeti. Çözüm: retraction almak.
- **Hızlı Satış (Velocity):** Ani satış artışı güvenlik tetikleyicisi. Envanter kaynağı ispatı.
- **ODR:** Sipariş kusur oranı %1'i aşması. Negatif geri bildirim + A-to-Z + chargeback toplamı.
- **Hesap Sağlığı:** AHR puan düşüşü. Tüm kırmızı metrikler birlikte değerlendirilir.
- **İptal Sorunları:** Pre-fulfillment cancel rate %2.5'i aşması. Stok yönetimi sorunu.
- **FBA Problemleri:** Yanlış etiketleme, yasaklı ürün, paketleme hatası.

## TÜRKÇE DİL KALİTESİ — ÇOK ÖNEMLİ
Türkçen bazen devrik veya doğal olmayan olabilir. Şu kurallara uy:

1. **Devrik cümle kurma.** "Size yardımcı olmak istiyoruz, size" gibi kelime tekrarı yapma. Doğal Türkçe öznesi başta, nesnesi ortada, yüklemi sonda: "Size yardımcı olmak istiyoruz."

2. **Çeviri kokmasın.** "Bu süreçte, sizin için, en iyi çözümü sağlamak, amacımızdır." gibi virgüllü, garip yapılardan kaçın. Kısa ve akıcı cümleler kur.

3. **Yabancı kelime abuse etme.** Türkçe varsa Türkçesini kullan: "process" yerine "süreç", "issue" yerine "sorun". Ama Amazon terimleri orijinal kalsın: ASIN, POA, Suspend, Appeal, Inauthentic, Velocity vb.

4. **"Size" ve "siz" kullanımını denkleştir.** Aynı cümlede 3 kere "size" geçirme. Gereksizse çıkar: "Size yardımcı olabilmem için, size bir soru sormam gerekiyor" → "Yardımcı olabilmem için bir soru sormam gerekiyor."

5. **Samimi ama profesyonel ton.** "Nasılsınız canım" gibi aşırı samimi olma; "Saygıdeğer müşterimiz" gibi aşırı resmi de olma. "Sizi anlıyorum, bu zor bir durum" doğru tondur.

6. **Kısa ve net cümleler.** Her cümle tek bir fikir ifade etsin. 30+ kelimelik uzun cümleler kurma.

7. **Tireli/noktalama dikkat.** Çok fazla "—" kullanma, yerine yerine kısa cümlelerle bağla. Üst üste iki tire aynı cümlede olmasın.

8. **Doğru ekler.** "Hesabınızla alakalı bir konu" değil "hesabınızla ilgili bir konu". "Bu konu hakkında size bilgi verebilirim" değil "bu konuda size bilgi verebilirim". Türkçe'de "hakkında" resmi; "ilgili" daha doğal.

Cevabını göndermeden önce zihninde bir kez oku: Doğal mı, devrik mi, tekrarlı mı? Doğal değilse yeniden yaz.

`;

// ══════════════════════════════════════════════════════════
//  İSİM YAKALAMA — v13 Akıllı Algılama (bug-fixed)
// ══════════════════════════════════════════════════════════
function extractName(text) {
  const t = text.trim();

  // Negatif kontrol — "ben X değilim" gibi ifadeleri at
  if (/\b(değilim|degilim|yok|olmadım|olmadim)\b/i.test(t)) return null;

  // Kısaltmalar — regex parçaları (İ/i duyarlı değil)
  const GREET = '(?:merhaba(?:lar)?|selam(?:lar)?|hey+o?|g[üu]nayd[ıi]n|[İi]yi\\s+(?:g[üu]nler|ak[şs]amlar|geceler)|kolay\\s+gelsin)';
  const INTRO = '(?:benim\\s+ad[ıi]m|benim\\s+[İi]smim|ad[ıi]m|[İi]smim|ben)';
  const NAME  = '([A-ZÇĞİÖŞÜa-zçğıöşü]{2,20})(?:\\s+[A-ZÇĞİÖŞÜa-zçğıöşü]{2,20})?';

  // Yasaklı "isim" kelimeleri
  const BANNED = /^(benim|ad[ıi]m|[İi]smim|ben|merhaba|merhabalar|selam|selamlar|hey|evet|hayir|hayır|tamam|olur|peki|yok|var|[İi]yi|kolay|g[üu]nler|g[üu]nayd[ıi]n|ak[şs]amlar|geceler|nas[ıi]ls[ıi]n|nas[ıi]ls[ıi]n[ıi]z|naber)$/iu;

  // 1) [opsiyonel selamlama] + giriş ("benim adım / adım / ismim / ben") + isim
  //    → "Merhaba benim adım Orçun", "benim adım Ali", "ismim Zeynep", "ben Orçun"
  let re = new RegExp('^(?:' + GREET + '[\\s,!.:]+)?' + INTRO + '\\s+' + NAME + '\\b', 'i');
  let m = t.match(re);
  if (m && !BANNED.test(m[1])) return cap(m[1]);

  // 2) v15 YENİ: Ters sıra — [isim] + [giriş] (isim ÖNCE)
  //    → "Kemal benim adım", "Ayşe ismim", "Orçun ben"
  re = new RegExp('^' + NAME + '\\s+' + INTRO + '\\s*[.!]*$', 'i');
  m = t.match(re);
  if (m && !BANNED.test(m[1])) return cap(m[1]);

  // 3) Selamlama + isim ("Selam Orçun", "Merhaba Ali")
  re = new RegExp('^' + GREET + '\\s+' + NAME + '\\s*[.!]*$', 'i');
  m = t.match(re);
  if (m && !BANNED.test(m[1])) return cap(m[1]);

  // 4) Tek kelime isim ("Orçun")
  if (/^[A-ZÇĞİÖŞÜa-zçğıöşü]{2,20}$/u.test(t) && !BANNED.test(t)) {
    return cap(t);
  }

  // 5) "Ali Yılmaz" — ad soyad
  m = t.match(/^([A-ZÇĞİÖŞÜa-zçğıöşü]{2,20})\s+([A-ZÇĞİÖŞÜa-zçğıöşü]{2,20})$/u);
  if (m && !BANNED.test(m[1]) && !BANNED.test(m[2])) return cap(m[1]);

  return null;

  function cap(s) {
    return s.charAt(0).toLocaleUpperCase('tr') + s.slice(1).toLocaleLowerCase('tr');
  }
}

// v15: Tek başına "Merhaba / Selam" gibi selamlama — isim değildir ama kullanıcı sadece selam verdi
function isJustGreeting(text) {
  const t = text.trim().toLowerCase();
  // Türkçe "İ" lower case'de "i̇" (noktalı) olabilir, basit "i" de olabilir — iki şansı da dene
  const norm = t.replace(/i̇/g, 'i');
  return /^(merhaba(?:lar)?|selam(?:lar)?|hey+o?|g[üu]nayd[ıi]n|iyi\s+(?:g[üu]nler|ak[şs]amlar|geceler)|kolay\s+gelsin|nas[ıi]ls[ıi]n(?:[ıi]z)?|naber|ne\s+haber|selamun\s+aleykum)[\s!.?]*$/u.test(norm);
}

// ══════════════════════════════════════════════════════════
//  v13: FUZZY MATCH — yaygın yazım hataları için
// ══════════════════════════════════════════════════════════
// Levenshtein distance (küçük — en fazla 2)
function levenshtein(a, b) {
  if (a === b) return 0;
  if (!a.length) return b.length;
  if (!b.length) return a.length;
  const dp = Array.from({length: a.length + 1}, () => new Array(b.length + 1).fill(0));
  for (let i = 0; i <= a.length; i++) dp[i][0] = i;
  for (let j = 0; j <= b.length; j++) dp[0][j] = j;
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      dp[i][j] = a[i-1] === b[j-1]
        ? dp[i-1][j-1]
        : 1 + Math.min(dp[i-1][j], dp[i][j-1], dp[i-1][j-1]);
    }
  }
  return dp[a.length][b.length];
}
// Yazım hatası toleranslı eşleşme
// Kısa kelimeler (≤4 harf): tam eşleşme; 5-7 harf: ≤1 fark; 8+ harf: ≤2 fark
function fuzzyIncludes(haystack, needle) {
  if (haystack.includes(needle)) return true;
  if (needle.length < 5) return false;
  const maxDist = needle.length >= 8 ? 2 : 1;
  const words = haystack.split(/\s+/);
  for (const w of words) {
    if (Math.abs(w.length - needle.length) > maxDist) continue;
    if (levenshtein(w, needle) <= maxDist) return true;
  }
  return false;
}

// ══════════════════════════════════════════════════════════
//  CHAT ENGINE — v11
// ══════════════════════════════════════════════════════════
const SSchat = {
  history: [],
  userMsgCount: 0,
  whatsappNudges: 0,
  isOpen: false,
  firstOpen: true,
  waiting: false,

  // State & Lead (v9/v10'dan)
  state: 'idle',
  lastIntent: null,
  leadScore: 0,
  // v12: Hafıza — bir kez öğrenilen bilgiler tekrar sorulmaz
  detectedMarket: null,       // "ABD", "Kanada", "Avrupa", "İngiltere", "Almanya", "Japonya" vb.
  detectedSuspendType: null,  // "Inauthentic", "Policy Violation", "Velocity", "Related Accounts" vb.
  handoffSent: false,         // 12+ mesaj sonrası "Orçun Bey'e ilettim" mesajı tek kez gönderilsin
  handoffWarned: false,       // v13: 10. mesajda uyarı tek kez gönderilsin
  postHandoffMsgCount: 0,     // v20: Handoff sonrası müşterinin kaç ek sorusu var (max 3)

  // İletişim toplama — akıllı isim yakalama
  contactName: null,
  contactPhone: null,
  nameAsked: false,
  nameCollected: false,
  nameRetries: 0,             // v15: isim tekrar sorma sayacı
  phoneAsked: false,
  phoneCollected: false,

  el: {
    get window() { return document.getElementById('ss-window'); },
    get messages() { return document.getElementById('ss-messages'); },
    get input() { return document.getElementById('ss-input'); },
    get sendBtn() { return document.getElementById('ss-send'); },
    get fab() { return document.getElementById('ss-fab'); },
    get inputArea() { return document.getElementById('ss-input-area'); },
    get disabledBar() { return document.getElementById('ss-disabled-bar'); },
  },

  toggle() {
    if (!this.isOpen) {
      this.el.window.style.display = 'flex';
      requestAnimationFrame(() => {
        this.el.window.classList.add('ss-visible');
        this.el.window.classList.remove('ss-hiding');
      });
      this.el.fab.classList.add('ss-open');
      this.el.fab.classList.add('ss-seen');
      if (this.firstOpen) { this.welcome(); this.firstOpen = false; }
      setTimeout(() => this.el.input.focus(), 100);
    } else {
      this.el.window.classList.add('ss-hiding');
      this.el.window.classList.remove('ss-visible');
      this.el.fab.classList.remove('ss-open');
      setTimeout(() => { this.el.window.style.display = 'none'; }, 350);
    }
    this.isOpen = !this.isOpen;
  },

  welcome() {
    if (SS_EN) return this.welcomeEN();
    const hour = new Date().getHours();
    let g = hour >= 6 && hour < 12 ? 'Günaydın' : hour >= 12 && hour < 18 ? 'İyi günler' : hour >= 18 && hour < 22 ? 'İyi akşamlar' : 'İyi geceler';
    this.addBot(`${g}, Suspend Support'a hoş geldiniz! Amazon hesabınızla ilgili yaşadığınız sorunlar için yardım etmek istiyorum.\n\nÖncelikle sizi tanımak isterim — adınızı öğrenebilir miyim?`);
    this.nameAsked = true;
  },

  showQuickReplies(buttons) {
    if (!buttons || buttons.length === 0) return;
    const wrap = document.createElement('div');
    wrap.className = 'ss-quick-wrap';
    buttons.forEach(text => {
      const b = document.createElement('button');
      b.className = 'ss-quick-btn';
      b.textContent = text;
      b.onclick = () => { this.el.input.value = text; this.send(); wrap.remove(); };
      wrap.appendChild(b);
    });
    this.el.messages.appendChild(wrap);
    this.scroll();
  },

  addBot(text) {
    const d = document.createElement('div');
    d.className = 'ss-msg ss-bot';
    d.innerHTML = this.format(text);
    this.el.messages.appendChild(d);
    this.scroll();
  },

  addUser(text) {
    const d = document.createElement('div');
    d.className = 'ss-msg ss-user';
    d.textContent = text;
    this.el.messages.appendChild(d);
    this.scroll();
  },

  showTyping() {
    const w = document.createElement('div');
    w.className = 'ss-typing-wrap';
    w.id = 'ss-typing';
    w.innerHTML = `<div class="ss-typing-avatar"><img src="${SS_AVATAR_SRC}" alt=""></div><div class="ss-typing-dots"><span></span><span></span><span></span></div>`;
    this.el.messages.appendChild(w);
    this.scroll();
  },

  hideTyping() { const e = document.getElementById('ss-typing'); if (e) e.remove(); },

  scroll() { requestAnimationFrame(() => { this.el.messages.scrollTop = this.el.messages.scrollHeight; }); },

  format(text) {
    text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/(https?:\/\/[^\s<)]+)/g, '<a href="$1" target="_blank" rel="noopener">$1</a>');
    text = text.replace(/\n/g, '<br>');
    return text;
  },

  // ── Ezbere arama (v13 — fuzzy match + yazım hatası tolerans) ──
  searchKB(input) {
    let q = input.toLowerCase()
      .replace(/[?!.,;:'"]/g, '')
      .replace(/ğ/g,'g').replace(/ü/g,'u').replace(/ş/g,'s')
      .replace(/ı/g,'i').replace(/ö/g,'o').replace(/ç/g,'c')
      .replace(/İ/gi,'i').replace(/i̇/g,'i');

    // v13: Yaygın yazım hataları için ön-normalize
    // Bu kelimeler eşleşmede çok kritik olduğu için düzeltiyoruz
    const TYPO_MAP = [
      [/\bsuspent\b/g, 'suspend'],
      [/\bsuspand\b/g, 'suspend'],
      [/\bsuspen\b/g, 'suspend'],
      [/\bsispend\b/g, 'suspend'],
      [/\baskya\b/g, 'askiya'],
      [/\basikya\b/g, 'askiya'],
      [/\bapeal\b/g, 'appeal'],
      [/\bapel\b/g, 'appeal'],
      [/\bapell\b/g, 'appeal'],
      [/\banphentic\b/g, 'inauthentic'],
      [/\binothentik\b/g, 'inauthentic'],
      [/\binautentic\b/g, 'inauthentic'],
      [/\bdrop\s?shiping\b/g, 'drop shipping'],
      [/\bdropship\b/g, 'drop shipping'],
      [/\bvelosity\b/g, 'velocity'],
      [/\bpoliicy\b/g, 'policy'],
      [/\bkapatildi\b/g, 'kapatildi'],
      [/\bkapatıldı\b/g, 'kapatildi'], // zaten normalize edilmiş olmalı
      [/\bamzon\b/g, 'amazon'],
      [/\bamazn\b/g, 'amazon'],
    ];
    for (const [pattern, replacement] of TYPO_MAP) {
      q = q.replace(pattern, replacement);
    }

    // v12: Selamlaşma/nezaket entry'lerinin anahtarları — sohbet başladıktan sonra tetiklenmesin
    const GREETING_KEYS = new Set([
      'merhaba','merhabalar','herkese merhaba','selam','selamlar',
      'hey','heyy','heyo','gunaydin','iyi gunler','iyi aksamlar',
      'nasilsin','nasilsiniz','naber','ne haber','nasil gidiyor','keyifler nasil'
    ]);

    // v12: Kısa onay sözcükleri — sohbet ortasında API'ye bırakılmalı
    // ("evet", "tamam" gibi tek kelimeler context-free entry'ye düşerse saçma olur)
    const SHORT_ACK_KEYS = new Set([
      'evet','olur','tamam','kabul','anladim','peki',
      'hayir','istemiyorum','gerek yok','yok','ilgilenmiyorum',
      'yardim','help','yardim edin','yardima ihtiyacim var','destek'
    ]);

    // v12: Suspend giriş entry'si — state ilerledikten sonra tekrar tetiklenmesin
    // (Müşteri pazarı seçti, sonra "hesap açılmadı" dese, bot yine "hangi pazar?" dememeli)
    const SUSPEND_INTRO_KEYS = new Set([
      'hesabim suspend','suspend yedim','suspend oldu','hesabim kapandi',
      'hesabim askiya','ban yedim','hesap askiya alindi','hesabim kapatildi',
      'hesap kapandi','amazon hesabim kapandi','amazon kapatti',
      'hesabimi kapattilar','askiya aldilar','suspend aldim','hesabim durduruldu',
      'deactivate oldu','deactivate edildi'
    ]);

    // Sorguyu da normalize et (karşılaştırma için)
    const norm = s => s.toLowerCase()
      .replace(/[?!.,;:'"]/g, '')
      .replace(/ğ/g,'g').replace(/ü/g,'u').replace(/ş/g,'s')
      .replace(/ı/g,'i').replace(/ö/g,'o').replace(/ç/g,'c')
      .replace(/İ/gi,'i').replace(/i̇/g,'i');

    // Suspend tipi sinyalleri — bunlar bağlam belirleyici
    // NOT: 'hesap' tek başına çok genel (hesap açmak ≠ suspend), bu yüzden çıkarıldı
    // Tüm sinyaller normalize edilmiş haliyle tutulur
    const SUSPEND_SIGNALS = [
      'suspend','askiya','hesabim','kapatildi',
      'ban','engel','appeal','itiraz','poa','reinstate','acildi','acilmadi',
      'kapandi','durduruldu','deactivate'
    ];

    // Suspend eşanlamlıları — key'de suspend geçmese bile sorguda kapandı varsa entry suspend-related sayılmalı
    const SUSPEND_SYNONYMS = ['suspend','askiya','kapatildi','kapandi','ban','deactivate','durduruldu'];

    // Ülke/pazar sinyalleri
    const COUNTRY_SIGNALS = {
      us:  ['abd','usa','amerika','amerikan','us marketplace','kuzey amerika'],
      uk:  ['ingiltere','uk','birlesik krallik','amazon uk'],
      de:  ['almanya','germany','amazon de','alman'],
      fr:  ['fransa','france','amazon fr'],
      it:  ['italya','italy','amazon it'],
      es:  ['ispanya','spain','amazon es'],
      ca:  ['kanada','canada','amazon ca'],
      mx:  ['meksika','mexico','amazon mx'],
      jp:  ['japonya','japan','amazon jp'],
      eu:  ['avrupa','europe'],
      // v18: Yeni pazarlar eklendi
      au:  ['avustralya','australia','amazon au'],
      sg:  ['singapur','singapore','amazon sg'],
      ae:  ['bae','birlesik arap emirlikleri','uae','amazon ae','dubai','emirlikler'],
      sa:  ['suudi','suudi arabistan','saudi','saudi arabia','amazon sa'],
    };

    // Sadece ülke/hesap açılışı entry'si mi yoksa suspend ile de ilgili mi?
    const COUNTRY_ONLY_KEYS = ['kanada','canada','kanada pazari','kanada hesap',
      'amerika','abd','usa','amerikan pazari','us marketplace',
      'ingiltere','uk','birlesik krallik','ingiltere pazari','amazon uk',
      'almanya','germany','amazon de','alman pazari',
      'japonya','japan','amazon jp','japon pazari',
      'meksika','mexico','amazon mx',
      'fransa','france','amazon fr','fransiz pazari',
      'italya','italy','amazon it','italyan pazari',
      'ispanya','spain','amazon es','ispanyol pazari',
      'hangi ulke','hangi pazar','nerelerde','hangi marketplace','desteklediginiz ulkeler','calistiginiz ulkeler'];

    // Sorguda hangi ülke geçiyor?
    const detectedCountry = Object.entries(COUNTRY_SIGNALS).find(([,terms]) =>
      terms.some(t => q.includes(norm(t)))
    )?.[0] || null;

    // Sorguda suspend sinyali var mı?
    // v11: State farkındalığı — suspend akışındaysak, sorguda suspend kelimesi
    // geçmese bile (müşteri sadece "Almanya" yazdıysa) bağlamı koruyoruz
    const hasSuspendSignal = SUSPEND_SIGNALS.some(s => q.includes(s)) 
      || this.state === 'suspend_flow' 
      || this.state === 'suspend_country_selected';

    let bestMatch = null;
    let bestScore = 0;

    for (const entry of KB) {
      let entryScore = 0;

      // v12 GUARD A: Sohbet ilerledikten sonra (3+ mesaj) selamlaşma/onay entry'lerini atla
      // "nasılsın" aslında soru değil pasif cevap olabilir, "evet/tamam" bağlamsız olur
      // → Guard A bunları atlayıp daha iyi eşleşmeyi veya API fallback'ini devreye sokar
      if (this.userMsgCount > 2) {
        const isGreetingEntry = entry.keys.every(k => GREETING_KEYS.has(norm(k)));
        if (isGreetingEntry) continue;
        const isShortAckEntry = entry.keys.every(k => SHORT_ACK_KEYS.has(norm(k)));
        if (isShortAckEntry) continue;
      }

      // v12 GUARD B: Pazar zaten seçildiyse, suspend giriş entry'sini atla
      // (Müşteri ikinci kez "hesap açılmadı" dese bile "hangi pazar?" diye sormayalım)
      if (this.state === 'suspend_country_selected' || this.detectedMarket) {
        const isSuspendIntroEntry = entry.keys.some(k => {
          const nk = norm(k);
          return SUSPEND_INTRO_KEYS.has(nk);
        });
        if (isSuspendIntroEntry) continue;
      }

      // Bu entry sadece ülke/hesap açılışı mı?
      const isCountryOnlyEntry = entry.keys.every(k => COUNTRY_ONLY_KEYS.includes(norm(k)));

      for (const key of entry.keys) {
        const nk = norm(key);
        const keyWords = nk.split(/\s+/).filter(w => w.length > 2);

        // v12 FIX: "yorum" gibi kısa tek-kelime anahtarlar, substring ararken
        // "san-iyorum", "bilmiyorum" gibi compound kelimelerin içine yanlışlıkla
        // eşleşiyordu. Tek kelimeli ve ≤6 karakter anahtarlar için kelime sınırı şart.
        const isShortSingleWord = !nk.includes(' ') && nk.length <= 6;

        // Tam eşleşme kontrolü — kısa tek kelimeler için word-boundary, diğerleri substring
        let exactMatch;
        if (isShortSingleWord) {
          // Regex özel karakterlerini kaçır (KB anahtarlarında olmaz ama güvenlik için)
          const escaped = nk.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const re = new RegExp('(?:^|\\s)' + escaped + '(?:\\s|$)');
          exactMatch = re.test(q);
        } else {
          exactMatch = q.includes(nk);
        }

        // 1) Tam eşleşme — en yüksek puan
        if (exactMatch) {
          let exactScore = 100 + nk.length;

          // v8 FIX: Suspend sinyali varken saf ülke entry'sini cezalandır
          // Böylece "kanada pazarım suspend/kapandı" yazıldığında
          // kanada hesap açılışı yerine kanada+suspend entry'si kazanır
          const exactKeyIsSuspendRelated = SUSPEND_SYNONYMS.some(syn => nk.includes(syn));
          if (hasSuspendSignal && isCountryOnlyEntry && !exactKeyIsSuspendRelated) {
            exactScore -= 50;
          }

          entryScore = Math.max(entryScore, exactScore);
          continue;
        }

        // 2) Kelime bazlı eşleşme — v13: uzun kelimelere fuzzy fallback
        // Kısa kelimeler (≤5 harf): word-boundary (substring collision engeli)
        // Uzun kelimeler (6+ harf): önce tam substring, sonra Levenshtein ≤1/2
        // Bu sayede "suspent", "askya", "anphentic", "apeal" gibi yazım hataları da eşleşir
        const wordMatches = (w) => {
          if (w.length <= 5) {
            const escaped = w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const re = new RegExp('(?:^|\\s)' + escaped + '(?:\\s|$)');
            return re.test(q);
          }
          // Önce hızlı substring kontrolü
          if (q.includes(w)) return true;
          // Fuzzy: yazım hatası toleranslı arama
          return fuzzyIncludes(q, w);
        };
        const matched = keyWords.filter(wordMatches);
        const ratio = keyWords.length > 0 ? matched.length / keyWords.length : 0;

        if (ratio >= 0.6 && matched.length >= 1) {
          let score = matched.length * 10 + ratio * 20;

          // 3) Bonus: suspend sinyali + entry suspend ile ilgiliyse
          //    Key'de herhangi bir suspend eşanlamlısı geçiyorsa bu entry suspend-related
          const keyIsSuspendRelated = SUSPEND_SYNONYMS.some(syn => nk.includes(syn));
          if (hasSuspendSignal && keyIsSuspendRelated) {
            score += 15;
          }

          // v8 FIX: Suspend sinyali varken saf ülke entry'sini cezalandır
          if (hasSuspendSignal && isCountryOnlyEntry && !keyIsSuspendRelated) {
            score -= 20;
          }

          // 4) Bonus: ülke eşleşmesi — ülke+suspend kombinasyonu en değerli
          if (detectedCountry && (
            (detectedCountry === 'us' || detectedCountry === 'ca' || detectedCountry === 'mx') && nk.includes('kuzey') ||
            (['uk','de','fr','it','es'].includes(detectedCountry)) && (nk.includes('avrupa') || nk.includes('ingiltere') || nk.includes('almanya') || nk.includes('fransa') || nk.includes('italya') || nk.includes('ispanya')) ||
            detectedCountry === 'jp' && nk.includes('japon') ||
            detectedCountry === 'eu' && nk.includes('avrupa') ||
            // v18: Yeni pazarlar için de bonus
            detectedCountry === 'au' && nk.includes('avustralya') ||
            detectedCountry === 'sg' && nk.includes('singapur') ||
            detectedCountry === 'ae' && (nk.includes('bae') || nk.includes('emirlik')) ||
            detectedCountry === 'sa' && nk.includes('suudi')
          )) {
            score += 25;
          }

          // 5) Kelime uzunluğu bonusu — uzun anahtar kelimeler daha spesifik
          score += matched.reduce((acc, w) => acc + w.length, 0) * 0.5;

          entryScore = Math.max(entryScore, score);
        }
      }

      // v11: State-aware boost — suspend akışındayken ülke yazılırsa,
      // o ülkenin suspend entry'si öne çıksın (hesap açılışı değil)
      if (hasSuspendSignal && detectedCountry && !isCountryOnlyEntry) {
        const entryHasCountry = entry.keys.some(k => {
          const nk2 = norm(k);
          const countryTerms = COUNTRY_SIGNALS[detectedCountry] || [];
          return countryTerms.some(ct => {
            const nct = norm(ct);
            // Kısa terimler (2-3 harf) kelime sınırı ile eşleşmeli, substring değil
            if (nct.length <= 3) {
              const re = new RegExp('(?:^|\\s)' + nct + '(?:\\s|$)');
              return re.test(nk2);
            }
            return nk2.includes(nct);
          });
        });
        const entryIsSuspendType = entry.keys.some(k => SUSPEND_SYNONYMS.some(syn => norm(k).includes(syn)));
        if (entryHasCountry && entryIsSuspendType) {
          entryScore += 80;
        }
      }

      if (entryScore > bestScore) {
        bestScore = entryScore;
        bestMatch = entry;
      }
    }

    // Eşik: 15 puan altı çok zayıf eşleşme, API'ye gönder
    return bestScore >= 15 ? bestMatch : null;
  },

  // ── Claude API (v13 — Haiku 4.5 + yumuşak dinamik context) ──
  async callAPI(userMsg) {
    this.history.push({ role: 'user', content: userMsg });
    const recent = this.history.slice(-12);
    // Claude API ilk mesajın 'user' olmasını ister; kırpma 'assistant' ile başlarsa 400 hatası verirdi.
    while (recent.length && recent[0].role !== 'user') recent.shift();

    // Dinamik context: bot ne öğrendiyse API'ye söyle — yumuşak, bilgilendirici dil
    const ctx = [];
    if (this.contactName) ctx.push(`Müşterinin adı: ${this.contactName}`);
    if (this.contactPhone) ctx.push(`Telefon: ${this.contactPhone}`);
    if (this.detectedMarket) ctx.push(`Pazarı: ${this.detectedMarket} (müşteri önceden belirtti, tekrar sormaya gerek yok)`);
    if (this.detectedSuspendType) ctx.push(`Suspend türü: ${this.detectedSuspendType} (müşteri önceden belirtti, tekrar sormaya gerek yok)`);
    if (this.state && this.state !== 'idle') ctx.push(`Akış durumu: ${this.state}`);
    ctx.push(`Sohbet ilerleyişi: ${this.userMsgCount}. mesajdayız (${SS_CONFIG.HANDOFF_AT}. mesajda Orçun Bey'e devredilecek)`);

    const dynCtx = ctx.length
      ? `\n\n## BU MÜŞTERİ HAKKINDA ŞU ANA KADAR ÖĞRENDİKLERİN\n${ctx.join('\n')}\n\nBu bilgileri müşteriden tekrar isteme — zaten biliyorsun. Onun durumuna odaklan, tek soru sor, adım adım ilerle.`
      : '';

    const sysPrompt = SS_EN ? ssEnSysPrompt(dynCtx) : SYS_PROMPT + dynCtx;

    try {
      const res = await fetch(SS_CONFIG.WORKER_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
        body: JSON.stringify({
          // v13: Haiku 4.5 — ekonomik, hızlı, bu senaryo için yeterli
          model: 'claude-haiku-4-5',
          max_tokens: 800,  // v13: 500 → 800 (uzun POA/suspend açıklamalarında kesilme olmasın)
          system: sysPrompt,
          messages: recent,
        }),
      });
      if (!res.ok) throw new Error(res.status);
      const data = await res.json();
      const reply = data.content?.[0]?.text || (SS_EN ? 'Something went wrong. Please try again.' : 'Bir sorun oluştu. Lütfen tekrar deneyin.');
      this.history.push({ role: 'assistant', content: reply });
      // v12: API cevabından suspend türünü algılamaya çalış (hafıza için)
      this.detectSuspendTypeFromText(userMsg + ' ' + reply);
      return reply;
    } catch (e) {
      console.error('API Error:', e);
      if (SS_EN) return 'We are having a technical problem right now. You can reach us directly:\n\n📞 +90 554 171 61 82\n💬 WhatsApp: https://wa.me/' + SS_CONFIG.PHONE;
      return `Şu an teknik bir aksaklık yaşıyoruz. Bize doğrudan ulaşabilirsiniz:\n\n📞 ${SS_CONFIG.PHONE_DISPLAY}\n💬 WhatsApp: https://wa.me/${SS_CONFIG.PHONE}`;
    }
  },

  // ── v12: Metinden suspend türü algıla (hafızaya yaz) ──
  detectSuspendTypeFromText(text) {
    if (this.detectedSuspendType) return; // zaten biliyoruz
    const t = text.toLowerCase();
    const patterns = [
      // v16: Genişletilmiş ve öncelikli pattern'ler (en spesifik önce)
      { re: /section\s*3|business solutions agreement|deceptive.*fraudulent.*illegal|seller code of conduct/i, type: 'Section 3' },
      { re: /hesap inceleme|account.*under review|account review/i, type: 'Hesap İncelemesi' },
      { re: /hesap sağlığı|account health rating|\bahr\b/i, type: 'Hesap Sağlığı' },
      { re: /iptal oran|cancel rate|pre-?fulfillment cancel|iptal sorun/i, type: 'İptal Sorunları' },
      { re: /\bfba\b.*(problem|ihlal|suspend|hata)|fba hesap/i, type: 'FBA Problemleri' },
      { re: /inauthentic|sahte ürün|orijinal olmay|orjinal olmay|ürün orijinal|ürün orjinal|orjinalik|orjinallik|orjinalligi|orijinallik|orijinalliği|orijinaliği|ürün orjinallik|urun orjinallik/i, type: 'Ürün Orjinallik (Inauthentic)' },
      { re: /intellectual property|fikri mülkiyet|fikri mulkiyet|ip ihlali|trademark|marka ihlal|copyright|telif/i, type: 'Fikri Mülkiyet' },
      { re: /policy violation|politika ihlali|kural ihlali/i, type: 'Policy Violation' },
      { re: /velocity|hızlı satış|hizli satis|satış hızı/i, type: 'Hızlı Satış (Velocity)' },
      { re: /related account|ilişkilendirme|bağlantılı hesap/i, type: 'Related Accounts (İlişkilendirme)' },
      { re: /dropshipping|drop shipping|drop shiping/i, type: 'Drop Shipping' },
      { re: /odr|order defect|sipariş kusur/i, type: 'ODR' },
      { re: /late shipment|geç gönderim|geç kargo/i, type: 'Geç Gönderim' },
      { re: /seller id verification|açılış suspend/i, type: 'Açılış (Seller ID Verification)' },
      { re: /forged document|sahte belge|sahte fatura/i, type: 'Forged Documents' },
      { re: /review manipulation|yorum manipülasyon|sahte yorum/i, type: 'Review Manipulation' },
    ];
    for (const p of patterns) {
      if (p.re.test(t)) {
        this.detectedSuspendType = p.type;
        return;
      }
    }
  },

  // ── Mesaj gönder — v11 ──
  async send() {
    const text = this.el.input.value.trim();
    if (!text || this.waiting) return;
    if (SS_EN) return this.sendEN(text);

    this.addUser(text);
    this.el.input.value = '';
    this.userMsgCount++;

    // ═══ İSİM YAKALAMA (v15 — selamlamayı da karşılar) ═══
    if (this.nameAsked && !this.nameCollected) {
      const name = extractName(text);
      if (name) {
        this.contactName = name;
        this.nameCollected = true;
        this.phoneAsked = true;
        setTimeout(() => {
          this.addBot(`Memnun oldum ${this.contactName}! Yazışmamız sonrası size ulaşabilmemiz için telefon numaranızı paylaşır mısınız? (Örn: 0555 123 45 67)`);
        }, 400);
        return;
      } else {
        // v19: ilk mesaj bir soruysa (ana sayfadaki hızlı soru butonları dahil) isim kapısını atla ve soruyu doğrudan yanıtla
        const askedFirst = !isJustGreeting(text) && (text.trim().split(/\s+/).length > 3 || /\?/.test(text));
        if (askedFirst) {
          this.nameCollected = true;
          this.contactName = null;
        } else {
          // v15: Eğer müşteri sadece "Merhaba" gibi selamlama yazdıysa, nazikçe karşıla
          this.nameRetries = (this.nameRetries || 0) + 1;
          if (isJustGreeting(text)) {
            setTimeout(() => this.addBot('Merhaba! Sizi tanımak isterim — adınızı öğrenebilir miyim?'), 300);
          } else if (this.nameRetries >= 2) {
            // 2. denemede "İsim söylemek istemezseniz boşverin" seçeneği
            this.nameCollected = true;   // artık isim sormayı bırak
            this.phoneAsked = true;
            this.contactName = null;
            setTimeout(() => {
              this.addBot('Sorun değil, isim olmadan da devam edebiliriz. Yazışmamız sonrası size ulaşabilmemiz için telefon numaranızı paylaşır mısınız? (Örn: 0555 123 45 67)');
            }, 300);
          } else {
            setTimeout(() => this.addBot('Afedersiniz, adınızı tam anlayamadım. Sadece adınızı yazabilir misiniz?'), 300);
          }
          return;
        }
      }
    }

    // ═══ TELEFON TOPLAMA ═══
    if (this.phoneAsked && !this.phoneCollected) {
      const digits = text.replace(/\D/g, '');
      if (digits.length >= 10) {
        this.contactPhone = text;
        this.phoneCollected = true;
        this.sendTelegramLog('İLETİŞİM BİLGİSİ ALINDI');
        setTimeout(() => {
          this.addBot(`Teşekkürler${this.contactName ? ' ' + this.contactName : ''}! Bilgilerinizi aldık. Şimdi size nasıl yardımcı olabilirim?`);
          this.showQuickReplies(['Hesabım suspend oldu', 'Hesap açtırmak istiyorum', 'Fiyat bilgisi', 'Orçun Bey ile görüşme']);
        }, 500);
        return;
      } else {
        // Telefon değil — müşteri direkt sorusuna geçmek istiyor, atla
        this.phoneAsked = false;
      }
    }

    // ═══ ORÇUN BEY İLE GÖRÜŞME — DİREKT HANDOFF (v21) ═══
    // Bu mesaj 10 farklı yerde quick reply olarak sunuluyor + müşteriler doğal olarak
    // "Orçun Bey'le konuşmak istiyorum" gibi varyantlar yazıyor. KB scoring'e
    // düşmeden direkt handoff akışına alıyoruz — bu bir bilgi sorusu değil, niyet.
    const wantsOrcunDirect = /(or[çc]un.{0,15}(bey|abi|uyar)?.{0,15}(ile|yle|la)?.{0,5}(g[öo]r[üu][şs]|konu[şs]|ileti[şs]im))|(or[çc]un.{0,5}bey.{0,5}ile.{0,5}g[öo]r[üu][şs]me)|(or[çc]un.{0,5}beyle)|(or[çc]un.{0,5}beyi.{0,10}g[öo]r)|(birebir.{0,5}g[öo]r[üu][şs])/i.test(text);
    if (wantsOrcunDirect && !this.handoffSent) {
      this.handoffSent = true;
      this.waiting = true;
      this.el.sendBtn.disabled = true;
      this.showTyping();
      const nm = this.contactName ? ` ${this.contactName} Bey/Hanım` : '';
      const phoneLine = this.contactPhone
        ? `Bilgilerinizi Orçun Bey'e ilettim — en kısa sürede ${this.contactPhone} numaranızdan size dönüş yapacaktır.`
        : `Bilgilerinizi Orçun Bey'e ilettim — en kısa sürede sizinle iletişime geçecektir.`;
      const reply = `Tabii${nm}. ${phoneLine}\n\nAcil bir durumunuz varsa WhatsApp üzerinden de doğrudan yazabilirsiniz:\n\n💬 WhatsApp: https://wa.me/${SS_CONFIG.PHONE}\n📞 ${SS_CONFIG.PHONE_DISPLAY}\n\n---\n\n**Bu arada sormak istediğiniz başka bir şey var mı?** Süreç, fiyatlar veya başka konularda kısaca yardımcı olabilirim.`;
      this.history.push({ role: 'user', content: text });
      this.history.push({ role: 'assistant', content: reply });
      this.sendTelegramLog('DİREKT HANDOFF — "Orçun Bey ile görüşme" talebi');
      setTimeout(() => {
        this.hideTyping();
        this.addBot(reply);
        this.showQuickReplies(["Süreç nasıl işliyor?", "Başarı oranınız ne?", "Hayır, teşekkürler"]);
        this.waiting = false;
        this.el.sendBtn.disabled = false;
      }, 600);
      return;
    }

    // ═══ "Anladım, dosyamı inceletin" — DOSYA İNCELEME TALEBİ (v22) ═══
    // Fiyat/bilgi mesajından sonra sunulan bu buton, "evet/tamam" değil — net bir aksiyon talebi.
    // KB'de [evet|olur|tamam|kabul|anladım] entry'sine yanlışlıkla düşüyordu; düzeltiyoruz.
    const wantsFileReview = /(dosyam[ıi].{0,5}incelet|dosyam[ıi].{0,5}inceleyin|incelet.{0,5}istiyorum|hesab[ıi]m[ıi].{0,5}incelet|hesab[ıi]m[ıi].{0,5}inceleyin|durumumu.{0,5}incelet|anlad[ıi]m.{0,5}dosyam)/i.test(text);
    if (wantsFileReview && !this.handoffSent) {
      this.handoffSent = true;
      this.waiting = true;
      this.el.sendBtn.disabled = true;
      this.showTyping();
      const nm = this.contactName ? ` ${this.contactName} Bey/Hanım` : '';
      const phoneLine = this.contactPhone
        ? `En kısa sürede ${this.contactPhone} numaranızdan size dönüş yapacaktır.`
        : `En kısa sürede sizinle iletişime geçecektir.`;
      const reply = `Harika${nm}! Dosyanızı Orçun Bey'e aktarıyorum — kendisi durumunuzu detaylı inceleyip gerçekçi bir yol haritası sunacak. ${phoneLine}\n\nAcil bir durumunuz varsa WhatsApp üzerinden de yazabilirsiniz:\n\n💬 WhatsApp: https://wa.me/${SS_CONFIG.PHONE}\n📞 ${SS_CONFIG.PHONE_DISPLAY}\n\n---\n\n**Bu arada başka sormak istediğiniz bir şey var mı?**`;
      this.history.push({ role: 'user', content: text });
      this.history.push({ role: 'assistant', content: reply });
      this.sendTelegramLog('DİREKT HANDOFF — Dosya inceleme talebi');
      setTimeout(() => {
        this.hideTyping();
        this.addBot(reply);
        this.showQuickReplies(["Süreç nasıl işliyor?", "Başarı oranınız ne?", "Hayır, teşekkürler"]);
        this.waiting = false;
        this.el.sendBtn.disabled = false;
      }, 600);
      return;
    }

    // ═══ "Önce daha bilgi almak istiyorum" — CONTEXT-AWARE (v22) ═══
    // Bu buton suspend tipi cevaplarından sonra gösteriliyor. Müşteri seçtiği konuda
    // "biraz daha açıkla" diyor — bot'un müşteriyi ana menüye geri atması saçma.
    // detectedSuspendType / detectedMarket biliniyorsa bağlama uygun cevap ver.
    const wantsMoreInfo = /^(önce )?(biraz )?(daha )?bilgi (almak |al )?istiyorum$|^daha (fazla )?bilgi$|^bilgi (verir misin|alabilir miyim)/i.test(text.trim());
    if (wantsMoreInfo && (this.detectedSuspendType || this.detectedMarket)) {
      this.waiting = true;
      this.el.sendBtn.disabled = true;
      this.showTyping();
      const ctxParts = [];
      if (this.detectedSuspendType) ctxParts.push(`**${this.detectedSuspendType}**`);
      if (this.detectedMarket) ctxParts.push(`${this.detectedMarket} pazarı`);
      const ctxLine = ctxParts.length ? ` ${ctxParts.join(' / ')} hakkında ` : ' ';
      const reply = `Tabii.${ctxLine}hangi konuda daha detay istersiniz? Birkaç başlık seçebilirim:`;
      this.history.push({ role: 'user', content: text });
      this.history.push({ role: 'assistant', content: reply });
      setTimeout(() => {
        this.hideTyping();
        this.addBot(reply);
        this.showQuickReplies(["Süreç nasıl işliyor?", "Başarı oranınız ne?", "Ne kadar sürer?", "Fiyat bilgisi", "Orçun Bey ile görüşme"]);
        this.waiting = false;
        this.el.sendBtn.disabled = false;
      }, 500);
      return;
    }

    // Mesaj limiti
    if (this.whatsappNudges >= 2) { this.disableInput(); return; }

    this.waiting = true;
    this.el.sendBtn.disabled = true;
    this.showTyping();

    let reply;
    let quickReplies = null;

    // v15: ERKEN HANDOFF — pazar + suspend türü biliniyorsa 6. mesajda Orçun Bey'e yönlendir
    // Müşteri yeterince bilgi verdi, bot detektif moduna girmesin.
    const hasEnoughContext = this.detectedMarket && this.detectedSuspendType;
    if (hasEnoughContext && this.userMsgCount >= SS_CONFIG.EARLY_HANDOFF_AT && !this.handoffSent) {
      this.handoffSent = true;
      const nm = this.contactName ? ` ${this.contactName} Bey/Hanım` : '';
      // v20: Handoff mesajı sonunda "Başka sorunuz var mı?" sor + quick reply butonları göster
      reply = `Durumunuzu iyice anladım${nm}. **${this.detectedMarket} pazarında ${this.detectedSuspendType}** ile ilgili yaşadıklarınızı kaydettim.\n\nDetaylı inceleme için sizi Orçun Bey'e aktarıyorum — kendisi en kısa sürede sizinle iletişime geçecek. Bu tür dosyalarda stratejik yaklaşım çok önemli, bu yüzden süreci bizzat Orçun Bey değerlendirecek.\n\nAcil bir durum varsa WhatsApp'tan da ulaşabilirsiniz:\n\n💬 WhatsApp: https://wa.me/${SS_CONFIG.PHONE}\n📞 ${SS_CONFIG.PHONE_DISPLAY}\n\n---\n\n**Bu arada sormak istediğiniz başka bir şey var mı?** Süreç, fiyat veya başka konularda kısaca bilgi verebilirim.`;
      quickReplies = ["Süreç nasıl işliyor?", "Başarı oranınız ne?", "Hayır, teşekkürler"];
      this.history.push({ role: 'user', content: text });
      this.history.push({ role: 'assistant', content: reply });
      this.sendTelegramLog(`ERKEN HANDOFF — Pazar+Tür biliniyor (${this.userMsgCount}. mesaj)`);
    }
    // v20: POST-HANDOFF — Handoff sonrası müşteri soru sormaya devam ediyor
    // Max 3 ek soruya cevap ver, sonra yumuşak veda
    else if (this.handoffSent) {
      this.postHandoffMsgCount++;
      const MAX_POST_HANDOFF = 3;

      // "Hayır teşekkürler" gibi kapanış mesajı — hemen güzel bir veda
      const isGoodbye = /^(hay[ıi]r|yok|tamam|te[sş]ekk[üu]r|sa[ğg] ol|g[öo]r[üu][şs][üu]r[üu]z|eyvallah|ok|olur|anla[şs][ıi]ld[ıi])/i
        .test(text.trim());
      if (isGoodbye || this.postHandoffMsgCount > MAX_POST_HANDOFF) {
        const nm = this.contactName ? `${this.contactName} Bey/Hanım, ` : '';
        if (isGoodbye) {
          reply = `Ne demek${nm ? ', ' + nm.slice(0, -2) : ''}! Yardımcı olabildiysem ne mutlu. Orçun Bey en kısa sürede sizinle iletişime geçecek. İyi günler dileriz! 🙏`;
        } else {
          reply = `${nm}yoğunluk nedeniyle sohbeti burada tamamlıyorum. Sorularınızın tamamını Orçun Bey'e ilettim, kendisi detaylı cevap verecek — merak etmeyin.\n\n💬 WhatsApp: https://wa.me/${SS_CONFIG.PHONE}\n📞 ${SS_CONFIG.PHONE_DISPLAY}`;
        }
        this.history.push({ role: 'user', content: text });
        this.history.push({ role: 'assistant', content: reply });
        this.disableInput();
        this.sendTelegramLog(`POST-HANDOFF KAPANIŞ (${this.postHandoffMsgCount}. ek soru)`);
      } else {
        // Normal soru — KB varsa KB, yoksa API ile kısa cevap
        const kbResult = this.searchKB(text);
        if (kbResult) {
          // KB cevabı — state-aware varsa onu kullan
          const inSuspendFlow = (this.state === 'suspend_flow' || this.state === 'suspend_country_selected');
          if (inSuspendFlow && kbResult.answerIfSuspending) {
            reply = kbResult.answerIfSuspending;
          } else {
            reply = kbResult.answer;
          }
          quickReplies = null; // Post-handoff'ta KB butonları göstermeyelim
        } else {
          reply = await this.callAPI(text);
        }
        // Son ek soruya yaklaşıyorsak müşteriye nazik uyarı
        if (this.postHandoffMsgCount >= MAX_POST_HANDOFF) {
          reply += `\n\n*Birkaç sorunuza daha cevap verebildim, sonrasında Orçun Bey süreci devralacak.*`;
        }
        this.history.push({ role: 'user', content: text });
        this.history.push({ role: 'assistant', content: reply });
      }
    }
    // v13: Handoff — HANDOFF_AT. mesajda yumuşak devir
    else if (this.userMsgCount >= SS_CONFIG.HANDOFF_AT && !this.handoffSent) {
      this.handoffSent = true;
      const nm = this.contactName ? ` ${this.contactName} Bey/Hanım` : '';
      reply = `Bilgileri topladım${nm}. Orçun Bey müsait olunca dönüş yapacak. Acil bir durum varsa WhatsApp'tan da ulaşabilirsiniz:\n\n💬 WhatsApp: https://wa.me/${SS_CONFIG.PHONE}\n📞 ${SS_CONFIG.PHONE_DISPLAY}`;
      this.history.push({ role: 'user', content: text });
      this.history.push({ role: 'assistant', content: reply });
      this.sendTelegramLog(`HANDOFF — Orçun Bey'e aktarıldı (${SS_CONFIG.HANDOFF_AT}. mesaj)`);
    } else if (this.userMsgCount === SS_CONFIG.HANDOFF_WARN_AT && !this.handoffWarned) {
      // v13: 10. mesajda yumuşak uyarı — "birkaç soru daha sorup iletiyorum"
      this.handoffWarned = true;
      // Uyarıyı normal akışa ekleyeceğiz (KB/API cevabından sonra)
      const kbResult = this.searchKB(text);
      reply = kbResult ? kbResult.answer : await this.callAPI(text);
      if (kbResult) {
        quickReplies = kbResult.quickReplies || null;
        if (kbResult.setState) this.state = kbResult.setState;
        if (kbResult.leadBonus) this.leadScore += kbResult.leadBonus;
        if (kbResult.setMarket) this.detectedMarket = kbResult.setMarket;
        if (kbResult.setSuspendType) this.detectedSuspendType = kbResult.setSuspendType;
        this.detectSuspendTypeFromText(text);
        this.history.push({ role: 'user', content: text });
        this.history.push({ role: 'assistant', content: reply });
      }
      reply += `\n\n*Durumunuzu iyice anladım. Birkaç soru daha sorduktan sonra Orçun Bey'e ileteceğim, kendisi size dönüş yapacak.*`;
    } else if (this.userMsgCount > SS_CONFIG.MAX_FREE_MSGS) {
      this.whatsappNudges++;
      if (this.whatsappNudges >= 2) {
        // v15: Müşterinin sorusunu geçiştirmeyelim — önce kısa cevap, sonra toparlama
        const kbResult = this.searchKB(text);
        let shortAnswer = '';
        if (kbResult) {
          const sentences = kbResult.answer.split(/(?<=[.!?])\s+/);
          shortAnswer = sentences.slice(0, 2).join(' ');
          if (kbResult.setMarket) this.detectedMarket = kbResult.setMarket;
          if (kbResult.setSuspendType) this.detectedSuspendType = kbResult.setSuspendType;
          this.detectSuspendTypeFromText(text);
        } else {
          try {
            shortAnswer = await this.callAPI(text);
            if (shortAnswer.length > 400) {
              const sentences = shortAnswer.split(/(?<=[.!?])\s+/);
              shortAnswer = sentences.slice(0, 3).join(' ');
            }
          } catch (e) { shortAnswer = ''; }
        }
        const nm = this.contactName ? `${this.contactName} Bey/Hanım, ` : '';
        const prefix = shortAnswer ? `${shortAnswer}\n\n---\n\n` : '';
        reply = `${prefix}${nm}yoğunluk sebebiyle sohbeti burada tamamlıyorum ancak konuşmamızın tüm detaylarını Orçun Bey'e ilettim — merak etmeyin. En kısa sürede sizinle iletişime geçecek.\n\n💬 WhatsApp: https://wa.me/${SS_CONFIG.PHONE}\n📞 ${SS_CONFIG.PHONE_DISPLAY}`;
        this.history.push({ role: 'user', content: text });
        this.history.push({ role: 'assistant', content: reply });
      } else {
        const kbResult = this.searchKB(text);
        reply = kbResult ? kbResult.answer : await this.callAPI(text);
        reply += `\n\nDetaylı bilgi için WhatsApp: https://wa.me/${SS_CONFIG.PHONE}`;
      }
    } else {
      // Normal akış: KB → API fallback
      const kbResult = this.searchKB(text);
      if (kbResult) {
        // v19: Eğer suspend akışındaysak VE entry'de özel suspend cevabı varsa, onu kullan
        const inSuspendFlow = (this.state === 'suspend_flow' || this.state === 'suspend_country_selected');
        if (inSuspendFlow && kbResult.answerIfSuspending) {
          reply = kbResult.answerIfSuspending;
          quickReplies = kbResult.quickRepliesIfSuspending || kbResult.quickReplies || null;
        } else {
          reply = kbResult.answer;
          quickReplies = kbResult.quickReplies || null;
        }

        // State & Lead bonus
        if (kbResult.setState) this.state = kbResult.setState;
        if (kbResult.leadBonus) this.leadScore += kbResult.leadBonus;

        // v12: Hafıza güncellemeleri
        if (kbResult.setMarket) {
          this.detectedMarket = kbResult.setMarket;
        }
        // v16: Suspend türü buton tıklamasında doğrudan tür kaydedilir
        if (kbResult.setSuspendType) {
          this.detectedSuspendType = kbResult.setSuspendType;
        }
        // Tekil ülke entry'si ama suspend akışındaysak, pazarı hatırla + state ilerlet
        if (kbResult.setMarketIfSuspending &&
            (this.state === 'suspend_flow' || this.state === 'suspend_country_selected')) {
          this.detectedMarket = kbResult.setMarketIfSuspending;
          if (this.state === 'suspend_flow') this.state = 'suspend_country_selected';
        }
        // v12: Suspend türünü de tespit et
        this.detectSuspendTypeFromText(text);

        this.history.push({ role: 'user', content: text });
        this.history.push({ role: 'assistant', content: reply });
      } else {
        reply = await this.callAPI(text);
      }
    }

    // İsim kişiselleştirmesi
    if (this.contactName && reply.startsWith('Merhaba!')) {
      reply = reply.replace('Merhaba!', `Merhaba ${this.contactName}!`);
    }

    this.hideTyping();
    this.addBot(reply);

    // Quick replies göster
    if (quickReplies) {
      setTimeout(() => this.showQuickReplies(quickReplies), 300);
    }

    // Her 3 mesajda Telegram logu
    if (this.userMsgCount > 0 && this.userMsgCount % 3 === 0) {
      this.sendTelegramLog(`ARA LOG — ${this.userMsgCount}. mesaj`);
    }

    if (this.whatsappNudges >= 2) {
      setTimeout(() => this.disableInput(), 500);
    }

    this.waiting = false;
    this.el.sendBtn.disabled = false;
    this.el.input.focus();
  },

  disableInput() {
    this.el.inputArea.style.display = 'none';
    this.el.disabledBar.style.display = 'block';
    this.sendTelegramLog('SOHBET TAMAMLANDI');
  },

  // ── Telegram mesajı bölerek gönder ──
  async sendTelegramMessage(text) {
    const MAX = 4000;
    const token = SS_CONFIG.TELEGRAM_BOT_TOKEN;
    const chatId = SS_CONFIG.TELEGRAM_CHAT_ID;
    if (token === 'YOUR_TELEGRAM_BOT_TOKEN') return;

    const chunks = [];
    let remaining = text;
    while (remaining.length > 0) {
      if (remaining.length <= MAX) { chunks.push(remaining); break; }
      // Satır sonundan kes
      let cut = remaining.lastIndexOf('\n', MAX);
      if (cut < MAX * 0.5) cut = MAX;
      chunks.push(remaining.substring(0, cut));
      remaining = remaining.substring(cut).replace(/^\n/, '');
    }

    for (let i = 0; i < chunks.length; i++) {
      const prefix = chunks.length > 1 ? `[${i+1}/${chunks.length}]\n` : '';
      await fetch(`${SS_CONFIG.WORKER_URL}/telegram`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: prefix + chunks[i] }),
      });
    }
  },

  // ── Telegram bildirim ──
  async sendTelegramLog(trigger) {
    if (SS_CONFIG.TELEGRAM_BOT_TOKEN === 'YOUR_TELEGRAM_BOT_TOKEN') return;
    try {
      const now = new Date().toLocaleString('tr-TR');
      const contactInfo = this.contactName || this.contactPhone
        ? `\n👤 İsim: ${this.contactName || '—'}\n📞 Telefon: ${this.contactPhone || '—'}`
        : '';
      const stateInfo = `\n📊 State: ${this.state} | Lead: ${this.leadScore}`
        + (this.detectedMarket ? `\n🌍 Pazar: ${this.detectedMarket}` : '')
        + (this.detectedSuspendType ? `\n⚠️ Tür: ${this.detectedSuspendType}` : '');
      const msgs = this.history.map(m =>
        `${m.role === 'user' ? '👤 Müşteri' : '🤖 Bot'}: ${m.content.substring(0, 200)}`
      ).join('\n\n');
      const text = `📋 CHATBOT — ${trigger}${SS_EN ? ' 🌐 EN' : ''}\n⏰ ${now}\n💬 ${this.userMsgCount} mesaj${contactInfo}${stateInfo}\n\n${msgs}`;
      await this.sendTelegramMessage(text);
    } catch (e) { console.log('Telegram log error:', e); }
  },
};

// ══════════════════════════════════════════════════════════
//  İNGİLİZCE MOD (v23) — /en sayfalarında sohbet İngilizce çalışır.
//  Türkçe akışa dokunulmaz: SS_EN yalnızca İngilizce sayfada true olur.
//  Bu bir çeviri katmanıdır; yeni bilgi, fiyat veya garanti eklenmez.
//  İngilizce modda yerel bilgi tabanı (Türkçe) kullanılmaz; cevapları
//  sistem komutuna dil kuralı eklenmiş Claude verir.
// ══════════════════════════════════════════════════════════
const SS_EN = String(window.SS_LANG || document.documentElement.lang || 'tr').toLowerCase().indexOf('en') === 0;

const SS_EN_SERVICE_NAMES = {
  '3_asin': 'Inauthentic Item Issues',
  'acilis': 'Opening Suspension - Seller ID Verification',
  'dropshipping': 'Drop Shipping Policy Violation',
  'fikri': 'Intellectual Property Violations',
  'hizli': 'Velocity Suspension',
  'odr': 'Order Defect Rate',
  'gec': 'Late Shipment Issues',
  'iptal': 'Order Cancellation Rate',
  'yasakli': 'Restricted Products',
  'iliskilendirme': 'Related Accounts Suspension',
  'kapali': 'Banned Category Activation',
  'tek_appeal': 'Single Appeal Service',
  'kuzey': 'North American Account Opening',
  'avrupa': 'European Account Opening',
  'gorusme': 'One-to-One Session with Orçun UYAR',
  'arama': 'Call Service',
  'saglik': 'Account Health Review',
  'fon': 'Fund Recovery Service'
};

function ssEnSysPrompt(dynCtx) {
  var trList = Object.values(SERVICES).map(function (s) { return '- ' + s.name + ' → ' + s.url; }).join('\n');
  var enList = Object.keys(SERVICES).map(function (k) {
    return '- ' + (SS_EN_SERVICE_NAMES[k] || SERVICES[k].name) + ' → ' + SERVICES[k].url.replace('suspendsupport.com.tr/products/', 'suspendsupport.com.tr/en/products/');
  }).join('\n');
  var prefix = [
    '## LANGUAGE — HIGHEST PRIORITY (overrides every other instruction below)',
    'The customer is using the ENGLISH version of the website. Reply ONLY in clear, natural, warm-but-professional English, never in Turkish, even though all the instructions and the knowledge below are written in Turkish. Everything below still applies in full (conversation philosophy, price policy, no guarantees, one question at a time, honest but hopeful tone, handing the customer over to Orçun), with these adjustments:',
    '- Ignore the Turkish-language rules (speaking Turkish, the "siz" form, "TÜRKÇE DİL KALİTESİ"). Write natural English instead.',
    '- Call the founder simply "Orçun" (never "Orçun Bey"), and never use "Bey/Hanım".',
    '- Translate Turkish terms faithfully (askıya alma = suspension, hesap = account, itiraz = appeal, süreç = process, hesap açılışı = account opening). Keep Amazon terms such as ASIN, POA, Suspend, Appeal, Inauthentic and Velocity as they are.',
    '- Use only facts that appear in the knowledge below. Do not invent prices, guarantees, statistics, timelines or promises. Never write a price: share only the service link.',
    '- Contact details: WhatsApp https://wa.me/905541716182 · phone +90 554 171 61 82 (Turkey) · info@suspendsupport.com.tr. Working hours are Turkey time (GMT+3): weekdays 09:00-18:00, 24/7 for emergencies.',
    '- If the knowledge below does not contain the answer, say so honestly and offer to pass the question to Orçun or to continue on WhatsApp.',
    '- Keep replies short (1-4 sentences for simple questions), plain text, one question at a time.',
    '',
    '- ASIN Fetcher (Chrome extension for Amazon sellers) English page: https://suspendsupport.com.tr/en/pages/suspendsupport-asin-fetcher',
    '## SERVICES — English names and English links (use these links, not the Turkish ones)',
    enList,
    '',
    ''
  ].join('\n');
  var base = SYS_PROMPT.split(trList).join('(see the English service list above)');
  return prefix + base + dynCtx;
}

var SS_EN_TYPES = {
  'Section 3': 'Section 3',
  'Hesap İncelemesi': 'Account Under Review',
  'Hesap Sağlığı': 'Account Health',
  'İptal Sorunları': 'Cancellation Issues',
  'FBA Problemleri': 'FBA Issues',
  'Ürün Orjinallik (Inauthentic)': 'Inauthentic Item',
  'Fikri Mülkiyet': 'Intellectual Property',
  'Policy Violation': 'Policy Violation',
  'Hızlı Satış (Velocity)': 'Velocity',
  'Related Accounts (İlişkilendirme)': 'Related Accounts',
  'Drop Shipping': 'Drop Shipping',
  'ODR': 'Order Defect Rate',
  'Geç Gönderim': 'Late Shipment',
  'Açılış (Seller ID Verification)': 'Seller ID Verification',
  'Forged Documents': 'Forged Documents',
  'Review Manipulation': 'Review Manipulation'
};
function ssEnType(t) { return SS_EN_TYPES[t] || t; }

var SS_EN_GREET = /^(hi|hello|hey|hiya|howdy|yo|hola|good (morning|afternoon|evening)|greetings)(\s+there)?[\s!.,]*$/i;
var SS_EN_NOT_NAME = /^(i|im|me|my|we|you|yes|no|nope|yeah|yep|ok|okay|sure|please|pls|help|hi|hello|hey|hola|thanks|thank|thx|need|want|have|has|had|am|is|are|was|do|does|did|can|could|would|should|how|what|why|when|where|who|which|the|an|and|or|but|for|with|about|from|to|in|on|at|of|account|amazon|seller|suspended|suspend|suspension|blocked|banned|locked|closed|problem|issue|issues|question|questions|price|pricing|cost|info|information|support|service|services|open|opening|appeal|not|just|here|there|its|this|that|looking|trying|having|getting|asking|wondering|calling|writing|interested|business|store|shop|listing|listings)$/i;
var SS_EN_WORD = /^[A-Za-zÀ-ÖØ-öø-ÿĞğİıŞşÇçÖöÜü'’\-]{2,20}$/;

function ssCap(s) {
  return s.replace(/(^|[\s\-'’])([a-zà-öø-ÿğışçöü])/g, function (m, a, b) { return a + b.toUpperCase(); });
}

function ssExtractNameEN(text) {
  var t = String(text || '').trim().replace(/[.!?,;:]+$/g, '');
  if (!t || t.length > 60 || /\d|@|https?:/i.test(t)) return null;
  t = t.replace(/^(hi|hello|hey|hiya|good (morning|afternoon|evening))[\s,!.]*/i, '').trim();
  if (!t) return null;
  var m = t.match(/^(?:my name is|my name's|name is|i am|i'm|im|this is|it's|its|it is|call me|they call me|you can call me)\s+(.+)$/i);
  var cand = (m ? m[1] : t).replace(/\b(here|speaking|please|thanks|thank you)\b/gi, '').trim();
  var words = cand.split(/\s+/).filter(Boolean);
  if (!words.length || words.length > 3) return null;
  for (var i = 0; i < words.length; i++) {
    if (!SS_EN_WORD.test(words[i]) || SS_EN_NOT_NAME.test(words[i])) return null;
  }
  return ssCap(words.join(' '));
}

SSchat.welcomeEN = function () {
  var h = new Date().getHours();
  var g = h >= 6 && h < 12 ? 'Good morning' : h >= 12 && h < 18 ? 'Good afternoon' : h >= 18 && h < 22 ? 'Good evening' : 'Hello';
  this.addBot(g + ', and welcome to Suspend Support! I\'m here to help with any issue you\'re having with your Amazon account.\n\nFirst, I\'d like to get to know you — may I have your name?');
  this.nameAsked = true;
};

SSchat.detectMarketEN = function (text) {
  if (this.detectedMarket) return;
  var M = [
    ['Canada', /\b(canada|canadian|amazon\.ca)\b/i],
    ['Mexico', /\b(mexico|mexican|amazon\.com\.mx)\b/i],
    ['UK', /\b(uk|u\.k\.|united kingdom|britain|british|england|amazon\.co\.uk)\b/i],
    ['Germany', /\b(germany|german|amazon\.de)\b/i],
    ['France', /\b(france|french|amazon\.fr)\b/i],
    ['Italy', /\b(italy|italian|amazon\.it)\b/i],
    ['Spain', /\b(spain|spanish|amazon\.es)\b/i],
    ['Japan', /\b(japan|japanese|amazon\.co\.jp)\b/i],
    ['Australia', /\b(australia|australian|amazon\.com\.au)\b/i],
    ['Singapore', /\b(singapore|amazon\.sg)\b/i],
    ['UAE', /\b(uae|dubai|emirates|amazon\.ae)\b/i],
    ['Saudi Arabia', /\b(saudi|amazon\.sa)\b/i],
    ['Europe', /\b(europe|european)\b/i],
    ['US', /\b(usa|u\.s\.a?\.?|united states|north america|america|american|amazon\.com)\b/i]
  ];
  for (var i = 0; i < M.length; i++) {
    if (M[i][1].test(text)) { this.detectedMarket = M[i][0]; return; }
  }
  if (/\bUS\b/.test(text)) this.detectedMarket = 'US';
};

SSchat.sendEN = async function (text) {
  var self = this;
  this.addUser(text);
  this.el.input.value = '';
  this.userMsgCount++;

  var PH = SS_CONFIG.PHONE;
  var wa = '💬 WhatsApp: https://wa.me/' + PH + '\n📞 +90 554 171 61 82';
  var nm = this.contactName ? ', ' + this.contactName : '';
  var HQR = ['How does the process work?', 'What is your success rate?', 'No, thanks'];

  // ═══ NAME ═══
  if (this.nameAsked && !this.nameCollected) {
    var name = ssExtractNameEN(text);
    if (name) {
      this.contactName = name;
      this.nameCollected = true;
      this.phoneAsked = true;
      setTimeout(function () {
        self.addBot('Nice to meet you, ' + name + '! So that we can reach you after our chat, could you share your phone number? (e.g. +90 555 123 45 67)');
      }, 400);
      return;
    }
    var greetOnly = SS_EN_GREET.test(text.trim());
    var looksLikeQuestion = !greetOnly && (text.trim().split(/\s+/).length > 3 || /\?/.test(text));
    if (looksLikeQuestion) {
      // The customer went straight to their question: skip the name step and answer it.
      this.nameCollected = true;
      this.contactName = null;
      nm = '';
    } else {
      if (greetOnly) {
        setTimeout(function () { self.addBot('Hello! I\'d love to get to know you — may I have your name?'); }, 300);
        return;
      }
      this.nameRetries = (this.nameRetries || 0) + 1;
      if (this.nameRetries >= 2) {
        this.nameCollected = true;
        this.phoneAsked = true;
        this.contactName = null;
        setTimeout(function () {
          self.addBot('No problem, we can continue without a name. So that we can reach you after our chat, could you share your phone number? (e.g. +90 555 123 45 67)');
        }, 300);
      } else {
        setTimeout(function () { self.addBot('Sorry, I didn\'t quite catch your name. Could you type just your name?'); }, 300);
      }
      return;
    }
  }

  // ═══ PHONE ═══
  if (this.phoneAsked && !this.phoneCollected) {
    var digits = text.replace(/\D/g, '');
    if (digits.length >= 10) {
      this.contactPhone = text;
      this.phoneCollected = true;
      this.sendTelegramLog('İLETİŞİM BİLGİSİ ALINDI');
      setTimeout(function () {
        self.addBot('Thank you' + (self.contactName ? ', ' + self.contactName : '') + '! We\'ve received your details. How can I help you now?');
        self.showQuickReplies(['My account is suspended', 'I want to open an account', 'Pricing', 'Talk to Orçun']);
      }, 500);
      return;
    }
    // Not a phone number: the customer wants to ask directly, so skip this step.
    this.phoneAsked = false;
  }

  // ═══ DIRECT HANDOFF: "talk to Orçun" ═══
  var wantsOrcun = /(talk|speak|chat|connect|get in touch|contact|reach|call|meet|consult)[^.?!]{0,30}(orçun|orcun|the owner|the founder|a human|real person|someone|an agent|a representative|an expert|a consultant|your team)|(orçun|orcun)[^.?!]{0,20}(please|call|contact|speak|talk|reach)|one[- ]to[- ]one|call me( back)?\b|(book|schedule|arrange)[^.?!]{0,15}(call|session|meeting)/i.test(text);
  if (wantsOrcun && !this.handoffSent) {
    this.handoffSent = true;
    this.waiting = true;
    this.el.sendBtn.disabled = true;
    this.showTyping();
    var phoneLine = this.contactPhone
      ? 'I\'ve passed your details to Orçun — he\'ll get back to you at ' + this.contactPhone + ' as soon as possible.'
      : 'I\'ve passed your details to Orçun — he\'ll get in touch with you as soon as possible.';
    var r1 = 'Of course' + nm + '. ' + phoneLine + '\n\nIf it\'s urgent, you can also write to us directly on WhatsApp:\n\n' + wa + '\n\n---\n\n**Is there anything else you\'d like to ask in the meantime?** I can briefly help with the process, pricing or other topics.';
    this.history.push({ role: 'user', content: text });
    this.history.push({ role: 'assistant', content: r1 });
    this.sendTelegramLog('DİREKT HANDOFF — "Orçun ile görüşme" talebi');
    setTimeout(function () {
      self.hideTyping();
      self.addBot(r1);
      self.showQuickReplies(HQR);
      self.waiting = false;
      self.el.sendBtn.disabled = false;
    }, 600);
    return;
  }

  // ═══ "please review my case" ═══
  var wantsReview = /(review|assess|evaluate|look into|look at)[^.?!]{0,10}\bmy (case|file)\b|\bmy (case|file)\b[^.?!]{0,10}(reviewed|assessed|evaluated)/i.test(text);
  if (wantsReview && !this.handoffSent) {
    this.handoffSent = true;
    this.waiting = true;
    this.el.sendBtn.disabled = true;
    this.showTyping();
    var phoneLine2 = this.contactPhone
      ? 'He\'ll get back to you at ' + this.contactPhone + ' as soon as possible.'
      : 'He\'ll get in touch with you as soon as possible.';
    var r2 = 'Great' + nm + '! I\'m passing your file to Orçun — he\'ll go through your situation in detail and give you a realistic roadmap. ' + phoneLine2 + '\n\nIf it\'s urgent, you can also write to us on WhatsApp:\n\n' + wa + '\n\n---\n\n**Is there anything else you\'d like to ask?**';
    this.history.push({ role: 'user', content: text });
    this.history.push({ role: 'assistant', content: r2 });
    this.sendTelegramLog('DİREKT HANDOFF — Dosya inceleme talebi');
    setTimeout(function () {
      self.hideTyping();
      self.addBot(r2);
      self.showQuickReplies(HQR);
      self.waiting = false;
      self.el.sendBtn.disabled = false;
    }, 600);
    return;
  }

  // ═══ MESSAGE LIMIT ═══
  if (this.whatsappNudges >= 2) { this.disableInput(); return; }

  this.waiting = true;
  this.el.sendBtn.disabled = true;
  this.showTyping();

  var reply = '';
  var quickReplies = null;
  try {
    this.detectMarketEN(text);
    this.detectSuspendTypeFromText(text);
    var enough = this.detectedMarket && this.detectedSuspendType;

    if (enough && this.userMsgCount >= SS_CONFIG.EARLY_HANDOFF_AT && !this.handoffSent) {
      // Early handoff: market + suspension type are known.
      this.handoffSent = true;
      reply = 'I have a good understanding of your situation' + nm + '. I\'ve noted what you\'ve described about **' + ssEnType(this.detectedSuspendType) + ' in the ' + this.detectedMarket + ' marketplace**.\n\nI\'m passing you to Orçun for a detailed review — he\'ll get in touch with you as soon as possible. Cases like this call for a strategic approach, so Orçun will evaluate the process personally.\n\nIf it\'s urgent, you can also reach us on WhatsApp:\n\n' + wa + '\n\n---\n\n**Is there anything else you\'d like to ask in the meantime?** I can briefly cover the process, pricing or other topics.';
      quickReplies = HQR;
      this.history.push({ role: 'user', content: text });
      this.history.push({ role: 'assistant', content: reply });
      this.sendTelegramLog('ERKEN HANDOFF — Pazar+Tür biliniyor (' + this.userMsgCount + '. mesaj)');
    } else if (this.handoffSent) {
      // After handoff: at most 3 more questions, then a polite goodbye.
      this.postHandoffMsgCount++;
      var MAXP = 3;
      var words = text.trim().split(/\s+/).length;
      var bye = words <= 4 && /^(no|nope|nah|none|nothing|that'?s (all|it)|thanks|thank you|thx|ok|okay|alright|got it|bye|goodbye|cheers|great|perfect|sounds good|see you)\b/i.test(text.trim());
      if (bye || this.postHandoffMsgCount > MAXP) {
        if (bye) {
          reply = 'You\'re welcome' + nm + '! I\'m glad I could help. Orçun will be in touch with you as soon as possible. Have a great day! 🙏';
        } else {
          reply = (this.contactName ? this.contactName + ', ' : '') + 'to keep things moving I\'ll wrap up our chat here. I\'ve passed all your questions to Orçun and he will answer in detail — no need to worry.\n\n' + wa;
        }
        this.history.push({ role: 'user', content: text });
        this.history.push({ role: 'assistant', content: reply });
        this.disableInput();
        this.sendTelegramLog('POST-HANDOFF KAPANIŞ (' + this.postHandoffMsgCount + '. ek soru)');
      } else {
        reply = await this.callAPI(text);
        if (this.postHandoffMsgCount >= MAXP) {
          reply += '\n\n*I can answer a few more questions, after which Orçun will take over.*';
        }
      }
    } else if (this.userMsgCount >= SS_CONFIG.HANDOFF_AT) {
      this.handoffSent = true;
      reply = 'I\'ve gathered the details' + nm + '. Orçun will get back to you as soon as he\'s available. If it\'s urgent, you can also reach us on WhatsApp:\n\n' + wa;
      this.history.push({ role: 'user', content: text });
      this.history.push({ role: 'assistant', content: reply });
      this.sendTelegramLog('HANDOFF — Orçun\'a aktarıldı (' + SS_CONFIG.HANDOFF_AT + '. mesaj)');
    } else if (this.userMsgCount === SS_CONFIG.HANDOFF_WARN_AT && !this.handoffWarned) {
      this.handoffWarned = true;
      reply = await this.callAPI(text);
      reply += '\n\n*I have a good understanding of your situation. After a few more questions I\'ll pass everything to Orçun, who will get back to you.*';
    } else {
      reply = await this.callAPI(text);
    }
  } catch (err) {
    console.error(err);
    reply = 'Sorry, something went wrong. Please try again, or write to us on WhatsApp: https://wa.me/' + PH;
  }

  this.hideTyping();
  this.addBot(reply);
  if (quickReplies) {
    setTimeout(function () { self.showQuickReplies(quickReplies); }, 300);
  }
  if (this.userMsgCount > 0 && this.userMsgCount % 3 === 0) {
    this.sendTelegramLog('ARA LOG — ' + this.userMsgCount + '. mesaj');
  }
  this.waiting = false;
  this.el.sendBtn.disabled = false;
  this.el.input.focus();
};

// Enter ile gönder
document.getElementById('ss-input').addEventListener('keydown', (e) => {
  if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); SSchat.send(); }
});

// v13: Sayfa kapanırken Telegram log — URL parametreli Beacon (JSON body yerine)
// Not: navigator.sendBeacon JSON body'i bazı tarayıcılarda multipart olarak gönderiyor
// ve Telegram API bunu reddediyor. URL param ile çalışıyor.
window.addEventListener('beforeunload', () => {
  if (SSchat.userMsgCount > 0 && SS_CONFIG.TELEGRAM_BOT_TOKEN !== 'YOUR_TELEGRAM_BOT_TOKEN') {
    const now = new Date().toLocaleString('tr-TR');
    const contactInfo = SSchat.contactName || SSchat.contactPhone
      ? `\n👤 İsim: ${SSchat.contactName || '—'}\n📞 Telefon: ${SSchat.contactPhone || '—'}`
      : '';
    const msgs = SSchat.history.map(m =>
      `${m.role === 'user' ? '👤' : '🤖'}: ${m.content.substring(0, 150)}`
    ).join('\n\n');
    const fullText = `📋 CHATBOT — Sayfa kapatıldı${SS_EN ? ' 🌐 EN' : ''}\n⏰ ${now}\n💬 ${SSchat.userMsgCount} mesaj${contactInfo}\n\n${msgs}`;
    // Telegram sendMessage GET desteğiyle — URL'de text parametresi
    // Tek parça, en fazla ~3500 karakter (URL length limiti için güvenli)
    const safeText = fullText.substring(0, 3500);
    navigator.sendBeacon(`${SS_CONFIG.WORKER_URL}/telegram`, JSON.stringify({ text: safeText }));
  }
});

// ══════════════════════════════════════════════════════════
//  OTOMATİK BELİRME (v23)
//  1) Ana sayfada, masaüstünde pencere 6 sn sonra kendiliğinden açılır (oturumda 1 kez — eski davranış).
//  2) Tüm sayfalarda (mobil dahil) sohbet düğmesinin üstünde küçük bir davet balonu ARA SIRA görünür:
//     oturumda en fazla 2 kez, iki gösterim arası en az 4 dk, balon kapatılırsa 24 saat çıkmaz,
//     sohbet açıldıysa veya mesaj yazıldıysa çıkmaz.
//  3) Sepet, ödeme, hesap, sipariş, fatura ve politika sayfalarında sohbet hiç görünmez.
// ══════════════════════════════════════════════════════════
(function () {
  var sc = document.getElementById('ss-chatbot-scope');
  var path = location.pathname;
  var off = /(^|\/)(cart|checkouts?|account|orders|invoices|policies)(\/|$)/i.test(path);
  if (off) { if (sc) sc.style.display = 'none'; return; }
  if (!sc) return;

  var ses = null, loc = null;
  try { ses = window.sessionStorage; } catch (e) {}
  try { loc = window.localStorage; } catch (e) {}
  function sGet(s, k) { try { return s.getItem(k); } catch (e) { return null; } }
  function sSet(s, k, v) { try { s.setItem(k, v); } catch (e) {} }

  var nudgeEl = null, hideTimer = null;
  function hideNudge() {
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    var el = nudgeEl;
    if (!el) return;
    nudgeEl = null;
    el.classList.remove('ss-in');
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 400);
  }

  // Sohbet bir kez açıldıysa bu oturumda balon bir daha çıkmasın; açılırken balon kapansın.
  var origToggle = SSchat.toggle;
  SSchat.toggle = function () {
    if (!this.isOpen) { sSet(ses, 'ss_chat_used', '1'); hideNudge(); }
    return origToggle.apply(this, arguments);
  };

  var desktop = window.innerWidth >= 1024;
  var home = /^\/([a-z]{2}(-[a-z]{2})?\/?)?$/i.test(path);

  // 1) Eski davranış: ana sayfa + masaüstü → pencere 6 sn sonra açılır
  if (desktop && home && sGet(ses, 'ss_auto') !== '1') {
    setTimeout(function () {
      if (!SSchat.isOpen) {
        SSchat.toggle();
        sSet(ses, 'ss_auto', '1');
        sSet(ses, 'ss_nudge_n', '2');
        sSet(loc, 'ss_nudge_ts', String(Date.now()));
      }
    }, 6000);
    return;
  }

  // 2) Davet balonu
  var now = Date.now();
  var n = parseInt(sGet(ses, 'ss_nudge_n') || '0', 10) || 0;
  var last = parseInt(sGet(loc, 'ss_nudge_ts') || '0', 10) || 0;
  var offUntil = parseInt(sGet(loc, 'ss_nudge_off') || '0', 10) || 0;
  if (sGet(ses, 'ss_chat_used') === '1' || n >= 2 || now < offUntil || now - last < 4 * 60 * 1000) return;

  var MSG = SS_EN
    ? ['Hi! Have a question about your Amazon account?', 'Need a hand? We\'re here 👋', 'Is your Amazon account suspended? Ask us, we can point you in the right direction.']
    : ['Merhaba! Amazon hesabınızla ilgili bir sorunuz mu var?', 'Yardıma mı ihtiyacınız var? Buradayız 👋', 'Amazon hesabınız mı askıya alındı? Bize sorun, yol göstermeye çalışalım.'];
  var CLOSE = SS_EN ? 'Close' : 'Kapat';
  var OPEN = SS_EN ? 'Open chat' : 'Sohbeti aç';
  var tries = 0;

  function showNudge() {
    if (nudgeEl || SSchat.isOpen || SSchat.userMsgCount > 0 || sGet(ses, 'ss_chat_used') === '1') return;
    if (document.visibilityState !== 'visible') {
      if (++tries < 8) setTimeout(showNudge, 5000);
      return;
    }
    var css = [
      '#ss-nudge{position:fixed;right:24px;bottom:96px;max-width:268px;z-index:99997;display:flex;align-items:flex-start;',
      'background:#ffffff !important;color:#0a1628 !important;border-radius:16px;font-family:var(--ss-font,"Outfit",-apple-system,BlinkMacSystemFont,sans-serif);',
      'box-shadow:0 10px 36px rgba(10,22,40,.22),0 0 0 1px rgba(37,99,235,.10);opacity:0;transform:translateY(8px) scale(.96);',
      'transition:opacity .35s ease,transform .35s ease;}',
      '#ss-nudge.ss-in{opacity:1;transform:none;}',
      '#ss-nudge:after{content:"";position:absolute;right:26px;bottom:-7px;width:14px;height:14px;background:#ffffff;transform:rotate(45deg);box-shadow:3px 3px 6px rgba(10,22,40,.08);}',
      '#ss-nudge .ss-nudge-text{flex:1;background:none !important;border:0;cursor:pointer;text-align:left;font:inherit;font-size:14px;line-height:1.45;color:#0a1628 !important;padding:12px 4px 12px 14px;}',
      '#ss-nudge .ss-nudge-x{background:none !important;border:0;cursor:pointer;font:inherit;font-size:20px;line-height:1;color:#64748b !important;padding:8px 10px;border-radius:50%;}',
      '#ss-nudge .ss-nudge-x:hover{color:#0a1628 !important;}',
      '@media (max-width:480px){#ss-nudge{right:16px;bottom:84px;max-width:calc(100vw - 32px);}#ss-nudge:after{right:22px;}}',
      '@media (prefers-reduced-motion:reduce){#ss-nudge{transition:none;}}'
    ].join('');
    if (!document.getElementById('ss-nudge-css')) {
      var st = document.createElement('style');
      st.id = 'ss-nudge-css';
      st.textContent = css;
      document.head.appendChild(st);
    }
    var el = document.createElement('div');
    el.id = 'ss-nudge';
    el.setAttribute('role', 'status');
    var tx = document.createElement('button');
    tx.type = 'button';
    tx.className = 'ss-nudge-text';
    tx.setAttribute('aria-label', OPEN + ': ' + MSG[n % MSG.length]);
    tx.textContent = MSG[n % MSG.length];
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'ss-nudge-x';
    x.setAttribute('aria-label', CLOSE);
    x.textContent = '×';
    el.appendChild(tx);
    el.appendChild(x);
    sc.appendChild(el);
    nudgeEl = el;
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('ss-in'); }); });

    tx.addEventListener('click', function () { if (!SSchat.isOpen) SSchat.toggle(); hideNudge(); });
    x.addEventListener('click', function () {
      sSet(loc, 'ss_nudge_off', String(Date.now() + 24 * 60 * 60 * 1000));
      hideNudge();
    });
    sSet(ses, 'ss_nudge_n', String(n + 1));
    sSet(loc, 'ss_nudge_ts', String(Date.now()));
    hideTimer = setTimeout(hideNudge, 14000);
  }

  setTimeout(showNudge, desktop ? 10000 : 14000);
})();
